<template>
  <v-container class="py-0 py-sm-8 px-0 px-sm-4">
    <v-row no-gutters>
      <v-col v-if="dataSelected.length" cols="12" class="col-sm-1">
        <v-card class="d-flex align-center font-weight-bold justify-center pa-4 fill-width fill-height orange darken-1" dark outlined @click.prevent="MANIFEST_SHOW()">
          <v-icon small class="mr-0">
            mdi-plus
          </v-icon>
          <span class="d-lg-block text-h6 font-weight-bold">{{ dataSelected.length }}</span>
        </v-card>
      </v-col>
      <v-col v-if="!(dataSelected.length)" cols="4" class="col-sm-1">
        <v-card class="d-flex align-center font-weight-bold justify-center pa-4 fill-width fill-height primary" dark outlined @click.prevent="SHIPPING_SHOW()">
          <v-icon small class="mr-0 mr-lg-2">
            mdi-plus
          </v-icon>
          <span class="d-none d-lg-block">Create</span>
        </v-card>
      </v-col>
      <v-col v-if="!(dataSelected.length) && $role(['manager'], $store.state.user.role)" cols="4" class="col-sm-1">
        <v-card class="d-flex align-center font-weight-bold justify-center pa-4 fill-width fill-height black" dark outlined @click.prevent="MANIFEST_DATA_SHOW()">
          <v-icon small class="mr-0 mr-lg-2">
            mdi-package
          </v-icon>
          <span class="d-none d-lg-block">Manifest</span>
        </v-card>
      </v-col>
      <v-col v-if="!(dataSelected.length)" cols="4" class="col-sm-1">
        <v-card class="d-flex align-center font-weight-bold justify-center pa-4 fill-width fill-height secondary" dark outlined @click.prevent="businessProjectShow = true">
          <v-icon small class="mr-0 mr-lg-2">
            mdi-handshake
          </v-icon>
          <span class="d-none d-lg-block">Business</span>
        </v-card>
      </v-col>
      <v-col cols="12" :class="[tableSearchSwitch ? 'col-sm-5' : 'col-sm-8']" class="white">
        <div class="d-flex flex-column flex-sm-row align-center pl-4 pl-sm-8 pr-4 pr-sm-8 pt-4 pb-0 pb-sm-3">
          <div class="d-flex align-center pr-4 pb-4 pb-sm-0">
            <div
              :class="[!tableSearchSwitch ? 'primary white--text' : 'grey--text text--darken-1 grey lighten-2']"
              class="c-pointer py-4 px-4 rounded-l-lg text-center"
              style="width: 100px;"
              @click.prevent="tableSearchSwitch = 0"
            >
              INTERNAL
            </div>
            <div
              :class="[tableSearchSwitch === 99 ? 'primary white--text' : 'grey--text text--darken-1 grey lighten-2']"
              class="c-pointer py-4 px-4 text-center"
              style="width: 45px;"
              @click.prevent="tableSearchSwitch = 99"
            >
              <v-icon :color="tableSearchSwitch === 99 ? 'orange' : 'white'" small>
                mdi-alert-outline
              </v-icon>
            </div>
            <div
              :class="[tableSearchSwitch === 1 ? 'primary white--text' : 'grey--text text--darken-1 grey lighten-2']"
              class="c-pointer py-4 px-4 text-center"
              style="width: 45px;"
              @click.prevent="tableSearchSwitch = 1"
            >
              <v-icon :color="tableSearchSwitch === 1 ? 'red' : 'white'" small>
                mdi-alert-octagram
              </v-icon>
            </div>
            <div
              :class="[tableSearchSwitch === 2 ? 'primary white--text' : 'grey--text text--darken-1 grey lighten-2']"
              class="c-pointer py-4 px-4 rounded-r-lg text-center"
              style="width: 100px;"
              @click.prevent="tableSearchSwitch = 2"
            >
              SEMUA
            </div>
          </div>
          <v-text-field
            v-model="tableSearch"
            outlined
            hide-details
            class="fill-width"
            clearable
            :placeholder="tableSearchSwitch ? 'Lacak kiriman . . .' : 'Lacak Kiriman Internal Cabang . . .'"
            prepend-inner-icon="mdi-magnify"
          />
        </div>
      </v-col>
      <v-col v-if="tableSearchSwitch" cols="12" class="col-sm-3 white pt-4 pb-4 pb-sm-0 pr-4 pl-4 pl-sm-0">
        <v-autocomplete
          v-model.number="tableSearchStore"
          :disabled="!$role(['manager'], $store.state.user.role)"
          :items="[{ id: -1, name: 'Semua Cabang' }].concat($store.state.storeData).filter(r => !parseInt(r.type))"
          item-text="name"
          item-value="id"
          outlined
          hide-details
          class=""
          label="Filter Cabang"
        />
      </v-col>
      <v-col cols="12" class="py-4">
        <div class="pb-4">
          <v-row align="center">
            <v-col cols="12" class="col-sm-4">
              <div class="d-flex align-center fill-width">
                <div v-if="dataSelected.length" class="pr-2">
                  <v-chip class="c-pointer" size="x-small" dark color="red" @click.prevent="dataSelected = []">
                    Clear Selected
                  </v-chip>
                </div>
                <v-icon class="mr-2">
                  mdi-table
                </v-icon>
                <span v-if="tableSearchSwitch === 99">TTK TERLAMBAT</span>
                <span v-else-if="tableSearchSwitch === 2">SEMUA TTK</span>
                <span v-else-if="tableSearchSwitch === 1">TTK INVESTIGASI / BERMASALAH</span>
                <div v-else>
                  <v-autocomplete
                    v-if="$role(['manager'], $store.state.user.role)"
                    v-model.number="tableSearchStore"
                    :items="($store.state.storeData || []).filter(r => !parseInt(r.type))"
                    item-text="name"
                    item-value="id"
                    outlined
                    dense
                    hide-details
                    label="Bypass Cabang"
                  />
                  <span v-else>
                    TTK INTERNAL CABANG
                  </span>
                </div>
              </div>
            </v-col>
            <v-col cols="12" class="col-sm-4 d-flex align-center justify-center">
              <v-menu
                ref="menu"
                v-model="menu"
                :return-value.sync="dates"
                left
                offset-y
                :close-on-content-click="false"
                min-width="auto"
              >
                <template v-slot:activator="{ on, attrs }">
                  <v-text-field
                    :value="dateRangeText"
                    label="Date Ranges"
                    append-icon="mdi-calendar-outline"
                    readonly
                    outlined
                    dense
                    clearable
                    hide-details
                    v-bind="attrs"
                    v-on="on"
                    @click:clear="dates = [], SHIPPING_GET(tableSearch)"
                  />
                </template>
                <v-date-picker
                  v-model="dates"
                  no-title
                  light
                  class="force-light-font"
                  range
                >
                  <v-spacer />
                  <v-btn
                    text
                    class="text-capitalize"
                    small
                    @click="menu = false"
                  >
                    Cancel
                  </v-btn>
                  <v-btn
                    text
                    class="text-capitalize"
                    small
                    @click="$refs.menu.save(dates), (dates.length === 2 ? SHIPPING_GET() : '')"
                  >
                    Ok
                  </v-btn>
                </v-date-picker>
              </v-menu>
            </v-col>
            <v-col cols="6" class="col-sm-1 d-flex align-center justify-center">
              <!-- <v-btn depressed color="blue" dark block small class="text-capitalize" @click.prevent="DOWNLOAD_TTK()">
                Download
              </v-btn> -->
              <v-btn class="rounded-pill" depressed color="primary" @click.prevent="pickupScan.show = !pickupScan.show">
                <v-icon class="mr-2">
                  mdi-barcode
                </v-icon>
                PICKUP
              </v-btn>
              <div v-if="pickupScan.show" class="d-flex justify-center align-center px-4" style="max-width:100%;position:fixed;top:0px;left:0px;width:100vw;height:100vh;z-index:10000;background-color:rgba(0, 0, 0, .7);" @click="pickupScan.show = false">
                <div class="" style="position:relative;border-radius:16px;overflow:hidden;">
                  <div v-if="pickupScan.loading" style="position:absolute;width:100%;height:100%;z-index:1;color:#999;font-size:16px;background-color:rgba(0, 0, 0, .5);" class="d-flex align-center justify-center pa-4 text-center">
                    processing ...
                  </div>
                  <StreamBarcodeReader
                    @decode="onDecodeScanner"
                    @loaded="onLoadedScanner"
                  />
                </div>
              </div>
            </v-col>
            <v-col cols="6" class="col-sm-1 d-flex align-center justify-center">
              <XlsxAwbImport @reload="SHIPPING_GET(tableSearch)" />
            </v-col>
            <v-col cols="12" class="col-sm-4">
              <div class="d-flex align-center justify-end fill-width">
                <v-btn
                  v-if="false"
                  :loading="loadingDownload"
                  :depressed="loadingDownload"
                  class="rounded-pill text-capitalize mr-4"
                  color="primary"
                  dark
                  small
                  @click.prevent="SHIPPING_GET(tableSearch, [])"
                >
                <!-- :loading="$store.state.dialogPrint.runnerActive"
                  :depressed="!$store.state.dialogPrint.runnerActive" -->
                <!-- @click.prevent="$store.state.dialogPrint.runnerActive ? DOWNLOAD_RUNNER_FORCE_STOP() : SHIPPING_GET_TEMP()" -->
                  Download All
                  <template v-slot:loader>
                    <div class="d-flex fill-width mx-4">
                      <v-progress-linear
                        :value="((tableTempCounter * 100) / (tableTemp.length))"
                        height="10"
                        dark
                        color="green darken-1"
                        class="rounded-lg fill-width"
                        style="min-width:100px;"
                      >
                        <template v-slot:default="{ value }">
                          <div class="d-flex align-center text-caption py-1">
                            <small class="font-weight-bold mr-1">{{ tableTempCounter }}/{{ tableTemp.length }} ({{ value.toFixed(1) }}%)</small>
                          </div>
                        </template>
                      </v-progress-linear>
                    </div>
                  </template>
                </v-btn>
                <!-- <v-btn depressed class="rounded-pill text-capitalize" color="orange darken-2" dark small @click.prevent="dialogPickup.show = true">
                  <strong>({{ dialogPickup.total }})</strong> Pickup Request
                </v-btn> -->
              </div>
            </v-col>
          </v-row>
        </div>
        <!-- :items="tableSearchSwitch ? table : filteredTable" -->
        <v-data-table
          v-model="dataSelected"
          :headers="headers"
          :items="table"
          item-key="id"
          :server-items-length="tableTotal"
          :page.sync="tablePage"
          :items-per-page.sync="tableLimit"
          :options.sync="options"
          :footer-props="{
            itemsPerPageOptions: [25, 50, 100]
          }"
          :single-select="false"
          :loading="tableLoading"
          :show-select="!tableSearchSwitch"
          loading-text="Loading... Please wait"
        >
          <template v-slot:[`item.data-table-select`]="{ isSelected, select }">
            <div>
              <v-simple-checkbox
                :value="isSelected"
                :ripple="false"
                v-on:input="select"
              />
            </div>
          </template>
          <template v-slot:[`item.ttk`]="{ item }">
            <div class="py-2">
              <div class="d-flex align-center text-uppercase">
                <v-icon class="mr-1">
                  mdi-barcode
                </v-icon>
                <!-- <barcode v-if="item.ttk" :value="item.ttk">
                  -
                </barcode> -->
                <span class="font-weight-bold caption">
                  {{ item.ttk || '-' }}
                </span>
              </div>
              <div class="d-flex align-center caption">
                <v-icon small class="mr-1">
                  mdi-calendar-clock
                </v-icon>
                {{ $localDT(item.created, 'datetimedefault') }}
              </div>
              <div class="d-flex align-center caption secondary--text text-uppercase font-weight-bold">
                <v-icon small class="mr-1" color="secondary">
                  mdi-package
                </v-icon>
                {{ item.product_name || '-' }}
                <!-- {{ item.sales_detail || '-' }} -->
              </div>
              <div class="d-flex align-center caption orange--text font-weight-bold">
                <v-icon small class="mr-1" color="orange">
                  mdi-information
                </v-icon>
                {{ item.weight_chargeable || '~' }}KG, {{ item.shipping_package_quantity_sum }} {{ (parseInt(item.product_is_unit) ? 'UNIT' : 'ITEMS') }} in {{ item.shipping_package_quantity }} PKG
              </div>
              <div class="d-flex align-center caption secondary--text text-uppercase font-weight-bold">
                <v-icon small class="mr-1" color="primary">
                  mdi-truck-fast
                </v-icon>
                {{ item.vendor_name || '-' }} &sdot; {{ item.vendor_awb || '-' }}
                <!-- {{ item.sales_detail || '-' }} -->
              </div>
            </div>
          </template>
          <template v-slot:[`item.shipping_sender_name`]="{ item }">
            <div class="d-flex flex-column py-2">
              <div class="d-flex align-center">
                {{ item.shipping_sender_name || '-' }}
                <v-icon class="mx-1" small>
                  mdi-chevron-right
                </v-icon>
                {{ item.shipping_name || '-' }}
              </div>
              <div class="caption">
                Bill To : {{ item.customer_billto_detail || '-' }}
              </div>
            </div>
          </template>
          <template v-slot:[`item.price_final`]="{ item }">
            <div v-if="item.master_count_type === 'UNIT'" class="d-flex justify-end py-2">
              {{ $price(m.master_price_final) }} (1 UNIT)
            </div>
            <div v-else class="d-flex flex-column align-end py-2">
              {{ $price(item.price_final) }}
              <div>
                {{ parseInt(item.product_is_unit) ? '[UNIT]' : ('[' + item.weight_chargeable + ' KG]') }}
                <!-- {{ parseInt(item.product_is_unit) ? '[UNIT]' : ('[' + $countShippingWeight(item) + ' KG]') }} -->
              </div>
            </div>
          </template>
          <template v-slot:[`item.shipping_origin_city_name`]="{ item }">
            <div class="d-flex align-center py-2">
              {{ item.shipping_origin_fullname || item.shipping_origin_city_name }} <span v-if="!item.shipping_origin_fullname">{{ item.shipping_origin_city_type }}</span>
              <v-icon class="mx-1" small>
                mdi-chevron-right
              </v-icon>
              {{ item.shipping_destination_fullname || item.shipping_destination_city_name }} <span v-if="!item.shipping_destination_fullname">{{ item.shipping_destination_city_type }}</span>
            </div>
          </template>
          <template v-slot:[`item.amount_paid`]="{ item }">
            <div style="min-width: 175px;">
              <div v-if="parseInt(item.pickup_id)" class="d-flex align-center font-weight-bold teal--text caption">
                <v-icon class="mr-1" small color="teal">
                  mdi-account-cash
                </v-icon>
                Pickup : {{ $price(item.amount_pickup) }}
              </div>
              <div v-else class="d-flex align-center font-weight-bold grey--text caption">
                <v-icon class="mr-1" small color="grey">
                  mdi-account-cash
                </v-icon>
                Onsite : {{ $price(item.price_final) }}
              </div>
              <div class="d-flex align-center pt-2 pb-1 justify-space-between">
                <div class="d-flex align-center">
                  <span class="mr-1">PAID :</span>
                  <v-icon v-if="parseInt(item.pickup_id)" :color="parseInt(item.amount_pickup) > parseInt(item.amount_paid) ? 'red' : 'blue'" class="mr-1" small>
                    {{ parseInt(item.amount_pickup) > parseInt(item.amount_paid) ? 'mdi-cash-remove' : 'mdi-cash-check' }}
                  </v-icon>
                  <v-icon v-else :color="parseInt(item.price_final) > parseInt(item.amount_paid) ? 'red' : 'blue'" class="mr-1" small>
                    {{ parseInt(item.price_final) > parseInt(item.amount_paid) ? 'mdi-cash-remove' : 'mdi-cash-check' }}
                  </v-icon>
                  {{ $price(item.amount_paid) }}
                </div>
                <!-- <div class="pl-2">
                  <v-btn color="brown" depressed class="text-capitalize" x-small dark @click.prevent="PaymentGetShow(item)">
                    <v-icon class="mr-1" small>
                      mdi-cash
                    </v-icon>
                    Payment
                  </v-btn>
                </div> -->
              </div>
              <div class="d-flex align-center font-weight-bold indigo--text caption">
                Payment Option: {{ item.payment_option || '-' }}
              </div>
            </div>
          </template>
          <template v-slot:[`item.id_generated`]="{ item }">
            <div class="d-flex flex-column py-2">
              {{ item.id_generated }}
            </div>
          </template>
          <template v-slot:[`item.status`]="{ item }">
            <div v-if="!parseInt(item.old_data)">
              <div v-if="parseInt(item.pickup_handling_status)">
                <TrackStatus :item="item" @reload="SHIPPING_GET(tableSearch)" />
              </div>
              <div v-else-if="parseInt(item.pickup_handling)">
                {{ item.pickup_detail ? 'REGISTERED' : 'READY TO SHIP' }}
                <div v-if="item.pickup_detail">
                  {{ item.pickup_detail }}
                </div>
              </div>
              <div v-else>
                READY TO SHIP
              </div>
              <v-divider class="my-1" />
              <div v-if="parseInt(item.est_to)" class="d-flex align-center justify-space-between fill-width" style="min-width: 200px;">
                Est: {{ item.est_to }}hari
                <v-chip v-if="parseInt(item.delivered_late)" dark color="red" x-small>
                  Terlambat
                </v-chip>
              </div>
            </div>
            <div v-else class="red--text">
              ANTERO DATA
            </div>
          </template>
          <template v-slot:[`item.option`]="{ item }">
            <div class="d-flex align-center" style="min-width: 100px;">
              <v-btn v-if="$role(['manager'], $store.state.user.role) && !parseInt(item.old_data)" depressed small dark color="purple" class="text-capitalize mr-2" @click.prevent="PLAN_SHOW(item)">
                <v-icon small class="mr-1">
                  mdi-format-list-checkbox
                </v-icon>
                Tracking
              </v-btn>
              <v-btn v-if="!tableSearchSwitch && !parseInt(item.old_data)" depressed small dark color="orange" class="text-capitalize" @click.prevent="SHIPPING_SHOW(item)">
                <v-icon small class="mr-1">
                  mdi-information-outline
                </v-icon>
                Detail
              </v-btn>
              <v-btn depressed small dark color="indigo" class="text-capitalize ml-2" @click.prevent="PRINT(item)">
                <v-icon small class="mr-1">
                  mdi-printer
                </v-icon>
                Print
              </v-btn>
              <!-- <v-btn :loading="$store.state.dialogPrint.show" icon small dark color="secondary" class="text-capitalize ml-2" @click.prevent="$store.commit('DIALOG_PRINT_PROCESS', { show: true, data: item })"> -->
              <v-btn :loading="loadingDownload" icon small dark color="secondary" class="text-capitalize ml-2" @click.prevent="SHIPPING_GET(tableSearch, [parseInt(item.id)])">
                <v-icon>
                  mdi-download
                </v-icon>
              </v-btn>
            </div>
          </template>
          <!-- <template v-slot:footer>
            <div class="pt-2 pb-2 px-4 px-md-8 white fill-width">
              <v-divider class="mt-2 mb-3" />
              <div class="d-flex justify-end flex-column flex-sm-row">
                <div class="d-flex align-center font-weight-bold">
                  Summary Price : {{ $price(summaryPrice) }}
                </div>
              </div>
            </div>
          </template> -->
        </v-data-table>
      </v-col>
    </v-row>
    <v-dialog
      v-model="dialogShipping.show"
      fullscreen
      hide-overlay
      transition="dialog-bottom-transition"
    >
      <v-card v-if="dialogShipping.data" flat class="rounded-0 elevation-0">
        <v-toolbar
          dark
          color="primary"
        >
          <v-toolbar-title>{{ parseInt(dialogShipping.data.id) ? 'DETAIL TTK' : 'BUAT TTK BARU' }}</v-toolbar-title>
          <v-spacer />
          <v-toolbar-items>
            <v-btn
              dark
              text
              @click="dialogShipping.show = false"
            >
              <v-icon>
                mdi-close
              </v-icon>
            </v-btn>
          </v-toolbar-items>
        </v-toolbar>
        <div style="max-height: calc(100vh - 64px);overflow-y: auto;">
          <v-container class="pt-6 white px-0">
            <div class="mx-auto grey lighten-4 px-6 rounded-lg px-sm-8 py-sm-8" style="max-width: 1000px;">
              <v-row>
                <v-col cols="12" class="">
                  <div class="font-weight-bold text-center">
                    - PILIH PRODUK -
                    <v-row class="pt-4" justify="center">
                      <v-col v-for="(p, iP) in productData.filter(r => parseInt(r.id) === (parseInt(dialogShipping.data.id) ? parseInt(dialogShipping.data.product) : parseInt(r.id)))" :key="'product-item-' + iP" cols="6" class="col-sm-3">
                        <v-card :class="[parseInt(dialogShipping.data.product) ===  parseInt(p.id) ? 'primary white--text' : 'grey lighten-3 grey--text']" outlined class="d-flex flex-column align-center justify-center px-2 py-2 text-subtitle-2 rounded-lg fill-width c-pointer" @click.prevent="parseInt(dialogShipping.data.id) ? '' : (dialogShipping.data.price = 0, dialogShipping.data.price_id = 0, dialogShipping.data.product = parseInt(p.id))">
                          <strong class="text-uppercase">{{ p.name }}</strong>
                          <div class="caption text-caption">
                            {{ parseInt(p.is_unit) ? 'UNIT' : 'KG' }} - {{ p.type }}
                          </div>
                        </v-card>
                      </v-col>
                    </v-row>
                  </div>
                </v-col>
                <v-col cols="12">
                  <v-divider />
                </v-col>
                <v-col cols="6" class="col-sm-8">
                  <v-autocomplete
                    v-model.number="dialogShipping.data.customer_billto"
                    :disabled="parseInt(dialogShipping.data.id) ? true : false"
                    :name="Math.random()"
                    :search-input.sync="dataBilltoQuery"
                    :items="dataBillto"
                    item-value="id"
                    item-text="customer_detail"
                    solo
                    flat
                    dense
                    hide-details
                    color="white"
                    label="- Bill To -"
                    clearable
                    class="mb-0"
                    autocomplete="disabled"
                    @change="ReloadCustomer(2)"
                  />
                </v-col>
                <v-col cols="6" class="col-sm-4">
                  <v-btn class="text-caption font-weight-bold" block depressed color="secondary" @click.prevent="CUSTOMER_SHOW()">
                    Add New Customer
                  </v-btn>
                </v-col>
                <v-col cols="12" class="col-sm-6">
                  <v-autocomplete
                    v-model.number="dialogShipping.data.customer"
                    :disabled="parseInt(dialogShipping.data.id) ? true : false"
                    :name="Math.random()"
                    :search-input.sync="dataCustomerQuery"
                    :items="dataCustomer"
                    item-value="id"
                    item-text="customer_detail"
                    outlined
                    dense
                    hide-details
                    label="- Cari Pengirim -"
                    clearable
                    class="mb-4"
                    autocomplete="disabled"
                    @change="ReloadCustomer()"
                  />
                  <v-divider class="mb-5 mt-5" />
                  <v-text-field
                    v-model="dialogShipping.data.shipping_sender_name"
                    :disabled="parseInt(dialogShipping.data.id) ? true : false"
                    :name="Math.random()"
                    outlined
                    dense
                    hide-details
                    class="mb-4"
                    label="Nama Pengirim"
                  />
                  <v-text-field
                    v-model="dialogShipping.data.shipping_sender_phone"
                    :disabled="parseInt(dialogShipping.data.id) ? true : false"
                    :name="Math.random()"
                    outlined
                    dense
                    hide-details
                    class="mb-4"
                    label="No Telepon Pengirim"
                  />
                  <v-textarea
                    v-model="dialogShipping.data.shipping_sender_address"
                    :name="Math.random()"
                    :disabled="parseInt(dialogShipping.data.id) ? true : false"
                    rows="3"
                    outlined
                    dense
                    hide-details
                    class="mb-4"
                    label="Alamat Lengkap Asal Kiriman"
                  />
                  <v-autocomplete
                    v-model.number="dialogShipping.data.shipping_origin_kec"
                    :name="Math.random()"
                    :disabled="parseInt(dialogShipping.data.id) ? true : false"
                    :search-input.sync="shippingOriginQuery"
                    :items="shippingOriginData"
                    item-value="kecamatan_id"
                    item-text="fullname"
                    outlined
                    dense
                    hide-details
                    clearable
                    label="Asal Pengiriman"
                    autocomplete="disabled"
                    @change="PRICING_GET()"
                  />
                </v-col>
                <v-col cols="12" class="col-sm-6 pa-3 pa-sm-0" align="center">
                  <v-row class="py-2" no-gutters>
                    <v-col cols="6">
                      <v-btn-toggle
                        v-model="isProjectBased.v"
                        block
                        class="fill-width"
                        color="secondary"
                        dense
                        group
                      >
                        <v-btn :value="false" class="rounded">
                          Default
                        </v-btn>
                        <v-btn :value="true" class="rounded">
                          Project
                        </v-btn>
                      </v-btn-toggle>
                    </v-col>
                    <v-col v-if="isProjectBased.v" cols="6">
                      <xlsx-import @result="ImportData" />
                    </v-col>
                    <v-col v-else cols="6" class="d-flex align-center">
                      <v-autocomplete
                        v-model.number="dialogShipping.data.recipient"
                        :name="Math.random()"
                        :disabled="parseInt(dialogShipping.data.id) ? true : false"
                        :search-input.sync="dataRecipientQuery"
                        :items="dataRecipient"
                        item-value="id"
                        item-text="customer_detail"
                        outlined
                        dense
                        hide-details
                        label="- Cari Penerima -"
                        clearable
                        autocomplete="disabled"
                        @change="ReloadCustomer(1)"
                      />
                    </v-col>
                    <v-col v-if="isProjectBased.v" cols="12">
                      <v-divider class="mt-5 mb-5" />
                      <div class="d-flex align-center justify-space-between fill-width">
                        <v-autocomplete
                          v-model.number="dialogShipping.data.project"
                          :name="Math.random()"
                          :search-input.sync="dataProjectQuery"
                          :items="dataProject"
                          item-value="id"
                          item-text="name"
                          outlined
                          dense
                          hide-details
                          label="Select Project"
                          clearable
                          class="mb-0"
                          autocomplete="disabled"
                          @change="UpdateCustomerBillTo()"
                        >
                          <template v-slot:item="{ item }">
                            <v-list-item-content>
                              <v-list-item-title class="flex-column">
                                <div class="d-flex align-center">
                                  {{ item.name || '-' }}
                                </div>
                              </v-list-item-title>
                            </v-list-item-content>
                            <v-list-item-action v-if="item.customer_detail">
                              <v-chip x-small>
                                <v-icon x-small color="primary" class="mr-1">
                                  mdi-account
                                </v-icon>
                                {{ item.customer_detail }}
                              </v-chip>
                            </v-list-item-action>
                          </template>
                        </v-autocomplete>
                        <div class="d-flex align-center pl-2">
                          <v-btn icon small class="ma-1" @click.prevent="PROJECT_SHOW()">
                            <v-icon>
                              mdi-plus
                            </v-icon>
                          </v-btn>
                          <v-btn :disabled="parseInt(dialogShipping.data.project) ? false : true" icon x-small color="blue" class="ma-1" @click.prevent="PROJECT_SHOW(dialogShipping.data.project)">
                            <v-icon>
                              mdi-pencil
                            </v-icon>
                          </v-btn>
                          <!-- <v-btn :disabled="parseInt(dialogShipping.data.project) ? false : true" icon x-small color="red" class="ma-1">
                            <v-icon>
                              mdi-delete
                            </v-icon>
                          </v-btn> -->
                        </div>
                      </div>
                      <div class="d-flex align-center justify-space-between fill-width pt-4">
                        <v-text-field
                          v-model="dialogShipping.data.initialTTK"
                          :name="Math.random()"
                          outlined
                          dense
                          hide-details
                          label="Initial TTK Code"
                          class="mb-0 text-right"
                          autocomplete="disabled"
                          suffix="AUTO GENERATED ID"
                        />
                      </div>
                    </v-col>
                  </v-row>
                  <v-divider class="mt-3 mb-5" />
                  <div v-if="isProjectBased.v">
                    <v-card v-for="(s, iS) in isProjectBased.sheets" :key="'sheet-' + iS" class="pa-2 my-1 text-caption d-flex fill-width rounded font-weight-bold justify-center" outlined>
                      {{ iS }} ({{ s.length }} ROW(S))
                    </v-card>
                  </div>
                  <div v-else>
                    <v-text-field
                      v-model="dialogShipping.data.shipping_name"
                      :name="Math.random()"
                      :disabled="parseInt(dialogShipping.data.id) ? true : false"
                      outlined
                      dense
                      hide-details
                      class="mb-4"
                      label="Nama Penerima"
                    />
                    <v-text-field
                      v-model="dialogShipping.data.shipping_phone"
                      :name="Math.random()"
                      :disabled="parseInt(dialogShipping.data.id) ? true : false"
                      outlined
                      dense
                      hide-details
                      class="mb-4"
                      label="No Telepon Penerima"
                      @keypress="$NumOnly"
                    />
                    <v-textarea
                      v-model="dialogShipping.data.shipping_address"
                      :name="Math.random()"
                      :disabled="parseInt(dialogShipping.data.id) ? true : false"
                      rows="3"
                      outlined
                      dense
                      hide-details
                      class="mb-4"
                      label="Alamat Lengkap Tujuan Kiriman"
                    />
                    <v-autocomplete
                      v-model.number="dialogShipping.data.shipping_destination_kec"
                      :name="Math.random()"
                      :disabled="parseInt(dialogShipping.data.id) ? true : false"
                      :search-input.sync="shippingDestinationQuery"
                      :items="shippingDestinationData"
                      item-value="kecamatan_id"
                      item-text="fullname"
                      outlined
                      dense
                      clearable
                      hide-details
                      label="Tujuan Pengiriman"
                      autocomplete="disabled"
                      @change="PRICING_GET()"
                    />
                  </div>
                </v-col>
                <v-col cols="12">
                  <v-divider />
                </v-col>
                <v-col cols="12">
                  <div class="d-flex fill-width align-center">
                    Shipping Packages / Items
                    <v-btn :disabled="parseInt(dialogShipping.data.id) ? true : parseInt(dialogShipping.data.product) ? false : true" depressed small color="secondary" class="rounded-pill text-capitalize ont-weight-bold ml-4" @click.prevent="PackageAdd()">
                      <v-icon class="mr-1" small>
                        mdi-plus
                      </v-icon>
                      Add
                    </v-btn>
                  </div>
                  <div class="pt-4">
                    <div v-if="!$StrToArray(dialogShipping.data.shipping_package).length" class="grey--text text--darken-1 caption font-weight-bold pb-4">
                      No data
                    </div>
                    <div v-else>
                      <div
                        v-for="(pkg, iPkg) in $StrToArray(dialogShipping.data.shipping_package)" :key="'package-item-' + iPkg"
                        class="pa-2 white rounded-lg mb-2"
                        style="border: solid 1px rgba(0, 0, 0, .3)!important;"
                      >
                        <v-row no-gutters>
                          <v-col cols="12" :class="[parseInt(productSelected.is_unit) ? 'col-sm-1' : 'col-sm-2']" class="pa-1">
                            <v-text-field
                              :value="pkg.quantity"
                              :name="Math.random()"
                              :disabled="parseInt(dialogShipping.data.id) ? true : false"
                              outlined
                              dense
                              hide-details
                              label="Qty"
                              @input="PackageUpdate('quantity', iPkg, $event)"
                            />
                          </v-col>
                          <v-col cols="4" class="col-sm-2 pa-1">
                            <v-text-field
                              :value="pkg.volume_length"
                              :name="Math.random()"
                              :disabled="parseInt(dialogShipping.data.id) ? true : false"
                              outlined
                              dense
                              hide-details
                              suffix="CM"
                              label="Length"
                              @input="PackageUpdate('volume_length', iPkg, $event)"
                            />
                          </v-col>
                          <v-col cols="4" class="col-sm-2 pa-1">
                            <v-text-field
                              :value="pkg.volume_width"
                              :name="Math.random()"
                              outlined
                              dense
                              :disabled="parseInt(dialogShipping.data.id) ? true : false"
                              hide-details
                              suffix="CM"
                              label="Width"
                              @input="PackageUpdate('volume_width', iPkg, $event)"
                            />
                          </v-col>
                          <v-col cols="4" class="col-sm-2 pa-1">
                            <v-text-field
                              :value="pkg.volume_height"
                              :name="Math.random()"
                              :disabled="parseInt(dialogShipping.data.id) ? true : false"
                              outlined
                              dense
                              hide-details
                              suffix="CM"
                              label="Height"
                              @input="PackageUpdate('volume_height', iPkg, $event)"
                            />
                          </v-col>
                          <v-col cols="6" class="col-sm-2 pa-1">
                            <v-text-field
                              :value="pkg.kg_metric"
                              :disabled="parseInt(dialogShipping.data.id) ? true : false"
                              :readonly="true"
                              :name="Math.random()"
                              outlined
                              dense
                              hide-details
                              suffix="KG"
                              label="Volume / Metric"
                            />
                          </v-col>
                          <v-col cols="6" class="col-sm-2 pa-1">
                            <v-text-field
                              :value="pkg.kg_actual"
                              :name="Math.random()"
                              :disabled="parseInt(dialogShipping.data.id) ? true : false"
                              outlined
                              dense
                              hide-details
                              suffix="KG"
                              label="Actual"
                              @input="PackageUpdate('kg_actual', iPkg, $event)"
                            />
                          </v-col>
                          <v-col v-if="!parseInt(productSelected.is_unit)" cols="12" class="col-sm-3 pa-1">
                            <v-text-field
                              :value="pkg.chargeable_weight"
                              :readonly="true"
                              :name="Math.random()"
                              :disabled="parseInt(dialogShipping.data.id) ? true : false"
                              outlined
                              dense
                              hide-details
                              suffix="KG"
                              label="Chargeable"
                            />
                          </v-col>
                          <v-col cols="12" :class="[parseInt(productSelected.is_unit) ? 'col-sm-1' : 'col-sm-9']" class="d-flex align-center justify-end pa-1">
                            <v-icon v-if="!parseInt(dialogShipping.data.id)" color="red" @click.prevent="PackageDelete(iPkg)">
                              mdi-close
                            </v-icon>
                          </v-col>
                        </v-row>
                      </div>
                      <v-row v-if="!parseInt(productSelected.is_unit)" justify="end" align="center">
                        <v-col cols="1" class="d-flex align-center justify-end">
                        </v-col>
                        <v-col cols="12" class="col-sm-3 d-flex align-center justify-end pt-8">
                          <v-text-field
                            :value="ChargeableWeightTotal"
                            :readonly="true"
                            outlined
                            dense
                            hide-details
                            prefix="TOTAL"
                            suffix="KG"
                            class="yellow lighten-5"
                            label="Chargeable Weight Total"
                          />
                        </v-col>
                      </v-row>
                    </div>
                  </div>
                </v-col>
                <v-col cols="12">
                  <v-divider />
                </v-col>
                <v-col cols="12" class="col-sm-6">
                  <v-select
                    v-model.number="dialogShipping.data.price_id"
                    :disabled="parseInt(dialogShipping.data.id) ? true : (parseInt(dialogShipping.data.product) ? ($StrToArray(dialogShipping.data.shipping_package).length ? false : true) : true)"
                    :items="[{ price_detail: 'Custom Price', id: 0 }].concat(
                      pricingData.filter((r) => {
                        return parseInt(r.product) === parseInt(dialogShipping.data.product) && (parseInt(dialogShipping.data.customer_billto) === parseInt(r.customer) || !parseInt(r.customer))
                      })
                    )"
                    :item-text="(p) => {
                      return p.price_detail + (parseFloat(p.weight_minimum) ? (', Min.Weight ' + parseFloat(parseFloat(p.weight_minimum)/1000).toFixed(1) + 'Kg') : '')
                    }"
                    :rules="[IsWeightMatch]"
                    item-value="id"
                    outlined
                    dense
                    hide-details
                    class="mb-4"
                    label="Tentukan Harga"
                    @change="SetPrice()"
                  />
                  <v-text-field
                    v-model.number="dialogShipping.data.price"
                    :disabled="parseInt(dialogShipping.data.id) ? true : (parseInt(dialogShipping.data.price_id) || !parseInt(dialogShipping.data.product) ? true : false)"
                    :name="Math.random()"
                    outlined
                    dense
                    hide-details
                    :label="(parseInt(productSelected.is_unit) ? ('Harga untuk ' + (PrintItemTotal.quantity) + ' UNIT') : 'Harga untuk ' + (ChargeableWeightTotal + 'KG'))"
                    prefix="Rp"
                    @keypress="$NumOnly"
                  />
                </v-col>
                <v-col cols="12" class="col-sm-6">
                  <v-text-field
                    v-model.number="dialogShipping.data.price_packaging"
                    :disabled="parseInt(dialogShipping.data.id) ? true : (parseInt(dialogShipping.data.product) ? false : true)"
                    :name="Math.random()"
                    outlined
                    dense
                    hide-details
                    class="mb-4"
                    label="+ Harga Packaging"
                    prefix="Rp"
                    @keypress="$NumOnly"
                  />
                  <v-text-field
                    v-model.number="dialogShipping.data.price_other"
                    :disabled="parseInt(dialogShipping.data.id) ? true : (parseInt(dialogShipping.data.product) ? false : true)"
                    :name="Math.random()"
                    outlined
                    dense
                    hide-details
                    label="+ Harga Lainnya"
                    prefix="Rp"
                    @keypress="$NumOnly"
                  />
                </v-col>
                <v-col cols="12" class="col-sm-6">
                  <v-select
                    v-model="dialogShipping.data.payment_option"
                    :disabled="parseInt(dialogShipping.data.id) ? true : false"
                    :items="[
                      'CASH',
                      'COD',
                      'INVOICE'
                    ]"
                    outlined
                    dense
                    hide-details
                    class="mb-4"
                    label="Opsi Pembayaran"
                  />
                </v-col>
                <v-col cols="12" class="col-sm-6">
                  <v-text-field
                    v-model.number="dialogShipping.data.est_to"
                    :disabled="parseInt(dialogShipping.data.id) ? true : false"
                    :name="Math.random()"
                    outlined
                    dense
                    hide-details
                    label="Estimasi Pengiriman"
                    suffix="Hari"
                    @keypress="$NumOnly"
                  />
                </v-col>
                <v-col cols="12">
                  <v-divider />
                </v-col>
                <v-col cols="4">
                  <v-text-field
                    v-model="dialogShipping.data.id_refference"
                    :disabled="parseInt(dialogShipping.data.id) ? true : false"
                    :name="Math.random()"
                    outlined
                    dense
                    hide-details
                    class="mb-4"
                    label="Customer Refference"
                  />
                </v-col>
                <v-col cols="4">
                  <v-text-field
                    v-model="dialogShipping.data.notes"
                    :disabled="parseInt(dialogShipping.data.id) ? true : false"
                    :name="Math.random()"
                    outlined
                    dense
                    hide-details
                    class="mb-4"
                    label="Notes"
                  />
                </v-col>
                <v-col cols="4">
                  <v-autocomplete
                    v-model.number="dialogShipping.data.sales"
                    :disabled="parseInt(dialogShipping.data.id) ? true : false"
                    :name="Math.random()"
                    :search-input.sync="dataSalesQuery"
                    :items="dataSales"
                    item-value="id"
                    item-text="user_detail"
                    outlined
                    dense
                    hide-details
                    label="- Cari Sales -"
                    clearable
                    autocomplete="disabled"
                  />
                </v-col>
                <v-col cols="12">
                  <v-divider />
                </v-col>
                <v-col cols="12" class="d-flex align-center justify-end pb-8">
                  <div class="font-weight-bold pr-4 primary--text title">
                    Total : {{ $price(totalPrice) }}
                  </div>
                  <v-btn v-if="!parseInt(dialogShipping.data.id)" :loading="dialogShipping.loading" :disabled="parseInt(dialogShipping.data.product) ? false : true" depressed color="primary" class="text-capitalize font-weight-bold" @click.prevent="SHIPPING_PROCESS()">
                    {{ parseInt(dialogShipping.data.id) ? 'Update' : 'Proses' }} Kiriman
                  </v-btn>
                </v-col>
              </v-row>
            </div>
          </v-container>
        </div>
      </v-card>
    </v-dialog>
    <v-dialog
      v-model="dialogPrint.show"
      fullscreen
      hide-overlay
      transition="dialog-bottom-transition"
      content-class="dialog-printed"
    >
      <v-card v-if="dialogPrint.data && dialogPrint.type === 'manifest'" flat class="rounded-0 elevation-0">
        <v-toolbar
          dark
          color="blue"
          class="elevation-0 no-print"
        >
          <v-toolbar-title>
            PRINT
            {{
              parseInt(dialogPrint.data.id)
                ? (
                    '#MANIFEST/' + dialogPrint.data.store_origin_code + '/' + dialogPrint.data.store_destination_code + (dialogPrint.data.vendor_code ? ('/' + dialogPrint.data.vendor_code) : '') +  '/' + dialogPrint.data.id
                  )
                  : ''
            }}
          </v-toolbar-title>
          <v-spacer />
          <v-toolbar-items>
            <v-btn
              dark
              text
              @click="dialogPrint.show = false"
            >
              <v-icon>
                mdi-close
              </v-icon>
            </v-btn>
          </v-toolbar-items>
        </v-toolbar>
        <div class="print-content" style="max-height: calc(100vh - 64px);overflow-y: auto; overflow-x: auto;">
          <v-container class="pt-6" style="min-width: 1000px;">
            <v-row>
              <v-col cols="12" class="no-print font-weight-bold d-flex fill-width justify-space-between align-center">
                <div>
                  {{
                    parseInt(dialogPrint.data.id)
                      ? (
                          '#MANIFEST/' + dialogPrint.data.store_origin_code + '/' + dialogPrint.data.store_destination_code + (dialogPrint.data.vendor_code ? ('/' + dialogPrint.data.vendor_code) : '') +  '/' + dialogPrint.data.id
                        )
                        : ''
                  }}
                </div>
                <div class="d-flex align-center">
                  <v-btn depressed color="orange darken-3" class="font-weight-bold rounded-0" dark large @click.prevent="DoPrint()">
                    <v-icon class="mr-2" small>
                      mdi-printer
                    </v-icon>
                    PRINT
                  </v-btn>
                </div>
              </v-col>
              <v-col cols="12" class="py-4 no-print">
                <v-divider />
              </v-col>
            </v-row>
            <div>
              <v-row>
                <v-col cols="4">
                  <img src="/xie-trans.png" class="xti-logo" style="height: 75px;">
                </v-col>
                <v-col cols="4">
                  <div class="d-flex align-center">
                    Relasi :
                    <div class="d-flex align-center pl-2">
                      {{ dialogPrint.data.store_origin_name || '#' }}
                      <v-icon class="mx-1" small>
                        mdi-arrow-right
                      </v-icon>
                      {{ dialogPrint.data.store_destination_name || '#' }}
                    </div>
                  </div>
                  <div>
                    Transport : {{ dialogPrint.data.dispatch_name || '-' }}
                  </div>
                  <div>
                    Etd : -
                  </div>
                </v-col>
                <v-col cols="4">
                  <div class="caption">
                    Printed by : {{ $store.state.user.name || '#' }} [{{ $store.state.user.id || '#' }}], {{ $localDT(null, 'datetimedefault') }}
                  </div>
                  <div class="font-weight-bold">
                    MANIFEST KIRIMAN
                  </div>
                  <div>
                    No :
                    {{
                      parseInt(dialogPrint.data.id)
                        ? (
                            '#MANIFEST/' + dialogPrint.data.store_origin_code + '/' + dialogPrint.data.store_destination_code + (dialogPrint.data.vendor_code ? ('/' + dialogPrint.data.vendor_code) : '') +  '/' + dialogPrint.data.id
                          )
                          : ''
                    }}
                  </div>
                  <div>
                    {{ $localDT(dialogPrint.data.created, 'daydatetime') }}
                  </div>
                </v-col>
                <v-col cols="12">
                  <v-divider />
                </v-col>
                <v-col cols="12" class="pt-1 pb-3">
                  <div class="font-weight-bold pb-1">
                    TTK LIST
                  </div>
                  <div v-if="dialogPrint.list.length" class="grey lighten-4 rounded px-3 py-1">
                    <div v-for="(m, iM) in dialogPrint.list" :key="'manifest-data-list-' + iM" class="px-4 py-2 rounded my-2 white">
                      <div class="font-weight-bold d-flex fill-width justify-space-between align-center">
                        <span class="primary--text text-uppercase">
                          {{ m.ttk || '-' }}, {{ m.product_name || '-' }}
                        </span>
                        <div class="d-flex align-center text-right justify-end">
                          <!-- <span v-if="m.master_count_type === 'UNIT'" class="secondary--text caption font-weight-regular">
                            {{ $price(m.master_price_final) }}
                          </span>
                          <span v-else class="secondary--text caption font-weight-regular">
                            {{ $price(m.price_final) }}
                          </span>
                          <span class="mx-1">
                            |
                          </span> -->
                          <div v-if="parseInt(m.product_is_unit)" class="d-flex align-center">
                            <span class="orange--text caption font-weight-regular">
                              Qty : {{ (m.shipping_package_quantity_sum + ' UNITS in ' + m.shipping_package_quantity + ' PKG') || '~' }}
                            </span>
                          </div>
                          <div v-else class="d-flex align-center">
                            <span class="orange--text caption font-weight-regular">
                              {{ (m.weight_chargeable + ' kg') }}
                            </span>
                            <span class="mx-1">
                              |
                            </span>
                            <span class="orange--text caption font-weight-regular">
                              Qty : {{ (m.shipping_package_quantity_sum + ' ITEMS in ' + m.shipping_package_quantity + ' PKG') || '~' }}
                            </span>
                          </div>
                          <!-- shipping_package -->
                        </div>
                      </div>
                      <v-divider class="my-1" />
                      <div class="d-flex align-center justify-space-between">
                        <div style="width: 40%;">
                          {{ m.shipping_sender_name || '-' }}
                          <!-- <div class="caption">
                            {{ m.shipping_sender_phone }}
                          </div> -->
                          <div class="caption">
                            {{ m.shipping_origin_city_name }} {{ m.shipping_origin_city_type }}
                          </div>
                        </div>
                        <div style="width: 20%;" class="text-center">
                          <v-icon class="mx-2" small>
                            mdi-chevron-right
                          </v-icon>
                        </div>
                        <div style="width: 40%;">
                          {{ m.shipping_name || '-' }}
                          <!-- <div class="caption">
                            {{ m.shipping_phone }}
                          </div> -->
                          <div class="caption">
                            {{ m.shipping_destination_city_name }} {{ m.shipping_destination_city_type }}
                          </div>
                        </div>
                      </div>
                      <v-divider class="mt-1 mb-2" />
                      <div v-if="$statusPlan(m.manifest_plan) && dialogPrint.data.departure && !dialogPrint.data.arrival && dialogPrint.data.type !== 'courier'" class="d-flex align-center justify-space-between fill-width">
                        <div v-if="$statusPlan(m.manifest_plan).status_plan_img || (!dialogPrint.data.departure && !dialogPrint.data.arrival)" class="d-flex align-center justify-end">
                          <v-divider vertical class="mx-2" />
                          <v-btn v-if="$statusPlan(m.manifest_plan).status_plan_img" :href="$statusPlan(m.manifest_plan).status_plan_img" target="_blank" icon color="primary" x-small class="text-capitalize" @click.prevent="PlanAction('image', $statusPlan(m.manifest_plan).status_plan_img)">
                            <v-icon>
                              mdi-image
                            </v-icon>
                          </v-btn>
                          <v-btn v-else-if="!dialogPrint.data.departure && !dialogPrint.data.arrival" icon color="red" x-small class="text-capitalize" @click.prevent="PlanAction('delete', $statusPlan(m.manifest_plan).id, parseInt(dialogPrint.data.id), m.id)">
                            <v-icon>
                              mdi-close
                            </v-icon>
                          </v-btn>
                          <span v-else icon color="red" x-small class="text-capitalize">
                            -
                          </span>
                        </div>
                      </div>
                    </div>
                  </div>
                </v-col>
                <v-col cols="12" class="py-1">
                  <v-divider class="mb-2" />
                  <div class="d-flex fill-width align-center justify-space-between">
                    <div class="d-flex align-center" style="width: calc(50% - 32px);">
                      CHARGEABLE WEIGHT : {{ ManifestPrintWeight.weight_chargeable || 0 }}Kg
                    </div>
                    <div class="d-flex align-center text-enter" style="width: 64px;">
                      SUMMARY
                    </div>
                    <div class="d-flex justify-end text-right" style="width: calc(50% - 32px);">
                      <div>
                        NON-UNIT: {{ ManifestPrintWeight.weight_sum + '/' + ManifestPrintWeight.weight }}
                      </div>
                      <div class="ml-2">
                        UNIT: {{ ManifestPrintWeight.unit_sum + '/' + ManifestPrintWeight.unit }}
                      </div>
                    </div>
                  </div>
                </v-col>
                <v-col cols="12" class="py-1">
                  <v-divider class="mb-2" />
                </v-col>
                <v-col cols="4">
                </v-col>
                <v-col cols="8" class="d-flex justify-end pt-8">
                  <v-row>
                    <v-col cols="4">
                      Petugas Ktr Tujuan
                      <div>
                        <div class="pt-2">
                          &nbsp;
                        </div>
                        ---------------------
                      </div>
                    </v-col>
                    <v-col cols="4">
                      Transporter
                      <div>
                        <div class="pt-2">
                          &nbsp;
                        </div>
                        ---------------------
                      </div>
                    </v-col>
                    <v-col cols="4">
                      Petugas Kirim
                      <div>
                        <div class="pt-2">
                          {{ $store.state.user.name || '#' }} [{{ $store.state.user.id || '#' }}]
                        </div>
                        ---------------------
                      </div>
                    </v-col>
                  </v-row>
                </v-col>
              </v-row>
            </div>
          </v-container>
        </div>
      </v-card>
      <v-card v-else-if="dialogPrint.data" flat class="rounded-0 elevation-0">
        <v-toolbar
          dark
          color="secondary"
          class="elevation-0 no-print"
        >
          <v-toolbar-title>PRINT - {{ dialogPrint.data.ttk || '-' }}</v-toolbar-title>
          <v-spacer />
          <v-toolbar-items>
            <v-btn
              dark
              text
              @click="dialogPrint.show = false"
            >
              <v-icon>
                mdi-close
              </v-icon>
            </v-btn>
          </v-toolbar-items>
        </v-toolbar>
        <div class="print-content" style="max-height: calc(100vh - 64px);overflow-y: auto; overflow-x: auto;">
          <v-container class="pt-6" style="min-width: 1000px;">
            <v-row>
              <v-col cols="12" class="no-print font-weight-bold d-flex fill-width justify-space-between align-center">
                <div>
                  TTK NUMBER : {{ dialogPrint.data.ttk || '-' }}
                </div>
                <div class="d-flex align-center no-print">
                  <v-switch
                    v-model="printNoPrice"
                    hide-details
                    inset
                    label="Print with No-Price"
                    class="mr-4 mt-0"
                  />
                  <v-btn depressed color="orange darken-3" class="font-weight-bold rounded-0" dark large @click.prevent="DoPrint()">
                    <v-icon class="mr-2" small>
                      mdi-printer
                    </v-icon>
                    PRINT
                  </v-btn>
                </div>
              </v-col>
              <v-col cols="12" class="py-4 no-print">
                <v-divider />
              </v-col>
              <v-col cols="12 print-only">
                <div class="pa-0 text-center">
                  TTK::e-CONNOTE
                </div>
                <v-divider />
              </v-col>
              <v-col cols="6" class="col-left">
                <v-row class="flex-stretch" align="center">
                  <v-col cols="6" class="fill-height">
                    <img src="/xie-trans.png" class="xti-logo" style="height: 75px;">
                    <div class="font-weight-bold pt-1">
                      Branch Code : {{ $Branch(dialogPrint.data) }}<br>
                      <v-card outlined class="pa-4 rounded-0 d-inline-block my-2 text-right">
                        No. TTK :
                        <div class="text-h5 font-weight-bold">
                          {{ dialogPrint.data.ttk || '-' }}
                        </div>
                      </v-card>
                    </div>
                  </v-col>
                  <v-col cols="6" class="d-flex justify-end">
                    <barcode v-if="dialogPrint.data.ttk" :value="dialogPrint.data.ttk">
                      -
                    </barcode>
                    <!-- <qrcode :value="(dialogPrint.data.ttk || '-') + ', ' + dialogPrint.data.shipping_sender_name + ', ' + dialogPrint.data.shipping_name + ', ' + dialogPrint.data.shipping_address" :options="{ width: 200 }" /> -->
                  </v-col>
                  <v-col cols="12" class="font-weight-bold">
                    <v-row no-gutters>
                      <v-col cols="3">
                        Jenis Kiriman
                      </v-col>
                      <v-col cols="9">
                        : {{ dialogPrint.data.product_name }}
                      </v-col>
                      <v-col cols="3">
                        Pembayaran
                      </v-col>
                      <v-col cols="9">
                        : {{ dialogPrint.data.payment_option || '-' }}
                      </v-col>
                      <v-col cols="3">
                        Bill To
                      </v-col>
                      <v-col cols="9">
                        : {{ dialogPrint.data.customer_billto_name || '-' }}
                      </v-col>
                      <v-col cols="12" class="py-2" />
                      <v-col cols="3">
                        Origin City
                      </v-col>
                      <v-col cols="9">
                        : {{ dialogPrint.data.shipping_origin_city_name || '-' }} {{ dialogPrint.data.shipping_origin_city_type || '-' }}
                      </v-col>
                      <v-col cols="3">
                        Destination City
                      </v-col>
                      <v-col cols="9">
                        : {{ dialogPrint.data.shipping_destination_city_name || '-' }} {{ dialogPrint.data.shipping_destination_city_type || '-' }}
                      </v-col>
                      <v-col cols="3">
                        Customer Refference
                      </v-col>
                      <v-col cols="9">
                        : {{ dialogPrint.data.id_refference || '-' }}
                      </v-col>
                      <v-col cols="12" class="pt-4">
                        <div class="pa-2 primary white--text mb-2">
                          SHIPPER
                        </div>
                        <div>
                          <span class="text-uppercase">{{ dialogPrint.data.shipping_sender_name }}</span><br>
                          {{ dialogPrint.data.shipping_origin_city_name || '-' }} {{ dialogPrint.data.shipping_origin_city_type || '-' }}<br>
                          {{ dialogPrint.data.shipping_sender_phone }}
                        </div>
                      </v-col>
                      <v-col cols="12" class="pt-4">
                        <div class="pa-2 primary white--text mb-2">
                          CONSIGNEE
                        </div>
                        <div>
                          <span class="text-uppercase">{{ dialogPrint.data.shipping_name }}</span><br>
                          {{ dialogPrint.data.shipping_destination_city_name || '-' }} {{ dialogPrint.data.shipping_destination_city_type || '-' }}<br>
                          {{ dialogPrint.data.shipping_address }}<br>
                          {{ dialogPrint.data.shipping_sender_phone }}
                        </div>
                      </v-col>
                    </v-row>
                  </v-col>
                </v-row>
              </v-col>
              <v-col cols="6" class="col-right">
                <div class="d-flex align-center justify-space-between fill-width">
                  <span>
                    Trx Date : {{ $localDT(dialogPrint.data.created, 'datetimedefault') }}
                  </span>
                  <span>
                    Print Date : {{ $localDT(null, 'datetimedefault') }}
                  </span>
                </div>
                <div class="pt-2">
                  <table class="fill-width font-weight-bold table-print">
                    <tr>
                      <td class="text-center grey lighten-4 pa-1">
                        No
                      </td>
                      <td class="text-center grey lighten-4 pa-1">
                        Quantity
                      </td>
                      <td class="text-center grey lighten-4 pa-1">
                        Weight (kg)
                      </td>
                      <td class="text-center grey lighten-4 pa-1">
                        Dimentions (cm)
                      </td>
                      <td class="text-center grey lighten-4 pa-1">
                        Weight (Kg)
                      </td>
                    </tr>
                    <tr v-for="(pkg, iPkg) in $StrToArray(dialogPrint.data.shipping_package)" :key="'print-item-' + iPkg">
                      <td class="text-center">
                        {{ iPkg + 1 }}.
                      </td>
                      <td class="text-right">
                        {{ pkg.quantity }}
                      </td>
                      <td class="text-right">
                        {{ parseFloat(pkg.chargeable_weight || 0).toFixed(2) }}
                      </td>
                      <td class="text-right">
                        {{ pkg.volume_length }}x{{ pkg.volume_width }}x{{ pkg.volume_height }}
                      </td>
                      <td class="text-right">
                        {{ parseFloat(pkg.chargeable_weight || 0).toFixed(2) }}
                      </td>
                    </tr>
                    <tr>
                      <td class="text-center">
                        TOTAL
                      </td>
                      <td class="text-right">
                        {{ (PrintItemTotal.quantity || 0) }}
                      </td>
                      <td class="text-right" colspan="3">
                        {{ (PrintItemTotal.total || 0).toFixed(2) }}
                      </td>
                    </tr>
                  </table>
                  <v-divider class="my-2" />
                  <div v-if="!printNoPrice" class="text-right py-4">
                    Packaging : <span class="d-inline-block" style="min-width:100px;">{{ $price(dialogPrint.data.price_packaging) }}</span><br>
                    Other : <span class="d-inline-block" style="min-width:100px;">{{ $price(dialogPrint.data.price_other) }}</span><br>
                    <v-divider class="my-2" />
                    <div class="font-weight-bold">
                      Total : <span class="d-inline-block" style="min-width:100px;">{{ $price(dialogPrint.data.price_final) }}</span>
                    </div>
                  </div>
                  <v-card outlined class="pa-4 rounded-0 my-2">
                    Notes :
                    <div>
                      {{ dialogPrint.data.notes || '-' }}
                    </div>
                  </v-card>
                  <v-row class="pt-4 pb-4">
                    <v-col cols="6" class="pa-4 text-center">
                      Created By<br><br>
                      {{ dialogPrint.data.creator_name || '-' }}
                    </v-col>
                    <v-col cols="6" class="pa-4 text-center">
                      Recipient<br><br>
                      __________________
                    </v-col>
                  </v-row>
                  <div>
                    *) Syarat dan Kondisi Pengiriman dapat dilihat di website: www.xti.co.id
                  </div>
                </div>
              </v-col>
            </v-row>
          </v-container>
          <v-container class="pt-6" style="min-width: 1000px;">
            <v-row>
              <v-col cols="12" class="py-4 no-print">
                <v-divider />
              </v-col>
              <v-col cols="12 print-only">
                <div class="pa-0 text-center">
                  TTK::e-CONNOTE
                </div>
                <v-divider />
              </v-col>
              <v-col cols="6" class="col-left">
                <v-row class="flex-stretch" align="center">
                  <v-col cols="6" class="fill-height">
                    <img src="/xie-trans.png" class="xti-logo" style="height: 75px;">
                    <div class="font-weight-bold pt-1">
                      Branch Code : {{ $Branch(dialogPrint.data) }}<br>
                      <v-card outlined class="pa-4 rounded-0 d-inline-block my-2 text-right">
                        No. TTK :
                        <div class="text-h5 font-weight-bold">
                          {{ dialogPrint.data.ttk || '-' }}
                        </div>
                      </v-card>
                    </div>
                  </v-col>
                  <v-col cols="6" class="d-flex justify-end">
                    <barcode v-if="dialogPrint.data.ttk" :value="dialogPrint.data.ttk">
                      -
                    </barcode>
                    <!-- <qrcode :value="(dialogPrint.data.ttk || '-') + ', ' + dialogPrint.data.shipping_sender_name + ', ' + dialogPrint.data.shipping_name + ', ' + dialogPrint.data.shipping_address" :options="{ width: 200 }" /> -->
                  </v-col>
                  <v-col cols="12" class="font-weight-bold">
                    <v-row no-gutters>
                      <v-col cols="3">
                        Jenis Kiriman
                      </v-col>
                      <v-col cols="9">
                        : {{ dialogPrint.data.product_name }}
                      </v-col>
                      <v-col cols="3">
                        Pembayaran
                      </v-col>
                      <v-col cols="9">
                        : {{ dialogPrint.data.payment_option || '-' }}
                      </v-col>
                      <v-col cols="3">
                        Bill To
                      </v-col>
                      <v-col cols="9">
                        : {{ dialogPrint.data.customer_billto_name || '-' }}
                      </v-col>
                      <v-col cols="12" class="py-2" />
                      <v-col cols="3">
                        Origin City
                      </v-col>
                      <v-col cols="9">
                        : {{ dialogPrint.data.shipping_origin_city_name || '-' }} {{ dialogPrint.data.shipping_origin_city_type || '-' }}
                      </v-col>
                      <v-col cols="3">
                        Destination City
                      </v-col>
                      <v-col cols="9">
                        : {{ dialogPrint.data.shipping_destination_city_name || '-' }} {{ dialogPrint.data.shipping_destination_city_type || '-' }}
                      </v-col>
                      <v-col cols="3">
                        Customer Refference
                      </v-col>
                      <v-col cols="9">
                        : {{ dialogPrint.data.id_refference || '-' }}
                      </v-col>
                      <v-col cols="12" class="pt-4">
                        <div class="pa-2 primary white--text mb-2">
                          SHIPPER
                        </div>
                        <div>
                          <span class="text-uppercase">{{ dialogPrint.data.shipping_sender_name }}</span><br>
                          {{ dialogPrint.data.shipping_origin_city_name || '-' }} {{ dialogPrint.data.shipping_origin_city_type || '-' }}<br>
                          {{ dialogPrint.data.shipping_sender_phone }}
                        </div>
                      </v-col>
                      <v-col cols="12" class="pt-4">
                        <div class="pa-2 primary white--text mb-2">
                          CONSIGNEE
                        </div>
                        <div>
                          <span class="text-uppercase">{{ dialogPrint.data.shipping_name }}</span><br>
                          {{ dialogPrint.data.shipping_destination_city_name || '-' }} {{ dialogPrint.data.shipping_destination_city_type || '-' }}<br>
                          {{ dialogPrint.data.shipping_address }}<br>
                          {{ dialogPrint.data.shipping_sender_phone }}
                        </div>
                      </v-col>
                    </v-row>
                  </v-col>
                </v-row>
              </v-col>
              <v-col cols="6" class="col-right">
                <div class="d-flex align-center justify-space-between fill-width">
                  <span>
                    Trx Date : {{ $localDT(dialogPrint.data.created, 'datetimedefault') }}
                  </span>
                  <span>
                    Print Date : {{ $localDT(null, 'datetimedefault') }}
                  </span>
                </div>
                <div class="pt-2">
                  <table class="fill-width font-weight-bold table-print">
                    <tr>
                      <td class="text-center grey lighten-4 pa-1">
                        No
                      </td>
                      <td class="text-center grey lighten-4 pa-1">
                        Quantity
                      </td>
                      <td class="text-center grey lighten-4 pa-1">
                        Weight (kg)
                      </td>
                      <td class="text-center grey lighten-4 pa-1">
                        Dimentions (cm)
                      </td>
                      <td class="text-center grey lighten-4 pa-1">
                        Weight (Kg)
                      </td>
                    </tr>
                    <tr v-for="(pkg, iPkg) in $StrToArray(dialogPrint.data.shipping_package)" :key="'print-item2-' + iPkg">
                      <td class="text-center">
                        {{ iPkg + 1 }}.
                      </td>
                      <td class="text-right">
                        {{ pkg.quantity }}
                      </td>
                      <td class="text-right">
                        {{ parseFloat(pkg.chargeable_weight || 0).toFixed(2) }}
                      </td>
                      <td class="text-right">
                        {{ pkg.volume_length }}x{{ pkg.volume_width }}x{{ pkg.volume_height }}
                      </td>
                      <td class="text-right">
                        {{ parseFloat(pkg.chargeable_weight || 0).toFixed(2) }}
                      </td>
                    </tr>
                    <tr>
                      <td class="text-center">
                        TOTAL
                      </td>
                      <td class="text-right">
                        {{ (PrintItemTotal.quantity || 0) }}
                      </td>
                      <td class="text-right" colspan="3">
                        {{ (PrintItemTotal.total || 0).toFixed(2) }}
                      </td>
                    </tr>
                  </table>
                  <v-divider class="my-2" />
                  <div v-if="!printNoPrice" class="text-right py-4">
                    Packaging : <span class="d-inline-block" style="min-width:100px;">{{ $price(dialogPrint.data.price_packaging) }}</span><br>
                    Other : <span class="d-inline-block" style="min-width:100px;">{{ $price(dialogPrint.data.price_other) }}</span><br>
                    <v-divider class="my-2" />
                    <div class="font-weight-bold">
                      Total : <span class="d-inline-block" style="min-width:100px;">{{ $price(dialogPrint.data.price_final) }}</span>
                    </div>
                  </div>
                  <v-card outlined class="pa-4 rounded-0 my-2">
                    Notes :
                    <div>
                      {{ dialogPrint.data.notes || '-' }}
                    </div>
                  </v-card>
                  <v-row class="pt-4 pb-4">
                    <v-col cols="6" class="pa-4 text-center">
                      Created By<br><br>
                      {{ dialogPrint.data.creator_name || '-' }}
                    </v-col>
                    <v-col cols="6" class="pa-4 text-center">
                      Recipient<br><br>
                      __________________
                    </v-col>
                  </v-row>
                  <div>
                    *) Syarat dan Kondisi Pengiriman dapat dilihat di website: www.xti.co.id
                  </div>
                </div>
              </v-col>
            </v-row>
          </v-container>
        </div>
      </v-card>
    </v-dialog>
    <v-dialog
      v-model="dialogPlan.show"
      persistent
      scrollable
      max-width="450"
    >
      <v-card v-if="dialogPlan.data.loading" class="pa-8">
        Loading
      </v-card>
      <v-card v-else-if="dialogPlan.selected" class="px-4">
        <v-card-title class="flex-column body-1 align-center text-uppercase font-weight-bold">
          <span class="subtitle-2">- LACAK KIRIMAN -</span>
          <div class="secondary--text">
            {{ dialogPlan.selected.ttk }}
          </div>
        </v-card-title>
        <v-divider />
        <v-card-text class="pt-4 pr-2 pl-12" style="max-height: 90vh;">
          <div v-for="(dp, iDp) in dialogPlan.data" :key="'route-track-' + iDp" class="p-relative">
            <v-card v-if="(dp.recipient_imgs && dp.recipient_imgs !== '[]') || (dp.manifest_arrival && parseInt(dp.status_plan) !== 3)" :class="[iDp === 0 && !dp.courier_detail ? 'px-5' : 'px-0']" flat :dark="(iDp === 0 && !dp.courier_detail) ? true : false" class="d-flex flex-column justify-center fill-width rounded-lg p-relative" style="min-height: 82px;">
              {{ $localDT(dp.manifest_arrival, 'daydatetime') }}
              <div v-if="dp.recipient_imgs && parseInt(dp.status)">
                DELIVERED TO <span class="text-uppercase">{{ dp.recipient_relation || '-' }} ({{ dp.recipient_name || '#' }})</span>
                <div class="d-flex align-center">
                  <v-icon class="mr-1" small>
                    mdi-note-multiple-outline
                  </v-icon>
                  {{ dp.recipient_notes || '#' }}
                </div>
                <div v-if="dp.recipient_imgs" class="d-flex fill-width flex-wrap">
                  <img
                    v-for="(img, iimg) in $StrToArray(dp.recipient_imgs)"
                    :key="'img-delivery-' + iimg"
                    :src="img"
                    style="height: 80px; width: 80px;"
                    class="ma-1"
                    @click.prevent="OpenBrowser(img)"
                  >
                </div>
                <div class="py-1">
                  <span>Sign :</span>
                  <img
                    v-if="dp.recipient_sign"
                    :src="dp.recipient_sign"
                    style="height: 80px; width: 80px;"
                    class="ma-1 d-block"
                    @click.prevent="OpenBrowser(dp.recipient_sign)"
                  >
                </div>
              </div>
              <div v-else-if="!dp.courier_detail" class="text-uppercase">
                {{ dp.store_destination_city_name || dp.store_destination_name ? ((dp.store_destination_city_name || dp.store_destination_name) + ', ') : '' }} MANIFEST IN
                <!-- {{ dp.store_destination_name }} MANIFEST IN, {{ dp.store_destination_name }}{{ (dp.vendor_code ? (' (' + (dp.vendor_code || '-') + ')') : '') }} -->
              </div>
              <span v-if="iDp !== 0" style="display:block;position: absolute;top:-24%;left:-30px;height:50%;width:0px;border-left:dashed 2px #4CAF50;z-index:1;" />
              <span :class="[(iDp !== 0 || dp.courier_detail) ? 'green' : 'primary']" style="position: absolute;top:calc(50% - 15px);left:-43px;width: 30px;height: 30px;z-index:2;" class="d-flex align-center justify-center rounded-pill">
                <v-icon color="white" small>
                  {{ iDp !== 0 || dp.courier_detail ? 'mdi-check' : 'mdi-map-marker' }}
                </v-icon>
              </span>
            </v-card>
            <v-card v-if="dp.manifest_departure" flat class="d-flex flex-column justify-center fill-width rounded-lg px-0 p-relative" style="min-height: 82px;">
              {{ $localDT(dp.manifest_departure, 'daydatetime') }}
              <div v-if="dp.courier_detail">
                PROCESS DELIVERY WITH COURIER
                <div class="caption">
                  {{ dp.courier_detail || '-' }}
                </div>
              </div>
              <div v-else class="text-uppercase">
                {{ dp.store_origin_city_name ? (dp.store_origin_city_name + ', ') : '' }} MANIFEST OUT
                <!-- {{ dp.store_origin_code }} {{ dp.courier_detail ? 'ON DELIVERY WITH COURIER' : 'MANIFEST OUT' }}, {{ dp.store_origin_name }}{{ (dp.vendor_code ? (' (' + (dp.vendor_code || '-') + ')') : '') }} -->
              </div>
              <span v-if="dp.manifest_arrival && parseInt(dp.status_plan) !== 3" style="display:block;position: absolute;top:-24%;left:-30px;height:50%;width:0px;border-left:dashed 2px #4CAF50;z-index:1;" />
              <span :class="[!dp.manifest_arrival ? 'primary' : 'green']" style="position: absolute;top:calc(50% - 15px);left:-43px;width: 30px;height: 30px;z-index:2;" class="d-flex align-center justify-center rounded-pill">
                <v-icon color="white" small>
                  {{ !dp.manifest_arrival ? 'mdi-map-marker' : 'mdi-check' }}
                </v-icon>
              </span>
              <!-- <span style="display:block;position: absolute;bottom:-7px;left:-30px;height:50%;width:0px;border-left:dashed 2px #4CAF50;z-index:1;" /> -->
            </v-card>
            <v-card flat class="d-flex flex-column justify-center fill-width rounded-lg px-0 p-relative" style="min-height: 82px;">
              {{ $localDT(dp.created, 'daydatetime') }}
              <div class="text-uppercase">
                <div v-if="dp.notes && ((dp.notes || 'X').split('[CANCELED]').length >= 2)" class="d-flex align-center red--text caption text-uppercase">
                  <v-icon class="mr-2" small color="red">
                    mdi-arrow-u-left-bottom
                  </v-icon>
                  {{ dp.notes || '-' }}
                </div>
                {{ dp.store_origin_city_name ? (dp.store_origin_city_name + ', ') : '' }} {{ dp.courier_detail ? 'DISPATCH COURIER' : 'MANIFESTED' }}
                <!-- {{ dp.store_origin_code }} {{ dp.courier_detail ? 'DISPATCH COURIER' : 'MANIFESTED' }}, {{ dp.store_origin_name }} -->
              </div>
              <span v-if="dp.manifest_departure" style="display:block;position: absolute;top:-24%;left:-30px;height:50%;width:0px;border-left:dashed 2px #4CAF50 ;z-index:1;" />
              <span :class="[!dp.manifest_departure ? 'primary' : 'green']" style="position: absolute;top:calc(50% - 15px);left:-43px;width: 30px;height: 30px;z-index:2;" class="d-flex align-center justify-center rounded-pill">
                <v-icon color="white" small>
                  {{ !dp.manifest_departure ? 'mdi-map-marker' : 'mdi-check' }}
                </v-icon>
              </span>
              <!-- <span style="display:block;position: absolute;bottom:-7px;left:-30px;height:50%;width:0px;border-left:dashed 2px #4CAF50 ;z-index:1;" /> -->
            </v-card>
          </div>
          <div>
            <v-card v-if="parseInt(dialogPlan.selected.pickup_handling)" flat class="d-flex flex-column justify-center fill-width rounded-lg px-0 p-relative" style="min-height: 82px;">
              <div v-if="parseInt(dialogPlan.selected.pickup_handling_admin)" class="d-flex align-start justify-center flex-column mb-4">
                <div class="text-uppercase">
                  Received by {{ dialogPlan.selected.shipping_origin_city_name }} {{ dialogPlan.selected.shipping_origin_city_type }}
                </div>
                <span style="position: absolute;top:calc(50% - 15px);left:-43px;width: 30px;height: 30px;z-index:2;" class="d-flex align-center justify-center green rounded-pill">
                  <v-icon color="white" small>
                    mdi-truck-fast
                  </v-icon>
                </span>
              </div>
              <div v-if="parseInt(dialogPlan.selected.pickup_handling_status)" class="d-flex align-start justify-center flex-column mb-4">
                <div class="text-uppercase">
                  Picked-Up by {{ dialogPlan.selected.pickup_detail }}
                </div>
                <span style="position: absolute;top:calc(50% - 15px);left:-43px;width: 30px;height: 30px;z-index:2;" class="d-flex align-center justify-center green rounded-pill">
                  <v-icon color="white" small>
                    mdi-truck-fast
                  </v-icon>
                </span>
              </div>
              <div class="d-flex align-start justify-center flex-column mb-4">
                <div class="text-uppercase">
                  Prepare for Pickup
                </div>
                <span style="position: absolute;top:calc(50% - 15px);left:-43px;width: 30px;height: 30px;z-index:2;" class="d-flex align-center justify-center green rounded-pill">
                  <v-icon color="white" small>
                    mdi-truck-fast
                  </v-icon>
                </span>
              </div>
              <div class="d-flex align-start justify-center flex-column">
                <div class="text-uppercase">
                  Order Request #{{ dialogPlan.selected.id_refference || '-' }}, {{ dialogPlan.selected.shipping_name }}
                </div>
                <span style="position: absolute;top:calc(50% - 15px);left:-43px;width: 30px;height: 30px;z-index:2;" class="d-flex align-center justify-center green rounded-pill">
                  <v-icon color="white" small>
                    mdi-truck-fast
                  </v-icon>
                </span>
              </div>
            </v-card>
            <v-card v-else-if="!parseInt(dialogPlan.selected.pickup) || (parseInt(dialogPlan.selected.pickup) && parseInt(dialogPlan.selected.pickup_handling) && dialogPlan.selected.pickup_end)" flat class="d-flex flex-column justify-center fill-width rounded-lg px-0 p-relative" style="min-height: 82px;">
              {{ parseInt(dialogPlan.selected.pickup) ? $localDT(dialogPlan.selected.pickup_end, 'daydatetime') : $localDT(dialogPlan.selected.created, 'daydatetime') }}
              <div class="text-uppercase">
                <div v-if="dialogPlan.selected.notes && ((dialogPlan.selected.notes || 'X').split('[CANCELED]').length >= 2)" class="d-flex align-center red--text caption text-uppercase">
                  <v-icon class="mr-2" small color="red">
                    mdi-arrow-u-left-bottom
                  </v-icon>
                  {{ dialogPlan.selected.notes || '-' }}
                </div>
                <span>
                  REGISTERED AT {{ dialogPlan.selected.shipping_origin_city_name }} {{ dialogPlan.selected.shipping_origin_city_type }}
                </span>
              </div>
              <span v-if="dialogPlan.data.length" style="display:block;position: absolute;top:-24%;left:-30px;height:50%;width:0px;border-left:dashed 2px #4CAF50 ;z-index:1;" />
              <span :class="[dialogPlan.data.length ? 'green' : 'primary']" style="position: absolute;top:calc(50% - 15px);left:-43px;width: 30px;height: 30px;z-index:2;" class="d-flex align-center justify-center green rounded-pill">
                <v-icon color="white" small>
                  mdi-package-variant-closed
                </v-icon>
              </span>
            </v-card>
          </div>
        </v-card-text>
        <v-divider />
        <v-card-actions class="overflow-hidden">
          <v-btn
            color="red darken-1"
            text
            @click="dialogPlan.show = false"
          >
            Close
          </v-btn>
          <v-spacer />
          <Download v-if="ParsingDownloadTtkTrackingData.length" :filename="'xti-tracking-' + dialogPlan.selected.ttk" :name="'TTK ' + dialogPlan.selected.ttk" :data="ParsingDownloadTtkTrackingData" />
          <v-btn v-else :disabled="true" depressed block small color="grey" class="white--text text-capitalize rounded-pill">
            Download
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog
      v-model="dialogManifest.show"
      persistent
      scrollable
      max-width="1600"
    >
      <v-card>
        <v-card-title class="body-1 justify-center text-uppercase font-weight-bold">
          MANIFEST & TRANSPORT
        </v-card-title>
        <v-divider />
        <v-card-text class="px-2 px-sm-4" style="height: 90vh;">
          <v-row>
            <v-col cols="12" class="col-sm-7">
              <div class="d-flex align-center justify-space-between fill-width title pt-4">
                <div v-if="$store.state.user.role === 'root' || $store.state.user.role === 'admin' || $store.state.user.role === 'manager'" class="pr-2">
                  <v-select
                    v-model.number="dialogManifest.cabang"
                    :items="$store.state.storeData.filter(r => !parseInt(r.type))"
                    item-text="name"
                    item-value="id"
                    outlined
                    dense
                    hide-details
                    label="Bypass Cabang"
                  />
                </div>
                <span v-else>
                  # MANIFEST
                </span>
                <v-btn-toggle
                  v-model="manifestView"
                  mandatory
                  dense
                >
                  <v-btn>
                    DRAFT
                  </v-btn>
                  <v-btn>
                    TRANSPORT
                  </v-btn>
                  <v-btn>
                    ALL
                  </v-btn>
                </v-btn-toggle>
              </div>
              <v-row no-gutters>
                <v-col v-if="false" cols="12" class="col-sm-4 white">
                  <div class="pl-2 pl-sm-1 pr-2 pt-2 pb-0 pb-sm-2">
                    <v-text-field
                      v-model="dialogManifest.search"
                      outlined
                      dense
                      hide-details
                      class=""
                      clearable
                      placeholder="Cari ..."
                      prepend-inner-icon="mdi-magnify"
                    />
                  </div>
                </v-col>
                <v-col v-if="false" cols="12" class="col-sm-2 white">
                  <div class="pr-2 pr-sm-2 pl-2 pl-sm-0 pt-2 pb-2">
                    <v-autocomplete
                      v-model.number="dialogManifest.cabang"
                      :disabled="true"
                      :items="[{ id: -1, name: '- Semua data -' }].concat($store.state.storeData.filter(r => !parseInt(r.type)))"
                      item-text="name"
                      item-value="id"
                      outlined
                      dense
                      hide-details
                      label="Filter Cabang"
                      @change="dialogManifest.dates = [], MANIFEST_GET()"
                    />
                  </div>
                </v-col>
                <v-col v-if="false" cols="12" class="col-sm-2 white">
                  <div class="pr-2 pr-sm-1 pl-2 pl-sm-0 pt-2 pb-2">
                    <v-select
                      v-model.number="dialogManifest.vendor"
                      :disabled="parseInt($store.state.user.store) > -1"
                      :items="[{ id: -1, name: '- Semua vendor -' }].concat($store.state.storeData.filter(r => parseInt(r.type)))"
                      item-text="name"
                      item-value="id"
                      outlined
                      dense
                      hide-details
                      label="Filter Vendor"
                      @change="dialogManifest.dates = [], MANIFEST_GET()"
                    />
                  </div>
                </v-col>
                <v-col v-if="false" cols="12" class="col-sm-4 white">
                  <div class="px-2 pt-2 pb-0 pb-sm-2">
                    <v-menu
                      ref="menumanifest"
                      v-model="dialogManifest.menu"
                      :return-value.sync="dialogManifest.dates"
                      left
                      offset-y
                      :close-on-content-click="false"
                      min-width="auto"
                    >
                      <template v-slot:activator="{ on, attrs }">
                        <v-text-field
                          :disabled="parseInt(dialogManifest.cabang) > -1 ? true : false"
                          :value="dateRangeTextManifest"
                          label="Date Ranges"
                          append-icon="mdi-calendar-outline"
                          readonly
                          outlined
                          dense
                          hide-details
                          clearable
                          v-bind="attrs"
                          v-on="on"
                          @click:clear="dialogManifest.dates = [], MANIFEST_GET()"
                        />
                      </template>
                      <v-date-picker
                        v-model="dialogManifest.dates"
                        no-title
                        light
                        class="force-light-font"
                        range
                      >
                        <v-spacer />
                        <v-btn
                          text
                          class="text-capitalize"
                          small
                          @click="dialogManifest.menu = false"
                        >
                          Cancel
                        </v-btn>
                        <v-btn
                          text
                          class="text-capitalize"
                          small
                          @click="$refs.menumanifest.save(dialogManifest.dates), (dialogManifest.dates.length === 2 ? MANIFEST_GET() : '')"
                        >
                          Ok
                        </v-btn>
                      </v-date-picker>
                    </v-menu>
                  </div>
                </v-col>
                <v-col cols="12" class="pt-4">
                  <v-data-table
                    dense
                    :headers="dialogManifest.headers"
                    :items="dialogManifest.table.filter((f) => {
                      if (parseInt(manifestView) === 2) {
                        return true
                      } else if (parseInt(manifestView) === 1) {
                        return (parseInt(f.dispatch) || parseInt(f.courier)) && !f.departure
                      }
                      return (!f.manifest_arrival && !f.manifest_departure && !(parseInt(f.dispatch) || parseInt(f.courier))) ? true : false
                    })"
                    :server-items-length="dialogManifest.tableTotal"
                    :page.sync="dialogManifest.tablePage"
                    :items-per-page.sync="dialogManifest.tableLimit"
                    :options.sync="dialogManifest.options"
                    :footer-props="{
                      itemsPerPageOptions: [100]
                    }"
                    :loading="dialogManifest.loading"
                    loading-text="Loading... Please wait"
                  >
                    <template v-slot:[`item.id`]="{ item }">
                      <div class="py-2">
                        <div class="d-flex align-center text-uppercase">
                          <!-- <v-icon class="mr-1">
                            mdi-barcode
                          </v-icon> -->
                          <span class="font-weight-bold caption">
                            [{{ item.manifest_arrival ? 'IN' : (item.manifest_departure ? 'OUT' : '-') }}]
                            MANIFEST/{{ item.store_origin_code }}/{{ item.store_destination_code }}{{ item.vendor_code ? ('/' + item.vendor_code) : '' }}/{{ item.id }}
                          </span>
                        </div>
                        <span v-if="item.manifest_ext_id" class="d-flex align-center caption secondary--text font-weight-bold">
                          <v-icon small class="mr-1">
                            mdi-ticket-confirmation-outline
                          </v-icon>
                          <div style="line-height: 120%;">
                            <div class="grey--text text--darken-2 font-weight-regular" style="font-size: .6rem;">
                              VENDOR AWB/RESI :
                            </div>
                            {{ item.manifest_ext_id || '-' }}
                          </div>
                        </span>
                        <div class="d-flex align-center caption">
                          <v-icon small class="mr-1">
                            mdi-calendar-outline
                          </v-icon>
                          {{ $localDT(item.created, 'datetime') }}
                        </div>
                        <div class="d-flex align-center">
                          <v-icon small class="mr-1">
                            mdi-note-text-outline
                          </v-icon>
                          {{ item.notes || '-' }}
                        </div>
                        <div v-if="((item.vendor_name || item.courier_detail || '-').trim() && (item.vendor_name || item.courier_detail || '-').trim() !== ',') || item.vendor_name" class="d-flex flex-column py-2">
                          {{ (item.vendor_name || item.courier_detail || '-').trim() === ',' ? '' : (item.vendor_name || item.courier_detail || '-').trim() }}
                          <div v-if="item.vendor_name" class="caption grey--text">
                            {{ $price(item.price) }}
                          </div>
                        </div>
                        <div class="d-flex align-center justify-space-between caption">
                          <div v-if="parseInt(item.unit_quantity_sum)">
                            <v-chip x-small class="font-weight-bold">
                              {{ item.unit_weight || '~' }}KG, {{ item.unit_quantity_sum }} UNIT in {{ item.unit_quantity }} PKG
                            </v-chip>
                          </div>
                          <v-divider v-if="parseInt(item.unit_quantity_sum) && parseInt(item.unitnon_quantity_sum)" vertical />
                          <div v-if="parseInt(item.unitnon_quantity_sum)">
                            <v-chip x-small class="font-weight-bold">
                              {{ item.unitnon_weight || '~' }}KG, {{ item.unitnon_quantity_sum }} ITEM in {{ item.unitnon_quantity }} PKG
                            </v-chip>
                          </div>
                        </div>
                      </div>
                    </template>
                    <template v-slot:[`item.shipping_total`]="{ item }">
                      <div class="text-center">
                        {{ parseInt(item.shipping_total) }}
                      </div>
                    </template>
                    <template v-slot:[`item.store_origin`]="{ item }">
                      <div class="d-flex flex-column py-2">
                        {{ item.type === 'courier' ? 'COURIER -' : '' }}{{ item.store_origin_name || '-' }}
                        <div class="caption">
                          {{ item.store_origin_city || '-' }}
                        </div>
                        <div class="caption d-flex align-center">
                          <!-- <v-icon x-small class="mr-1" color="pink">
                            mdi-clock-time-five-outline
                          </v-icon> -->
                          {{ item.manifest_departure ? $localDT(item.manifest_departure, 'datetime') : '~' }}
                        </div>
                      </div>
                    </template>
                    <template v-slot:[`item.store_destination`]="{ item }">
                      <div class="d-flex flex-column py-2">
                        {{ item.type === 'courier' ? 'COURIER -' : '' }}{{ item.store_destination_name || '-' }}
                        <div class="caption">
                          {{ item.store_destination_city || '-' }}
                        </div>
                        <div class="caption d-flex align-center">
                          <!-- <v-icon x-small class="mr-1" color="pink">
                            mdi-clock-time-five-outline
                          </v-icon> -->
                          <span v-if="item.manifest_arrival">
                            {{ $localDT(item.manifest_arrival, 'datetime') }}
                          </span>
                          <v-chip v-else-if="item.type === 'courier'" x-small color="secondary">
                            On Process by Courier
                          </v-chip>
                          <span v-else>
                            ~
                          </span>
                        </div>
                      </div>
                    </template>
                    <template v-slot:[`item.option`]="{ item }">
                      <div class="d-flex flex-column align-end" style="min-width: 100px;">
                        <v-menu v-if="!parseInt(item.courier) && !parseInt(item.dispatch) && (!item.manifest_arrival && !item.manifest_departure)" offset-y rounded="b-lg">
                          <template v-slot:activator="{ on, attrs }">
                            <v-btn
                              depressed
                              x-small
                              dark
                              color="primary"
                              class="text-capitalize mb-2 rounded-pill"
                              v-bind="attrs"
                              v-on="on"
                            >
                              SET TRANSPORT
                              <v-icon class="ml-1" x-small>
                                mdi-chevron-down
                              </v-icon>
                            </v-btn>
                          </template>
                          <div dense v-if="!dispatchData.length" class="px-4 pt-4 white text-center caption">
                            no transport data
                          </div>
                          <v-list dense>
                            <v-list-item v-for="(dd, iDd) in dispatchData" :key="'dispatch-to-' + iDd" @click.prevent="MANIFEST_DISPATCH(item.id, dd.id, '#' + dd.id + (dd.dispatch_vehicle_name ? (dd.dispatch_vehicle_name + ' ' + dd.dispatch_vehicle_plat_number) : dd.dispatch_vehicle_notes))">
                              <v-list-item-title class="align-center">
                                <v-icon small class="mr-1">
                                  mdi-cube-send
                                </v-icon>
                                #{{ dd.id }} {{ dd.dispatch_vehicle_name ? (dd.dispatch_vehicle_name + ' ' + dd.dispatch_vehicle_plat_number) : dd.dispatch_vehicle_notes }}
                              </v-list-item-title>
                            </v-list-item>
                          </v-list>
                        </v-menu>
                        <v-chip v-else-if="parseInt(item.dispatch) && !item.departure" color="green" class="mb-1" dark x-small @click.prevent="MANIFEST_DISPATCH(item.id)">
                          <v-icon class="mr-1" style="font-size: .7rem;">
                            mdi-check
                          </v-icon>
                          Transported : "{{ item.dispatch_name }}"
                        </v-chip>
                        <v-btn v-if="(parseInt(item.dispatch) || parseInt(item.courier)) && !item.departure" text x-small dark color="primary" class="font-weight-bold" @click.prevent="MANIFEST_SHOW(item)">
                          SET MANIFEST OUT
                        </v-btn>
                        <v-btn text small dark color="orange" class="mb-2 text-capitalize" @click.prevent="MANIFEST_SHOW(item)">
                          Detail
                        </v-btn>
                        <v-btn x-small dark depressed color="indigo" class="rounded-pill text-capitalize" @click.prevent="PRINT(item, true)">
                          <v-icon class="mr-2" x-small>
                            mdi-tray-full
                          </v-icon>
                          Print
                        </v-btn>
                      </div>
                    </template>
                  </v-data-table>
                </v-col>
              </v-row>
            </v-col>
            <v-col cols="12" class="col-sm-5">
              <div class="d-flex align-center justify-space-between fill-width title pt-5 pb-2">
                # TRANSPORT CABANG TO CABANG
                <v-btn depressed color="secondary" dark small class="rounded" @click.prevent="DISPATCH_SHOW()">
                  <v-icon x-small class="mr-2">
                    mdi-plus
                  </v-icon>
                  Add
                </v-btn>
              </div>
              <Dispatch :items="dispatchData" @show="DISPATCH_SHOW" @reload="DISPATCH_LOAD()" />
              <v-dialog
                v-model="dialogDispatch.show"
                persistent
                scrollable
                max-width="450"
              >
                <v-card v-if="dialogDispatch.data" class="px-4">
                  <v-card-title class="body-1 justify-center text-uppercase font-weight-bold">
                    {{ parseInt(dialogDispatch.data.id) ? 'DETAIL' : 'BUAT' }} TRANSPORT
                  </v-card-title>
                  <v-divider />
                  <v-card-text class="py-4 px-0" style="max-height: 90vh;overflow:hidden;">
                    <v-text-field
                      v-model="dialogDispatch.data.dispatch_vehicle_notes"
                      outlined
                      dense
                      hide-details
                      class="mb-4"
                      label="Transport Name"
                    />
                    <v-row class="py-4">
                      <v-col cols="12" class="col-sm-6 py-0">
                        <v-select
                          v-model.number="dialogDispatch.data.store_origin"
                          :items="$store.state.storeData.filter(r => !parseInt(r.type))"
                          item-text="name"
                          item-value="id"
                          outlined
                          dense
                          hide-details
                          class="mb-4"
                          label="Asal Cabang"
                          @change="PRICING_GET()"
                        />
                      </v-col>
                      <v-col cols="12" class="col-sm-6 py-0">
                        <v-select
                          v-model.number="dialogDispatch.data.store_destination"
                          :items="$store.state.storeData.filter(r => !parseInt(r.type))"
                          item-text="name"
                          item-value="id"
                          outlined
                          dense
                          hide-details
                          class="mb-4"
                          label="Tujuan Cabang"
                          @change="PRICING_GET()"
                        />
                      </v-col>
                    </v-row>
                    <v-select
                      v-model.number="dialogDispatch.data.vendor"
                      :items="[{ id: 0, name: '- Transport Internal -' }].concat($store.state.storeData.filter(r => parseInt(r.type)))"
                      item-text="name"
                      item-value="id"
                      outlined
                      hide-details
                      dense
                      class="d-block mb-4"
                      label="Vendor Transport"
                      @change="PRICING_GET()"
                    />
                    <v-autocomplete
                      v-if="parseInt(dialogDispatch.data.vendor)"
                      v-model.number="dialogDispatch.data.vendor_price_id"
                      :name="Math.random()"
                      :search-input.sync="pricingDataQuery"
                      :items="[{ id: 0, city_fullname: 'Custom Price' }].concat(pricingData)"
                      item-text="city_fullname"
                      item-value="id"
                      outlined
                      dense
                      hide-details
                      clearable
                      class="d-block mb-4"
                      label="Cari Harga Vendor"
                      @click:clear="dialogDispatch.data.vendor_price_id = 0, dialogDispatch.data.price = 0"
                      @change="SetPrice()"
                    >
                      <template v-slot:item="{ item }">
                        <v-list-item-content>
                          <v-list-item-title v-if="parseInt(item.id)" class="flex-column">
                            <div class="d-flex align-center">
                              <v-icon small color="grey" class="mr-1">
                                mdi-map-marker-radius-outline
                              </v-icon>
                              {{ item.city_origin_name }}
                            </div>
                            <div class="d-flex align-center">
                              <v-icon small color="primary" class="mr-1">
                                mdi-map-marker-check
                              </v-icon>
                              {{ item.city_destination_name }}
                            </div>
                            <div class="d-flex align-center pl-1">
                              <v-icon x-small color="primary" class="mr-1">
                                mdi-note-outline
                              </v-icon>
                              {{ item.notes || '-' }}
                            </div>
                          </v-list-item-title>
                          <v-list-item-title v-else class="flex-column">
                            <div class="d-flex align-center">
                              <v-icon class="mr-2">
                                mdi-minus
                              </v-icon>
                              Custom Pricing
                            </div>
                          </v-list-item-title>
                        </v-list-item-content>
                        <v-list-item-action v-if="parseInt(item.id)">
                          <v-chip small>
                            {{ $price(item.price) }}/{{ item.type }}
                          </v-chip>
                        </v-list-item-action>
                      </template>
                    </v-autocomplete>
                    <v-text-field
                      v-if="parseInt(dialogDispatch.data.vendor)"
                      v-model.number="dialogDispatch.data.price"
                      :name="Math.random()"
                      outlined
                      dense
                      hide-details
                      class="d-block mb-4"
                      prefix="Rp"
                      label="Harga : untuk tagihan vendor"
                      @keypress="$NumOnly"
                    />
                    <v-text-field
                      v-model="dialogDispatch.data.vendor_awb"
                      outlined
                      dense
                      hide-details
                      class="mb-4"
                      label="AWB (opsional)"
                    />
                    <v-textarea
                      v-model="dialogDispatch.data.notes"
                      outlined
                      rows="2"
                      dense
                      hide-details
                      label="Catatan"
                    />
                  </v-card-text>
                  <v-divider />
                  <v-card-actions class="px-0">
                    <v-btn
                      color="red darken-1"
                      text
                      @click="dialogDispatch.show = false"
                    >
                      Close
                    </v-btn>
                    <v-spacer />
                    <v-btn
                      color="primary"
                      dark
                      depressed
                      @click="DISPATCH_PROCESS()"
                    >
                      Simpan
                    </v-btn>
                  </v-card-actions>
                </v-card>
              </v-dialog>
            </v-col>
          </v-row>
        </v-card-text>
        <v-divider />
        <v-card-actions>
          <v-spacer />
          <v-btn
            color="red darken-1"
            text
            @click="SHIPPING_GET(tableSearch), dialogManifest.show = false"
          >
            Close
          </v-btn>
          <v-spacer />
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog
      v-model="dialogManifestData.show"
      persistent
      scrollable
      max-width="750"
    >
      <v-card v-if="dialogManifestData.data">
        <v-card-title class="body-1 justify-center text-uppercase font-weight-bold">
          {{ dialogManifestData.data.id ? 'DETAIL' : '+ CREATE MANIFEST' }}
          {{
            parseInt(dialogManifestData.data.id)
              ? (
                  '#MANIFEST/' + dialogManifestData.data.store_origin_code + '/' + dialogManifestData.data.store_destination_code + (dialogManifestData.data.vendor_code ? ('/' + dialogManifestData.data.vendor_code) : '') +  '/' + dialogManifestData.data.id
                )
                : ''
          }}
        </v-card-title>
        <v-divider />
        <v-card-text class="pt-4 px-2 px-sm-4" style="max-height: 90vh;">
          <v-row>
            <v-col cols="12" class="col-sm-12 pt-0">
              <div v-if="!(parseInt(parseInt(dialogManifestData.data.id)) && dialogManifestData.data.departure)" class="d-flex fill-width pt-4" style="border-radius: 4px!important;overflow:hidden;">
                <v-btn :disabled="parseInt(parseInt(dialogManifestData.data.id)) && dialogManifestData.data.departure ? true : false" :class="[dialogManifestData.data.type === 'courier' ? '' : 'primary']" class="d-block rounded-0 font-weight-bold" depressed style="width: 50%;" @click.prevent="dialogManifestData.data.type = null, dialogManifestData.data.courier = 0, dialogManifestData.data.store_destination = -1">
                  MANIFEST
                </v-btn>
                <v-btn :disabled="parseInt(parseInt(dialogManifestData.data.id)) && dialogManifestData.data.departure ? true : false" :class="[dialogManifestData.data.type === 'courier' ? 'primary' : '']" class="d-block rounded-0 font-weight-bold" depressed style="width: 50%;" @click.prevent="dialogManifestData.data.type = 'courier', dialogManifestData.data.store_destination = parseInt(dialogManifestData.data.store_origin)">
                  DISPATCH COURIER
                </v-btn>
              </div>
            </v-col>
            <v-col v-if="dialogManifestData.data.type === 'courier'" cols="12" class="col-sm-12">
              <v-autocomplete
                v-model.number="dialogManifestData.data.courier"
                :disabled="(parseInt(dialogManifestData.data.id) && dialogManifestData.data.departure) ? true : false"
                :name="Math.random()"
                :search-input.sync="dataPickupQuery"
                :items="dataPickup"
                item-value="id"
                item-text="user_detail"
                outlined
                dense
                hide-details
                label="Assign Courier"
                clearable
                autocomplete="disabled"
              />
            </v-col>
            <v-col cols="12" class="col-sm-6">
              <v-autocomplete
                v-model.number="dialogManifestData.data.store_origin"
                :disabled="(parseInt(dialogManifestData.data.id) && dialogManifestData.data.departure) ? true : false"
                :items="$store.state.storeData.filter(r => !parseInt(r.type))"
                item-text="name"
                item-value="id"
                outlined
                dense
                hide-details
                label="Pilih Asal Cabang"
                @change="dialogManifestData.data.type = 'courier', dialogManifestData.data.store_destination = parseInt(dialogManifestData.data.store_origin)"
              />
            </v-col>
            <v-col cols="12" class="col-sm-6">
              <v-autocomplete
                v-model.number="dialogManifestData.data.store_destination"
                :disabled="(dialogManifestData.data.type === 'courier' || (parseInt(dialogManifestData.data.id) && dialogManifestData.data.departure)) ? true : false"
                :items="$store.state.storeData.filter(r => !parseInt(r.type) && (dialogManifestData.data.type === 'courier' ? true : (parseInt(r.id) !== parseInt(dialogManifestData.data.store_origin))))"
                item-text="name"
                item-value="id"
                outlined
                dense
                hide-details
                label="Pilih Tujuan Cabang"
              />
            </v-col>
            <v-col cols="12" class="py-1">
              <v-divider />
            </v-col>
            <v-col cols="12" class="pt-1 pb-3">
              <div class="d-flex flex-column-reverse flex-sm-row align-center justify-space-between pb-1" style="border-bottom: solid 1px #eee;">
                <div v-if="dialogManifestData.data.departure && !dialogManifestData.data.arrival" class="d-flex align-center rounded-lg grey lighten-4 p-1 my-1">
                  <v-text-field
                    v-model="MANIFESTTTKLISTQUERY"
                    dense
                    hide-details
                    class="d-block transparent"
                    style="min-width:120px;"
                    flat
                    solo
                    clearable
                    label="Search ttk"
                  />
                  <span class="d-flex align-center pl-2 pr-2 c-pointer" @click="dialogScanTTK.show = !dialogScanTTK.show">
                    <v-icon class="mr-1" :color="dialogScanTTK.show ? 'red' : 'black'">
                      {{ dialogScanTTK.show ? 'mdi-close' : 'mdi-barcode' }}
                    </v-icon>
                    {{ dialogScanTTK.show ? 'CLOSE' : 'SCAN' }}
                  </span>
                  <div style="max-width:250px;">
                    <StreamBarcodeReader
                      v-if="dialogScanTTK.show"
                      @decode="onDecodeScannerTTK"
                      @loaded="onLoadedScannerTTK"
                    />
                  </div>
                </div>
                <div v-else>
                  TTK LIST
                </div>
                <div v-if="!dialogScanTTK.show && dialogManifestData.data.departure && !dialogManifestData.data.arrival" class="d-flex align-center justify-end">
                  <v-btn :loading="loadingPlanAction" small depressed color="green" dark class="ml-2 text-caption font-weight-bold"
                    @click.prevent="PlanAction('bulk', 0, parseInt(dialogManifestData.data.id), 0, 1, 0)"
                  >
                    DITERIMA
                  </v-btn>
                  <v-btn :loading="loadingPlanAction" small depressed color="orange" dark class="ml-2 text-caption font-weight-bold"
                    @click.prevent="PlanAction('bulk', 0, parseInt(dialogManifestData.data.id), 0, 1, 1)"
                  >
                    TERLAMBAT
                  </v-btn>
                  <v-btn :loading="loadingPlanAction" small depressed color="brown" dark class="ml-2 text-caption font-weight-bold"
                    @click.prevent="PlanAction('bulk', 0, parseInt(dialogManifestData.data.id), 0, 1, 2)"
                  >
                    RUSAK
                  </v-btn>
                  <v-btn :loading="loadingPlanAction" small depressed color="red" dark class="ml-2 text-caption font-weight-bold"
                    @click.prevent="PlanAction('bulk', 0, parseInt(dialogManifestData.data.id), 0, 1, 3)"
                  >
                    INVESTIGASI
                  </v-btn>
                </div>
              </div>
              <div class="grey lighten-4 rounded px-3 py-1" :style="{ overflow: (loadingPlanAction ? 'hidden' : 'auto') }" style="position:relative;height: calc(100vh - 441px);">
                <transition>
                  <div
                    v-if="loadingPlanAction"
                    class="d-flex align-center justify-center bg-glass font-weight-bold title primary--text"
                    style="position: absolute;top: 0px;left:0px;width:100%;height:100%;background-color:rgba(200,200,200,.6);z-index:1;transition:all .3s ease-in-out;"
                  >
                    PROCESSING
                  </div>
                </transition>
                <div v-for="(m, iM) in (
                  parseInt(dialogManifestData.data.id)
                    ? ((dialogManifestData.list || []).filter(r => (MANIFESTTTKLISTQUERY ? r.ttk === MANIFESTTTKLISTQUERY : true)))
                    : dataSelected
                  )" :key="'manifest-data-list-' + iM" class="px-4 py-2 rounded my-2 white">
                  <div class="font-weight-bold d-flex fill-width justify-space-between align-center">
                    <span class="primary--text">
                      {{ m.ttk || '-' }}
                    </span>
                    <div class="d-flex align-center text-right justify-end">
                      <span v-if="m.master_count_type === 'UNIT'" class="secondary--text caption font-weight-regular">
                        {{ $price(m.master_price_final) }}
                      </span>
                      <span v-else class="secondary--text caption font-weight-regular">
                        {{ $price(m.price_final) }}
                        <!-- {{ $price(m.price_final) }} ({{ $countShippingWeight(m) + ' KG' + (m.type === 'KUBIK' ? ' in KUBIK' : '') }}) -->
                      </span>
                      <span class="mx-1">
                        |
                      </span>
                      <div v-if="parseInt(m.product_is_unit)" class="d-flex align-center">
                        <span class="orange--text caption font-weight-regular">
                          Qty : {{ (m.shipping_package_quantity_sum + ' UNITS in ' + m.shipping_package_quantity + ' PKG') || '~' }}
                        </span>
                      </div>
                      <div v-else class="d-flex align-center">
                        <span class="orange--text caption font-weight-regular">
                          {{ (m.weight_chargeable + ' kg') }}
                        </span>
                        <span class="mx-1">
                          |
                        </span>
                        <span class="orange--text caption font-weight-regular">
                          Qty : {{ (m.shipping_package_quantity_sum + ' ITEMS in ' + m.shipping_package_quantity + ' PKG') || '~' }}
                        </span>
                      </div>
                      <!-- shipping_package -->
                    </div>
                  </div>
                  <v-divider class="my-1" />
                  <div class="d-flex align-center justify-space-between">
                    <div style="width: 40%;">
                      {{ m.shipping_sender_name || '-' }}
                      <div class="caption">
                        {{ m.shipping_sender_phone }}
                      </div>
                      <div class="caption">
                        {{ m.shipping_origin_city_name }} {{ m.shipping_origin_city_type }}
                      </div>
                    </div>
                    <div style="width: 20%;" class="text-center">
                      <v-icon class="mx-2" small>
                        mdi-chevron-right
                      </v-icon>
                    </div>
                    <div style="width: 40%;">
                      {{ m.shipping_name || '-' }}
                      <div class="caption">
                        {{ m.shipping_phone }}
                      </div>
                      <div class="caption">
                        {{ m.shipping_address }}, {{ m.shipping_destination_city_name }} {{ m.shipping_destination_city_type }}
                      </div>
                    </div>
                  </div>
                  <v-divider class="mt-1 mb-2" />
                  <div class="fill-width d-flex align-center justify-center">
                    <input v-model="(parseInt(dialogManifestData.data.id) ? dialogManifestData.list : dataSelected)[iM].vendor_awb" type="text" placeholder="AWB VENDOR" class="block fill-width px-2 py-1 uppercase text-center" style="background-color:rgba(0, 0, 0, .05);border-radius:4px;">
                  </div>
                  <v-divider class="mt-1 mb-2" />
                  <div v-if="$statusPlan(m.manifest_plan) && dialogManifestData.data.departure && !dialogManifestData.data.arrival && dialogManifestData.data.type !== 'courier'" class="d-flex align-center justify-space-between fill-width">
                    <div v-if="$statusPlan(m.manifest_plan).status_plan_img || (!dialogManifestData.data.departure && !dialogManifestData.data.arrival)" class="d-flex align-center justify-end">
                      <v-divider vertical class="mx-2" />
                      <v-btn v-if="$statusPlan(m.manifest_plan).status_plan_img" :href="$statusPlan(m.manifest_plan).status_plan_img" target="_blank" icon color="primary" x-small class="text-capitalize" @click.prevent="PlanAction('image', $statusPlan(m.manifest_plan).status_plan_img)">
                        <v-icon>
                          mdi-image
                        </v-icon>
                      </v-btn>
                      <v-btn v-else-if="!dialogManifestData.data.departure && !dialogManifestData.data.arrival" icon color="red" x-small class="text-capitalize" @click.prevent="PlanAction('delete', $statusPlan(m.manifest_plan).id, parseInt(dialogManifestData.data.id), m.id)">
                        <v-icon>
                          mdi-close
                        </v-icon>
                      </v-btn>
                      <span v-else icon color="red" x-small class="text-capitalize">
                        -
                      </span>
                    </div>
                    <div v-if="(parseInt(dialogManifestData.data.id) && dialogManifestData.data.departure && dialogManifestData.data.arrival)" :class="[!$statusPlan(m.manifest_plan).status_plan ? 'green--text' : 'red--text']" class="d-flex align-center justify-end font-weight-bold">
                      <v-icon class="mr-1" :color="!$statusPlan(m.manifest_plan).status_plan ? 'green' : 'red'" small>
                        {{ $statusPlan(m.manifest_plan).status_plan ? 'mdi-alert' : 'mdi-check-circle' }}
                      </v-icon>
                      {{ $statusPlan(m.manifest_plan).status_plan_text }}
                    </div>
                    <div v-else class="fill-width">
                      <div>
                        <v-text-field
                          v-model="dialogManifestData.list[iM].manifest_plan_notes"
                          :name="Math.random()"
                          outlined
                          dense
                          hide-details
                          class="d-block mb-2 fill-width"
                          prepend-inner-icon="mdi-note-text-outline"
                          label="Catatan"
                        />
                      </div>
                      <div class="d-flex align-center justify-end fill-width">
                        <v-btn
                          :disabled="!(dialogManifestData.data.departure && !dialogManifestData.data.arrival)"
                          :color="parseInt($statusPlan(m.manifest_plan).status) && !parseInt($statusPlan(m.manifest_plan).status_plan) ? 'green' : ''"
                          :dark="(parseInt($statusPlan(m.manifest_plan).status) && !parseInt($statusPlan(m.manifest_plan).status_plan)) ? true : false"
                          depressed
                          small
                          class="text-capitalize mr-2"
                          @click.prevent="PlanAction(
                            'update',
                            $statusPlan(m.manifest_plan).id,
                            parseInt(dialogManifestData.data.id),
                            m.id,
                            1,
                            0
                          )"
                        >
                          DITERIMA
                        </v-btn>
                        <v-btn
                          :disabled="!(dialogManifestData.data.departure && !dialogManifestData.data.arrival)"
                          :color="parseInt($statusPlan(m.manifest_plan).status) && parseInt($statusPlan(m.manifest_plan).status_plan) === 1 ? 'orange' : ''"
                          :dark="(parseInt($statusPlan(m.manifest_plan).status) && parseInt($statusPlan(m.manifest_plan).status_plan) === 1) ? true : false"
                          depressed
                          small
                          class="text-capitalize"
                          @click.prevent="PlanAction(
                            'update',
                            $statusPlan(m.manifest_plan).id,
                            parseInt(dialogManifestData.data.id),
                            m.id,
                            1,
                            1
                          )"
                        >
                          DITERIMA [TERLAMBAT]
                        </v-btn>
                        <v-btn
                          :disabled="!(dialogManifestData.data.departure && !dialogManifestData.data.arrival)"
                          :color="parseInt($statusPlan(m.manifest_plan).status) && parseInt($statusPlan(m.manifest_plan).status_plan) === 2 ? 'brown' : ''"
                          :dark="(parseInt($statusPlan(m.manifest_plan).status) && parseInt($statusPlan(m.manifest_plan).status_plan) === 2) ? true : false"
                          depressed
                          small
                          class="text-capitalize mx-2"
                          @click.prevent="PlanAction(
                            'update',
                            $statusPlan(m.manifest_plan).id,
                            parseInt(dialogManifestData.data.id),
                            m.id,
                            1,
                            2
                          )"
                        >
                          DITERIMA [RUSAK]
                        </v-btn>
                        <v-btn
                          :disabled="!(dialogManifestData.data.departure && !dialogManifestData.data.arrival)"
                          :color="parseInt($statusPlan(m.manifest_plan).status) && parseInt($statusPlan(m.manifest_plan).status_plan) === 3 ? 'red' : ''"
                          :dark="(parseInt($statusPlan(m.manifest_plan).status) && parseInt($statusPlan(m.manifest_plan).status_plan) === 3) ? true : false"
                          depressed
                          small
                          class="text-capitalize"
                          @click.prevent="PlanAction(
                            'update',
                            $statusPlan(m.manifest_plan).id,
                            parseInt(dialogManifestData.data.id),
                            m.id,
                            1,
                            3
                          )"
                        >
                          INVESTIGASI
                        </v-btn>
                      </div>
                    </div>
                  </div>
                  <div v-else class="d-flex align-center justify-space-between fill-width">
                    <div class="d-flex align-center">
                    </div>
                    <div class="d-flex align-center justify-end">
                      <v-divider vertical class="mx-2" />
                      <v-btn v-if="!dialogManifestData.data.departure && !dialogManifestData.data.arrival" icon color="red" x-small class="text-capitalize" @click.prevent="PlanAction('delete', null, null, m.id)">
                        <v-icon>
                          mdi-close
                        </v-icon>
                      </v-btn>
                    </div>
                  </div>
                </div>
              </div>
            </v-col>
            <v-col cols="12" class="py-1">
              <v-divider class="mb-2" />
              <div class="d-flex fill-width align-center justify-space-between">
                <div class="d-flex align-center" style="width: calc(50% - 32px);">
                  CHARGEABLE WEIGHT : {{ ManifestWeight.weight_chargeable || 0 }}Kg
                </div>
                <div class="d-flex align-center text-enter" style="width: 64px;">
                  SUMMARY
                </div>
                <div class="d-flex justify-end text-right" style="width: calc(50% - 32px);">
                  <div>
                    NON-UNIT: {{ ManifestWeight.weight_sum + '/' + ManifestWeight.weight }}
                  </div>
                  <div class="ml-2">
                    UNIT: {{ ManifestWeight.unit_sum + '/' + ManifestWeight.unit }}
                  </div>
                </div>
              </div>
            </v-col>
            <v-col v-if="false" cols="12">
              <v-select
                v-model.number="dialogManifestData.data.vendor"
                :disabled="(parseInt(dialogManifestData.data.id) && dialogManifestData.data.departure) ? true : false"
                :items="[{ id: 0, name: '- Tanpa Vendor -' }].concat($store.state.storeData.filter(r => parseInt(r.type)))"
                item-text="name"
                item-value="id"
                outlined
                dense
                hide-details
                class="d-block mb-4"
                label="Eksternal Vendor (opsional jika memakai eksternal vendor)"
                @change="
                  dialogManifestData.data.city_origin = 0,
                  dialogManifestData.data.city_origin_name = '',
                  dialogManifestData.data.city_destination = 0,
                  dialogManifestData.data.city_destination_name = '',
                  dialogManifestData.data.manifest_ext_id = '',
                  pricingDataQuery = '',
                  pricingData = [],
                  dialogManifestData.data.price = 0,
                  parseInt(dialogManifestData.data.vendor) ? PRICING_GET() : ''
                "
              />
              <v-autocomplete
                v-if="parseInt(dialogManifestData.data.vendor)"
                :disabled="(parseInt(dialogManifestData.data.id) && dialogManifestData.departure && dialogManifestData.arrival) ? true : false"
                v-model.number="dialogManifestData.data.vendor_price_selected"
                :name="Math.random()"
                :search-input.sync="pricingDataQuery"
                :items="[{ id: 0, city_fullname: 'Custom Price' }].concat(pricingData)"
                item-text="city_fullname"
                item-value="id"
                outlined
                dense
                hide-details
                clearable
                class="d-block mb-4"
                label="Cari Harga Vendor"
                @click:clear="dialogManifestData.data.vendor_price_selected = 0, dialogManifestData.data.price = 0"
                @change="SetPrice()"
              >
                <template v-slot:item="{ item }">
                  <v-list-item-content>
                    <v-list-item-title v-if="parseInt(item.id)" class="flex-column">
                      <div class="d-flex align-center">
                        <v-icon small color="grey" class="mr-1">
                          mdi-map-marker-radius-outline
                        </v-icon>
                        {{ item.city_origin_name }}
                      </div>
                      <div class="d-flex align-center">
                        <v-icon small color="primary" class="mr-1">
                          mdi-map-marker-check
                        </v-icon>
                        {{ item.city_destination_name }}
                      </div>
                      <div class="d-flex align-center pl-1">
                        <v-icon x-small color="primary" class="mr-1">
                          mdi-note-outline
                        </v-icon>
                        {{ item.notes || '-' }}
                      </div>
                    </v-list-item-title>
                    <v-list-item-title v-else class="flex-column">
                      <div class="d-flex align-center">
                        <v-icon class="mr-2">
                          mdi-minus
                        </v-icon>
                        Custom Pricing
                      </div>
                    </v-list-item-title>
                  </v-list-item-content>
                  <v-list-item-action v-if="parseInt(item.id)">
                    <v-chip small>
                      {{ $price(item.price) }}/{{ item.type }}
                    </v-chip>
                  </v-list-item-action>
                </template>
              </v-autocomplete>
              <v-text-field
                v-if="parseInt(dialogManifestData.data.vendor)"
                v-model.number="dialogManifestData.data.price"
                :disabled="(!parseInt(dialogManifestData.data.vendor) || (parseInt(dialogManifestData.data.id) && dialogManifestData.data.departure)) ? true : false"
                :name="Math.random()"
                outlined
                dense
                hide-details
                class="d-block mb-4"
                prefix="Rp"
                label="Harga : untuk keperluan tagihan eksternal vendor"
                @keypress="$NumOnly"
              />
              <v-text-field
                v-if="parseInt(dialogManifestData.data.vendor)"
                v-model="dialogManifestData.data.manifest_ext_id"
                :disabled="(!parseInt(dialogManifestData.data.vendor) || (parseInt(dialogManifestData.data.id) && dialogManifestData.data.departure)) ? true : false"
                :name="Math.random()"
                outlined
                dense
                hide-details
                class="d-block"
                label="No AWB/Resi Vendor"
              />
            </v-col>
            <v-col cols="12" class="py-1">
              <v-divider />
            </v-col>
            <v-col cols="12" class="">
              <!-- :disabled="(parseInt(dialogManifestData.data.id) && dialogManifestData.data.departure) ? true : false" -->
              <v-textarea
                v-model="dialogManifestData.data.notes"
                rows="1"
                outlined
                dense
                hide-details
                label="Tulis catatan manifest"
              />
            </v-col>
          </v-row>
        </v-card-text>
        <v-divider />
        <v-card-actions>
          <v-btn
            :disabled="loadingPlanAction"
            color="orange"
            text
            class="text-capitalize"
            @click="dialogManifestData.show = false"
          >
            Close
          </v-btn>
          <v-spacer />
          <v-btn
            v-if="parseInt(dialogManifestData.data.id) && !dialogManifestData.data.departure && !dialogManifestData.data.arrival"
            color="red"
            text
            class="text-capitalize"
            @click="MANIFEST_DELETE(dialogManifestData.data.id)"
          >
            Delete
          </v-btn>
          <v-spacer v-if="!dialogManifestData.data.departure && !dialogManifestData.data.arrival" />
          <v-btn
            v-if="!parseInt(dialogManifestData.data.id)"
            :loading="dialogManifestData.loading"
            :disabled="
              (((parseInt(dialogManifestData.data.store_origin) === 0 || parseInt(dialogManifestData.data.store_origin) > 0)) && ((parseInt(dialogManifestData.data.store_destination) === 0 || parseInt(dialogManifestData.data.store_destination) > 0)) && ((parseInt(dialogManifestData.data.id) ? dialogManifestData.list : dataSelected)).length) ? false : ((!dialogManifestData.data.departure && !dialogManifestData.data.arrival) ? false : true)
            "
            depressed
            color="primary"
            class="px-4 text-capitalize font-weight-bold"
            @click.prevent="MANIFEST_PROCESS()"
          >
            {{ parseInt(dialogManifestData.data.id) ? 'Update' : 'Buat' }} Manifest
          </v-btn>
          <v-btn
            v-else-if="parseInt(dialogManifestData.data.id) && !dialogManifestData.data.departure && !dialogManifestData.data.arrival"
            :loading="dialogManifestData.loading"
            :disabled="
              (((parseInt(dialogManifestData.data.store_origin) === 0 || parseInt(dialogManifestData.data.store_origin) > 0)) && ((parseInt(dialogManifestData.data.store_destination) === 0 || parseInt(dialogManifestData.data.store_destination) > 0)) && ((parseInt(dialogManifestData.data.id) ? dialogManifestData.list : dataSelected)).length) ? false : ((!dialogManifestData.data.departure && !dialogManifestData.data.arrival) ? false : true)
            "
            text
            color="primary"
            class="px-4 text-capitalize font-weight-bold"
            @click.prevent="MANIFEST_PROCESS()"
          >
            {{ parseInt(dialogManifestData.data.id) ? 'Update' : 'Buat' }}
          </v-btn>
          <v-btn
            v-if="(parseInt(dialogManifestData.data.dispatch) || parseInt(dialogManifestData.data.courier)) && parseInt(parseInt(dialogManifestData.data.id)) && !(dialogManifestData.data.type === 'courier' && dialogManifestData.data.departure)"
            :loading="dialogManifestData.loading"
            :disabled="!IsConfirmedAll && !(!dialogManifestData.data.departure && !dialogManifestData.data.arrival) && !loadingPlanAction"
            depressed
            color="primary"
            class="px-4 text-capitalize font-weight-bold ml-4"
            @click.prevent="MANIFEST_PROCESS((!dialogManifestData.data.departure && !dialogManifestData.data.arrival) ? 'OUT' : 'IN')"
          >
            <span v-if="(parseInt(dialogManifestData.data.dispatch) || parseInt(dialogManifestData.data.courier)) && (!dialogManifestData.data.departure && !dialogManifestData.data.arrival)">
              SET MANIFEST OUT
            </span>
            <span v-else-if="!(!dialogManifestData.data.departure && !dialogManifestData.data.arrival)">
              CONFIRM MANIFEST
            </span>
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog
      v-model="dialogPayment.show"
      persistent
      scrollable
      max-width="750"
    >
      <v-card v-if="dialogPayment.selected">
        <v-card-title class="body-1 justify-center text-uppercase font-weight-bold">
          Pembayaran
        </v-card-title>
        <v-divider />
        <v-card-text class="pt-4 px-2 px-sm-4" style="max-height: 90vh;">
          <v-row class="flex-stretch">
            <v-col cols="12" class="col-sm-5 align-center">
              <v-select
                v-model="dialogPayment.new.payment_type"
                :items="[{ name: 'Cash', value: 'cash' }, { name: 'Bank Transfer', value: 'transfer' }, { name: 'Online (Xendit)', value: 'xendit' }]"
                item-text="name"
                item-value="value"
                outlined
                dense
                hide-details
                label="Tipe Pembayaran"
              />
            </v-col>
            <v-col cols="12" class="col-sm-5 align-center">
              <v-text-field
                v-model="dialogPayment.new.notes"
                outlined
                dense
                hide-details
                label="Notes"
              />
            </v-col>
            <v-col cols="12" class="col-sm-2 d-flex align-center justify-center">
              <v-btn :loading="dialogPayment.loading" depressed color="brown" dark class="text-capitalize" small @click.prevent="PaymentProcess()">
                Add Payment
              </v-btn>
            </v-col>
            <v-col v-if="dialogPayment.data.length && parseInt(dialogPayment.selected.id)" cols="12" class="pb-3 grey lighten-4">
              <v-card v-for="(p, iP) in dialogPayment.data" :key="'payment-history-' + iP" class="px-3 py-2 my-1 rounded-lg d-flex align-center justify-space-between white" outlined>
                <div class="">
                  <div class="d-flex align-center text-uppercase pr-2">
                    <v-icon class="mr-1">
                      mdi-cash
                    </v-icon>
                    <span class="font-weight-bold caption">
                      [{{ (p.payment_type || '').toUpperCase() }}] {{ p.notes || '-' }}
                    </span>
                    <div class="caption pl-2">
                      {{ $price(p.amount) }}
                    </div>
                  </div>
                  <div class="d-flex align-center caption grey--text text--lighten-1">
                    <v-icon class="mr-1" small color="grey lighten-1">
                      mdi-calendar-clock
                    </v-icon>
                    {{ $localDT(p.created, 'datetime') }}
                  </div>
                </div>
                <v-spacer />
                <v-btn v-if="p.payment_link && p.payment_type === 'xendit'" :href="p.payment_link" target="_blank" small outlined color="primary" class="text-capitalize rounded-pill white--text">
                  Payment Link
                </v-btn>
                <v-chip v-else-if="p.payment_type !== 'xendit'" :color="parseInt(p.status) ? 'green' : 'red'" x-small dark>
                  {{ parseInt(p.status) ? 'Sudah dibayar' : 'Belum dibayar' }}
                </v-chip>
              </v-card>
            </v-col>
          </v-row>
        </v-card-text>
        <v-divider />
        <v-card-actions>
          <v-spacer />
          <v-btn
            color="red darken-1"
            text
            @click="dialogPayment.show = false"
          >
            Close
          </v-btn>
          <v-spacer />
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog
      v-model="dialogPickup.show"
      persistent
      scrollable
      eager
      max-width="750"
    >
      <v-card>
        <v-card-title class="body-1 justify-center text-uppercase font-weight-bold">
          Pickup Request
        </v-card-title>
        <v-divider />
        <v-card-text class="pt-4 px-2 px-sm-4" style="max-height: 90vh;">
          <v-row>
            <PickupData @reload-shipping="SHIPPING_GET(tableSearch)" @pickup-total="dialogPickup.total = $event" />
          </v-row>
        </v-card-text>
        <v-divider />
        <v-card-actions>
          <v-spacer />
          <v-btn
            color="red darken-1"
            text
            @click="dialogPickup.show = false"
          >
            Close
          </v-btn>
          <v-spacer />
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog
      v-model="dialogCustomer.show"
      persistent
      scrollable
      max-width="420"
    >
      <v-card v-if="dialogCustomer.data" >
        <v-card-title class="body-1 justify-center">
          {{ dialogCustomer.data.id ? 'Update Data' : 'Tambah Customer Baru' }}
        </v-card-title>
        <v-divider />
        <v-card-text class="pt-4" style="max-height: calc(100vh - 200px)">
          <!-- <div class="d-flex fill-width justify-center pt-4 pb-8">
            <v-img
              :src="dialogCustomer.data.img || '/logo.png'"
              :lazy-src="dialogCustomer.data.img || '/logo.png'"
              :aspect-ratio="1"
              max-width="100"
              class="rounded-circle grey lighten-4 mr-4"
            />
          </div> -->
          <!-- <v-divider class="my-4" /> -->
          <v-row no-gutters>
            <v-col cols="12" class="pr-0 pr-sm-2">
              <v-text-field
                v-model="dialogCustomer.data.name"
                outlined
                dense
                hide-details
                label="Nama Lengkap (*)"
                class="mb-4 "
              />
              <v-text-field
                v-model="dialogCustomer.data.email"
                outlined
                dense
                hide-details
                label="Email"
                class="mb-4 "
              />
              <v-text-field
                v-model="dialogCustomer.data.phone"
                label="No Telepon (*)"
                dense
                outlined
                color="secondary"
                hide-details
                class="mb-4 "
                @keypress="$NumberOnly"
              />
              <v-textarea
                v-model="dialogCustomer.data.address"
                outlined
                rows="4"
                dense
                hide-details
                label="Alamat"
                class="mb-4 "
              />
              <v-autocomplete
                v-model.number="dialogCustomer.data.kecamatan_id"
                :name="Math.random()"
                :search-input.sync="areaquery"
                :items="areas"
                item-value="kecamatan_id"
                item-text="fullname"
                outlined
                dense
                hide-details
                label="Area (Kota, Provinsi)"
                class="mb-4"
                autocomplete="disabled"
              />
              <v-select
                v-model.number="dialogCustomer.data.type"
                :items="[
                  { name: 'Default', value: 0 },
                  { name: 'Business', value: 1 }
                ]"
                item-text="name"
                item-value="value"
                outlined
                dense
                hide-details
                class="mb-4 "
                label="Tipe Customer"
              />
              <v-select
                v-model.number="dialogCustomer.data.status"
                :items="[
                  { name: 'Non Aktif', value: 0 },
                  { name: 'Aktif', value: 1 }
                ]"
                item-text="name"
                item-value="value"
                outlined
                dense
                hide-details
                class=""
                label="Status"
              />
            </v-col>
          </v-row>
          <v-divider class="my-4" />
          <div class="mt-2 mb-0 pa-4 orange lighten-2 rounded-lg">
            <v-text-field
              v-model="dialogCustomer.data.password"
              label="Password Sementara / Reset Password"
              type="password"
              outlined
              dense
              hide-details
            />
          </div>
        </v-card-text>
        <v-divider />
        <v-card-actions>
          <v-btn
            color="orange darken-1"
            text
            class="text-capitalize"
            @click="dialogCustomer.show = false"
          >
            Close
          </v-btn>
          <v-spacer />
          <v-btn
            color="green darken-1"
            text
            class="text-capitalize"
            @click="CUSTOMER_PROCESS()"
          >
            Process
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog
      v-model="dialogProject.show"
      persistent
      scrollable
      max-width="420"
    >
      <v-card v-if="dialogProject.data" >
        <v-card-title class="body-1 justify-center">
          {{ dialogProject.data.id ? 'Update Data' : 'Tambah Project Baru' }}
        </v-card-title>
        <v-divider />
        <v-card-text class="pt-4" style="max-height: calc(100vh - 200px)">
          <v-row no-gutters>
            <v-col cols="12" class="pr-0 pr-sm-2">
              <v-text-field
                v-model="dialogProject.data.name"
                outlined
                dense
                hide-details
                label="Project Name (*)"
                class="mb-4 "
              />
            </v-col>
            <v-col cols="12" class="pr-0 pr-sm-2">
              <v-autocomplete
                v-model.number="dialogShipping.data.customer_billto"
                :disabled="parseInt(dialogShipping.data.id) ? true : false"
                :name="Math.random()"
                :search-input.sync="dataBilltoQuery"
                :items="dataBillto"
                item-value="id"
                item-text="customer_detail"
                outlined
                dense
                hide-details
                label="Customer (Project Owner)"
                clearable
                class="mb-0"
                autocomplete="disabled"
                @change="ReloadCustomer(2)"
              />
            </v-col>
          </v-row>
        </v-card-text>
        <v-divider />
        <v-card-actions>
          <v-btn
            color="orange darken-1"
            text
            class="text-capitalize"
            @click="dialogProject.show = false"
          >
            Close
          </v-btn>
          <v-spacer />
          <v-btn
            color="green darken-1"
            text
            class="text-capitalize"
            @click="PROJECT_PROCESS()"
          >
            Process
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <BusinessTTK :show="businessProjectShow" @close="businessProjectShow = false" />
    <DialogPrintPDF v-if="$store.state.dialogPrint.show" @complete="DOWNLOAD_RUNNER_DONE" />
  </v-container>
</template>

<script>
let searchAreaTimeout = null
let searchInterval = null
let searchIntervalManifest = null
let timeOutOrigin = null
let timeOutDestination = null
let timeOutPlanOrigin = null
let timeOutPlanDestination = null
let timeOutManifestOrigin = null
let timeOutManifestDestination = null
let timeOutProject = null
let timeOutProjectQuery = null
let timeOutCustomer = null
let timeOutRecipient = null
let timeOutBillto = null
let timeOutSales = null
let timeScan = null
export default {
  name: 'Customer',
  data: () => ({
    MANIFESTTTKLISTQUERY: null,
    dialogScanTTK: {
      show: false,
      data: null
    },
    pickupScan: {
      show: false,
      loading: false,
      data: null
    },
    isProjectBased: {
      v: false,
      sheets: null,
      isError: []
    },
    downloadRunnerStatus: false,
    businessProjectShow: false,
    dispatchData: [],
    printNoPrice: false,
    tableSearchSwitch: 0,
    dataSelected: [],
    menu: false,
    dates: [],
    summaryPrice: 0,
    headers: [
      { text: 'No TTK', value: 'ttk' },
      { text: 'Pengirim - Penerima', value: 'shipping_sender_name' },
      { text: 'Asal - Tujuan', value: 'shipping_origin_city_name' },
      { text: 'Ongkos Kirim', value: 'price_final' },
      { text: 'Pembayaran', value: 'amount_paid' },
      { text: 'Status', value: 'status' },
      { text: 'Opsi', value: 'option', sortable: false }
    ],
    tableSearch: '',
    tableLoading: false,
    tableTemp: [],
    tableTempCounter: 0,
    table: [],
    tableTotal: 0,
    tablePage: 1,
    tableLimit: 25,
    tableSearchStore: -1,
    tableSearchStatus: -1,
    options: {
      sortBy: ['created'],
      sortDesc: 'DESC',
      itemsPerPage: 50,
      page: 1
    },
    dialogPrint: {
      show: false,
      type: null,
      list: [],
      data: null
    },
    dialogShipping: {
      show: false,
      loading: false,
      data: null,
      pricingSelected: null,
      oldStatus: 0
    },
    manifestView: 0,
    dialogManifest: {
      search: '',
      show: false,
      type: '',
      loading: false,
      cabang: -1,
      vendor: -1,
      status: 0,
      menu: false,
      dates: [],
      headers: [
        { text: 'No', value: 'id', sortable: false },
        { text: 'TTK', value: 'shipping_total', sortable: false },
        { text: 'Asal', value: 'store_origin', sortable: false },
        { text: 'Tujuan', value: 'store_destination', sortable: false },
        { text: 'Opsi', value: 'option', sortable: false }
      ],
      tableSearch: '',
      tableLoading: false,
      table: [],
      tableTotal: 0,
      tablePage: 1,
      tableLimit: 100,
      tableSearchStatus: -1,
      options: {
        sortBy: ['id'],
        sortDesc: 'DESC',
        itemsPerPage: 25,
        page: 1
      }
    },
    dialogManifestData: {
      show: false,
      loading: false,
      data: null,
      newMaster: '',
      list: []
    },
    shippingOriginQuery: '',
    shippingOriginData: [],
    shippingDestinationQuery: '',
    shippingDestinationData: [],
    shippingPlanOriginQuery: '',
    shippingPlanOriginData: [],
    shippingPlanDestinationQuery: '',
    shippingPlanDestinationData: [],
    shippingManifestOriginQuery: '',
    shippingManifestOriginData: [],
    shippingManifestDestinationQuery: '',
    shippingManifestDestinationData: [],
    vendorData: [],
    dataProjectQuery: '',
    dataProject: [],
    pricingDataQuery: '',
    pricingData: [],
    dataCustomerQuery: '',
    dataCustomer: [],
    dataRecipientQuery: '',
    dataRecipient: [],
    dataBilltoQuery: '',
    dataBillto: [],
    dataSalesQuery: '',
    dataSales: [],
    dataPickupQuery: '',
    dataPickup: [],
    dialogPlan: {
      show: false,
      data: [],
      selected: null
    },
    newShippingPlanOrigin: 0,
    newShippingPlanDestination: 0,
    dialogPayment: {
      show: false,
      loading: false,
      data: [],
      selected: null,
      new: {
        payment_type: 'cash',
        notes: ''
      }
    },
    vendorSelected: {
      data: [],
      pricing: [],
      pricingSelected: null
    },
    manifestDataList: {
      search: '',
      data: []
    },
    productData: [],
    dialogDispatch: {
      show: false,
      data: null
    },
    dialogPickup: {
      show: false,
      total: 0,
      data: []
    },
    areaquery: '',
    areas: [],
    processCustomerLoading: false,
    dialogProject: {
      show: false,
      data: null
    },
    dialogCustomer: {
      show: false,
      data: null
    },
    loadingPlanAction: false,
    loadingDownload: false
  }),
  computed: {
    ParsingDownloadTtkTrackingData () {
      if (this.dialogPlan.show) {
        const data = []
        const d = this.dialogPlan.data || []
        for (let i = 0; i < d.length; i++) {
          const dp = Object.assign({}, d[i])
          if (dp.manifest_arrival && parseInt(dp.status_plan) !== 3) {
            if (dp.courier_detail && parseInt(dp.status)) {
              data.push({
                Date: new Date(dp.manifest_arrival).toISOString(),
                Status: 'DELIVERED',
                StatusText: 'DELIVERED TO ' + (dp.recipient_relation || '') + ', ' + dp.recipient_name || '' + ', ' + dp.recipient_notes || ''
              })
            } else {
              data.push({
                Date: new Date(dp.manifest_arrival).toISOString(),
                Status: 'MANIFEST IN',
                StatusText: (dp.store_destination_city_name || '') + ', ' + dp.recipient_name || ''
              })
            }
          }
          if (dp.manifest_departure) {
            if (dp.courier_detail) {
              data.push({
                Date: new Date(dp.manifest_departure).toISOString(),
                Status: 'PROCESS DELIVERY WITH COURIER',
                StatusText: (dp.courier_detail)
              })
            } else {
              data.push({
                Date: new Date(dp.manifest_departure).toISOString(),
                Status: dp.courier_detail ? 'ON DELIVERY WITH COURIER' : 'MANIFEST OUT',
                StatusText: (dp.store_origin_city_name || '')
              })
            }
          }
          if (dp.notes && ((dp.notes || 'X').split('[CANCELED]').length >= 2)) {
            data.push({
              Date: null,
              Status: 'CANCELED',
              StatusText: (dp.notes || '')
            })
          }
          data.push({
            Date: new Date(dp.created).toISOString(),
            Status: dp.courier_detail ? 'DISPATCH COURIER' : 'MANIFESTED',
            StatusText: (dp.store_origin_city_name || '')
          })
        }
        if (!parseInt(this.dialogPlan.selected.pickup) || (parseInt(this.dialogPlan.selected.pickup) && parseInt(this.dialogPlan.selected.pickup_handling) && this.dialogPlan.selected.pickup_end)) {
          if (this.dialogPlan.selected.notes && ((this.dialogPlan.selected.notes || 'X').split('[CANCELED]').length >= 2)) {
            data.push({
              Date: null,
              Status: 'CANCELED',
              StatusText: (this.dialogPlan.selected.notes || '')
            })
          }
          data.push({
            Date: parseInt(this.dialogPlan.selected.pickup) ? (new Date(this.dialogPlan.selected.pickup_end).toISOString()) : (new Date(this.dialogPlan.selected.created).toISOString()),
            Status: 'REGISTERED',
            StatusText: 'REGISTERED AT ' + this.dialogPlan.selected.shipping_origin_city_name + ', ' + this.dialogPlan.selected.shipping_origin_city_type
          })
        }
        return data
      }
      return []
    },
    ManifestWeight () {
      if (this.dialogManifestData.show) {
        const manifestList = (parseInt(this.dialogManifestData.data.id) ? this.dialogManifestData.list : this.dataSelected)
        const result = {
          unit: 0,
          unit_sum: 0,
          unit_weight: 0,
          weight: 0,
          weight_sum: 0,
          weight_chargeable: 0
        }
        for (let m = 0; m < manifestList.length; m++) {
          const ml = manifestList[m]
          if (parseInt(ml.product_is_unit)) {
            result.unit += parseInt(ml.shipping_package_quantity)
            result.unit_sum += parseInt(ml.shipping_package_quantity_sum)
            result.unit_weight += parseFloat(ml.weight_chargeable)
          } else {
            result.weight += parseInt(ml.shipping_package_quantity)
            result.weight_sum += parseInt(ml.shipping_package_quantity_sum)
            result.weight_chargeable += parseFloat(ml.weight_chargeable)
          }
        }
        return result
      }
      return {}
    },
    ManifestPrintWeight () {
      if (this.dialogPrint.show && this.dialogPrint.type === 'manifest') {
        const manifestList = this.dialogPrint.list
        const result = {
          unit: 0,
          unit_sum: 0,
          unit_weight: 0,
          weight: 0,
          weight_sum: 0,
          weight_chargeable: 0
        }
        for (let m = 0; m < manifestList.length; m++) {
          const ml = manifestList[m]
          if (parseInt(ml.product_is_unit)) {
            result.unit += parseInt(ml.shipping_package_quantity)
            result.unit_sum += parseInt(ml.shipping_package_quantity_sum)
            result.unit_weight += parseFloat(ml.weight_chargeable)
          } else {
            result.weight += parseInt(ml.shipping_package_quantity)
            result.weight_sum += parseInt(ml.shipping_package_quantity_sum)
            result.weight_chargeable += parseFloat(ml.weight_chargeable)
          }
        }
        return result
      }
      return {}
    },
    IsWeightMatch () {
      if (!this.pricingData.length) {
        return false
      }
      const a = this.pricingData.find((r) => parseInt(r.id) === parseInt(this.dialogShipping.data.price_id))
      if (a && parseInt(this.dialogShipping.data.price_id)) {
        if (parseFloat(a.weight_minimum) > (this.ChargeableWeightTotal * 1000)) {
          return false
        }
      }
      return true
    },
    IsConfirmedAll () {
      const data = this.dialogManifestData.list
      let confirmedStatusTotal = 0
      for (let m = 0; m < data.length; m++) {
        if (parseInt(this.$statusPlan(data[m].manifest_plan).status)) {
          confirmedStatusTotal++
        }
      }
      return confirmedStatusTotal === data.length
    },
    PrintItemTotal () {
      if ((this.dialogPrint.show && this.dialogPrint.data) || this.dialogShipping.data) {
        const data = this.$StrToArray(this.dialogPrint.show ? this.dialogPrint.data.shipping_package : this.dialogShipping.data.shipping_package)
        let quantity = 0
        let total = 0
        for (let d = 0; d < data.length; d++) {
          quantity += parseInt(data[d].quantity) || 0
          total += parseFloat(data[d].chargeable_weight) || 0
        }
        return {
          quantity,
          total
        }
      }
      return {}
    },
    ChargeableWeightTotal () {
      if (!this.dialogShipping.show || !this.productSelected) {
        return 0
      }
      let weightTotal = 0
      const data = this.$StrToArray(this.dialogShipping.data.shipping_package)
      for (let d = 0; d < data.length; d++) {
        const volumeMetric = this.$VolumeMetric(data[d], parseFloat(this.productSelected.div_amount) || 0) || 0
        const chargeableWeight = parseFloat(data[d].kg_actual) > parseFloat(volumeMetric) ? (parseFloat(data[d].kg_actual) || 0) : (parseFloat(volumeMetric) || 0)
        weightTotal += chargeableWeight
      }
      return Math.ceil(weightTotal)
    },
    filteredTable () {
      const table = this.table || []
      const rgx = new RegExp((this.tableSearch + '').toLowerCase().trim(), 'gi')
      return !this.tableSearch ? table : table.filter((r) => {
        const queryEcxplore = ((r.ttk || '-') + (r.shipping_name || '') + (r.shipping_phone || '') + (r.shipping_sender_name || '') + (r.shipping_sender_phone || '') + (r.customer_detail || '')).toLowerCase().trim().match(rgx)
        return queryEcxplore
      })
    },
    totalPrice () {
      const d = this.dialogShipping.data
      if (d && this.dialogShipping.show) {
        return (parseInt(d.price) || 0) + (parseInt(d.price_packaging) || 0) + (parseInt(d.price_other) || 0)
      }
      return 0
    },
    newShippingWeightActive () {
      const weight = parseFloat(this.dialogShipping.data.weight_kg_actual) || 0
      const length = parseFloat(this.dialogShipping.data.weight_volume_length) || 0
      const width = parseFloat(this.dialogShipping.data.weight_volume_width) || 0
      const height = parseFloat(this.dialogShipping.data.weight_volume_height) || 0

      let weightVolume = 0
      if (this.dialogShipping.data.type === 'UNIT') {
        return 1
      } else if (this.dialogShipping.data.type === 'KG') {
        return weight
      } else if (this.dialogShipping.data.type === 'KUBIK') {
        weightVolume = parseFloat(parseFloat((length * width * height) / 4000).toFixed(2))
      }

      if (length && width && height) {
        weightVolume = parseFloat(parseFloat((length * width * height) / 4000).toFixed(2))
      }
      if (weight && weightVolume) {
        return (weight > weightVolume) ? weight : weightVolume
      } else {
        return weight || weightVolume
      }
    },
    dateRangeText () {
      return this.dates.join(' ~ ')
    },
    dateRangeTextManifest () {
      return this.dialogManifest.dates.join(' ~ ')
    },
    selectedCustomer () {
      const customer = parseInt(this.dialogShipping.data.customer)
      if (customer) {
        return this.dataCustomer.find(r => parseInt(r.id) === customer) || {}
      }
      return {}
    },
    selectedRecipient () {
      const customer = parseInt(this.dialogShipping.data.recipient)
      if (customer) {
        return this.dataRecipient.find(r => parseInt(r.id) === customer) || {}
      }
      return {}
    },
    productSelected () {
      if (this.dialogShipping.show) {
        const product = this.productData.find(r => parseInt(r.id) === parseInt(this.dialogShipping.data.product))
        return product || {}
      }
      return {}
    }
  },
  watch: {
    'dialogManifest.cabang' () {
      this.MANIFEST_GET()
      this.DISPATCH_LOAD()
    },
    areaquery (v) {
      if (!v) {
        return
      }
      const findSelectedArea = this.areas.find(r => r.fullname === v)
      if (findSelectedArea) {
        return
      }
      if (searchAreaTimeout) {
        clearTimeout(searchAreaTimeout)
      }
      searchAreaTimeout = setTimeout(() => {
        this.areaGet('?q=' + v)
        clearTimeout(searchAreaTimeout)
      }, 300)
    },
    $route: {
      immediate: true,
      handler (to, from) {
        this.dates = [this.$TodayDate(), this.$TodayDate()]
      }
    },
    ChargeableWeightTotal () {
      this.SetPrice()
    },
    tableSearchSwitch (v) {
      if (!v) {
        this.table = []
        this.tableTotal = 0
      }
      this.tableSearch = ''
      this.dataSelected = []
      this.SHIPPING_GET('')
    },
    dates: function () {
      if (!this.dates.length || this.dates.length === 2) {
        this.SHIPPING_GET(this.tableSearch)
      }
    },
    dataProjectQuery (v1, v2) {
      if (!v1 || (timeOutProjectQuery && timeOutProjectQuery === v1)) {
        return false
      }
      if (timeOutProject) {
        clearTimeout(timeOutProject)
      }
      timeOutProject = setTimeout(() => {
        timeOutProjectQuery = v1
        this.PROJECT_GET()
      }, 300)
    },
    dataCustomerQuery (v) {
      if (!v) {
        return false
      }
      if (timeOutCustomer) {
        clearTimeout(timeOutCustomer)
      }
      timeOutCustomer = setTimeout(() => {
        this.CUSTOMER_GET()
      }, 300)
    },
    dataRecipientQuery (v) {
      if (!v) {
        return false
      }
      if (timeOutRecipient) {
        clearTimeout(timeOutRecipient)
      }
      timeOutRecipient = setTimeout(() => {
        this.CUSTOMER_GET(1)
      }, 300)
    },
    dataBilltoQuery (v) {
      if (!v) {
        return false
      }
      if (timeOutBillto) {
        clearTimeout(timeOutBillto)
      }
      timeOutBillto = setTimeout(() => {
        this.CUSTOMER_GET(2)
      }, 300)
    },
    dataSalesQuery (v) {
      if (!v) {
        return false
      }
      if (timeOutSales) {
        clearTimeout(timeOutSales)
      }
      timeOutSales = setTimeout(() => {
        this.SALES_GET()
      }, 300)
    },
    dataPickupQuery (v) {
      if (!v) {
        return false
      }
      if (timeOutSales) {
        clearTimeout(timeOutSales)
      }
      timeOutSales = setTimeout(() => {
        this.SALES_GET(true)
      }, 300)
    },
    shippingManifestOriginQuery (v) {
      if (!v) {
        return false
      }
      if (timeOutManifestOrigin) {
        clearTimeout(timeOutManifestOrigin)
      }
      timeOutManifestOrigin = setTimeout(() => {
        this.AREA_REQUEST(4)
      }, 300)
    },
    shippingManifestDestinationQuery (v) {
      if (!v) {
        return false
      }
      if (timeOutManifestDestination) {
        clearTimeout(timeOutManifestDestination)
      }
      timeOutManifestDestination = setTimeout(() => {
        this.AREA_REQUEST(5)
      }, 300)
    },
    shippingPlanOriginQuery (v) {
      if (!v) {
        return false
      }
      if (timeOutPlanOrigin) {
        clearTimeout(timeOutPlanOrigin)
      }
      timeOutPlanOrigin = setTimeout(() => {
        this.AREA_REQUEST(2)
      }, 300)
    },
    shippingPlanDestinationQuery (v) {
      if (!v) {
        return false
      }
      if (timeOutPlanDestination) {
        clearTimeout(timeOutPlanDestination)
      }
      timeOutPlanDestination = setTimeout(() => {
        this.AREA_REQUEST(3)
      }, 300)
    },
    shippingOriginQuery (v) {
      if (!v) {
        return false
      }
      if (timeOutOrigin) {
        clearTimeout(timeOutOrigin)
      }
      timeOutOrigin = setTimeout(() => {
        this.AREA_REQUEST(1)
      }, 500)
    },
    shippingDestinationQuery (v) {
      if (!v) {
        return false
      }
      if (timeOutDestination) {
        clearTimeout(timeOutDestination)
      }
      timeOutDestination = setTimeout(() => {
        this.AREA_REQUEST(0)
      }, 500)
    },
    pricingDataQuery () {
      if (searchInterval) {
        clearTimeout(searchInterval)
      }
      searchInterval = setTimeout(() => {
        this.PRICING_GET()
      }, 300)
    },
    tableSearch: function (q) {
      // if (!this.tableSearchSwitch) {
      //   return false
      // }
      // this.dataSelected = []
      if (searchInterval) {
        clearTimeout(searchInterval)
      }
      searchInterval = setTimeout(() => {
        this.SHIPPING_GET(q)
      }, 300)
    },
    tableSearchStatus () {
      this.SHIPPING_GET(this.tableSearch)
    },
    tableSearchStore () {
      this.options.page = 1
      this.SHIPPING_GET(this.tableSearch)
    },
    options () {
      this.SHIPPING_GET(this.tableSearch)
    },
    'dialogManifest.search': function (q) {
      if (searchIntervalManifest) {
        clearTimeout(searchIntervalManifest)
      }
      searchIntervalManifest = setTimeout(() => {
        this.MANIFEST_GET()
      }, 300)
    },
    'dialogManifest.options' () {
      this.MANIFEST_GET()
    },
    'dialogManifest.vendor' () {
      this.MANIFEST_GET()
    },
    'dialogManifest.type' () {
      this.MANIFEST_GET()
    },
    'dialogManifest.status' () {
      this.MANIFEST_GET()
    },
    dateRangeTextManifest () {
      this.MANIFEST_GET()
    }
  },
  created () {
    if (this.$store.state.user) {
      if (this.$store.state.user.role === 'finance') {
        this.$router.replace('/')
      } else if (this.$store.state.user.role !== 'root' && this.$store.state.user.role !== 'admin' && this.$store.state.user.role !== 'manager') {
        this.tableSearchStore = this.$store.state.user.store
      }
    } else {
      this.$router.replace('/')
    }
  },
  mounted () {
    this.VENDOR_GET()
    this.SHIPPING_PRODUCT_GET()
    // this.onScanRequest('ABC25010134')
  },
  methods: {
    onDecodeScannerTTK (data) {
      if (!this.dialogManifestData.data) {
        return false
      }
      const manifestListTTK = (this.dialogManifestData.list || []).find(r => r.ttk === (data || '').trim())
      if (manifestListTTK) {
        this.PlanAction('update', 0, parseInt(this.dialogManifestData.data.id), manifestListTTK.id, 1, 0, true)
      }
    },
    onLoadedScannerTTK (data) {
      console.log('loaded: ', data)
    },
    async onScanRequest (ttk) {
      this.pickupScan.data = null
      this.pickupScan.loading = true
      await this.$store.dispatch('logistic/PICKUP_SCAN_AWB', ttk)
        .then(async (res) => {
          if (res && res.status && res.data.data.detail) {
            const d = res.data.data.detail
            const data = res.data.data.data || []
            if (d) {
              this.pickupScan.data = d
              if (data.length) {
                // TTK SUDAH TER-MANIFEST
                this.$store.dispatch('TOAST', { show: true, message: 'TTK sudah ter-manifest!' })
                return false
              } else if (parseInt(d.pickup_handling_admin)) {
                if (!confirm('TTK sudah teregister. Lanjutkan proses?')) {
                  return false
                }
                // CHANGE ADMIN
                // this.$store.dispatch('TOAST', { show: true, message: `TTK ter-manifest!` })
              } else if (!parseInt(d.pickup_handling)) {
                if (!confirm('TTK belum di pickup! Lanjutkan proses tanpa pickup?')) {
                  return false
                }
              }
              // CONTINUE PROCESS TTK
              await this.$store.dispatch('logistic/PICKUP_SCAN_PROCESS', {
                ttk,
                pickup_handling_status: 1,
                pickup_handling_admin: parseInt(this.$store.state.user.id)
              })
              this.$store.dispatch('TOAST', { show: true, message: 'TTK Berhasil teregister!' })
              this.SHIPPING_GET(this.tableSearch)
            } else {
              this.$store.dispatch('TOAST', { show: true, message: 'TTK tidak ditemukan!' })
            }
          } else {
            this.$store.dispatch('TOAST', { show: true, message: 'Terjadi kesalahan!' })
          }
        })
      this.pickupScan.loading = false
    },
    onDecodeScanner (data) {
      if (timeScan) {
        clearTimeout(timeScan)
      }
      if (data) {
        timeScan = setTimeout(() => {
          this.onScanRequest(data)
        }, 300)
      }
    },
    onLoadedScanner (data) {
      console.log('loaded: ', data)
    },
    UpdateCustomerBillTo () {
      const projectFind = this.dataProject.find(r => parseInt(r.id) === parseInt(this.dialogShipping.data.project))
      if (projectFind) {
        if (parseInt(projectFind.customer) && projectFind.customer_detail) {
          this.dialogShipping.data.customer_billto = parseInt(projectFind.customer)
          this.dataBilltoQuery = projectFind.customer_detail
        }
      }
    },
    ImportData (v) {
      this.isProjectBased.sheets = v.sheets
      this.isProjectBased.isError = v.isError
    },
    DOWNLOAD_RUNNER_FORCE_STOP () {
      this.$store.commit('DIALOG_PRINT_RUNNER', false)
    },
    async DOWNLOAD_RUNNER_START () {
      this.tableTempCounter++
      this.$store.commit('DIALOG_PRINT_RUNNER', true)
      const result = await this.DOWNLOAD_RUNNER()
      if (result && result.response && result.data === 'ok') {
        if (result.completed) {
          this.$store.dispatch('TOAST', { show: true, message: `Semua ttk di halaman ${this.tablePage} sudah terdownload!` })
          this.$store.commit('DIALOG_PRINT_RUNNER', false)
        } else {
          this.$store.commit('DIALOG_PRINT_PROCESS', { show: true, data: result.item })
        }
      } else {
        this.$store.dispatch('TOAST', { show: true, message: `Terjadi kesalahan [${result.data}]` })
      }
    },
    async DOWNLOAD_RUNNER_DONE (id) {
      const d = localStorage.getItem('download-iterations')
      const dd = JSON.parse(d || '[]')
      dd.push(id)
      localStorage.setItem('download-iterations', JSON.stringify(dd))
      if (this.$store.state.dialogPrint.runnerActive) {
        this.DOWNLOAD_RUNNER_START()
      } else {
        console.log('END NEW ITERATE... ')
      }
    },
    async DOWNLOAD_RUNNER () {
      const d = localStorage.getItem('download-iterations')
      return new Promise((resolve) => {
        const isRunnerActive = this.$store.state.dialogPrint.runnerActive
        if (isRunnerActive) {
          try {
            const dataDownloaded = d ? JSON.parse(d) : []
            const tbls = this.tableTemp || []
            let counterIterate = 0
            for (let t = 0; t < tbls.length; t++) {
              counterIterate++
              const item = tbls[t]
              const alreadyDownloaded = dataDownloaded.find(r => parseInt(r) === parseInt(item.id))
              if (!alreadyDownloaded) {
                resolve({ response: true, data: 'ok', item: item })
                break
              }
            }
            resolve({ response: true, data: 'ok', completed: counterIterate === tbls.length })
          } catch {
            resolve({ response: true, data: 'error' })
          }
        } else {
          resolve({ response: true, data: 'off' })
        }
      })
    },
    DOWNLOAD_TTK () {
      const storeFilterSelected = this.tableSearchSwitch ? (parseInt(this.tableSearchStore)) : parseInt(this.$store.state.user.store)
      const warningTTKStatusPlan = this.tableSearchSwitch === 1 ? '&warn=1' : ''
      const fromTo = this.GetDates()
      this.$store.dispatch('DOWNLOAD_TTK', `?store=${storeFilterSelected}${warningTTKStatusPlan}${fromTo}`)
        .then((res) => {
          console.log(res)
        })
    },
    DISPATCH_SHOW (data) {
      const d = data ? Object.assign({}, data) : {
        dispatch_vehicle: 0,
        dispatch_vehicle_notes: '',
        pic: 0,
        store_origin: -1,
        store_destination: -1,
        vendor: 0,
        vendor_price_id: 0,
        vendor_awb: '',
        notes: '',
        status: 1
      }
      this.dialogDispatch.data = Object.assign({}, d)
      this.dialogDispatch.show = true
      this.VENDOR_GET()
    },
    DISPATCH_LOAD () {
      this.$store.dispatch('logistic/DISPATCH_GET')
        .then((res) => {
          if (res && res.status) {
            this.dispatchData = (res.data.data || [])
          }
        })
    },
    DISPATCH_PROCESS () {
      const data = Object.assign({}, this.dialogDispatch.data)
      if (!data.dispatch_vehicle_notes) {
        this.$store.dispatch('TOAST', { show: true, message: 'Nama dispatch masih kosong!' })
        return false
      }
      if (parseInt(data.store_origin) < 0) {
        this.$store.dispatch('TOAST', { show: true, message: 'Asal cabang belum dipilih!' })
        return false
      }
      if (parseInt(data.store_destination) < 0) {
        this.$store.dispatch('TOAST', { show: true, message: 'Tujuan cabang belum dipilih!' })
        return false
      }
      this.$store.dispatch('logistic/DISPATCH_PROCESS', data)
        .then((res) => {
          if (res.status && res.data && res.data.data.id) {
            this.dialogDispatch.show = false
            this.$store.dispatch('TOAST', { show: true, message: 'Berhasil disimpan!' })
            this.DISPATCH_LOAD()
          } else {
            this.$store.dispatch('TOAST', { show: true, message: 'Terjadi kesalahan!' })
          }
        })
    },
    SummaryTTK (shippingPackage) {
      if (shippingPackage) {
        const data = this.$StrToArray(shippingPackage)
        let quantity = 0
        let total = 0
        for (let d = 0; d < data.length; d++) {
          quantity += parseInt(data[d].quantity) || 0
          total += parseFloat(data[d].chargeable_weight) || 0
        }
        return {
          quantity,
          total
        }
      }
      return {}
    },
    OpenBrowser (img) {
      const a = document.createElement('a')
      a.setAttribute('href', img)
      a.setAttribute('target', '_blank')
      a.click()
    },
    ParseManifestDelivered (data) {
      if (data) {
        const dataSplit = data.split('-|-')
        if (dataSplit.length === 2) {
          return {
            imgs: this.$StrToArray(dataSplit[0]),
            sign: dataSplit[1] || null
          }
        }
      }
      return {
        imgs: [],
        sign: null
      }
    },
    DoPrint () {
      window.print()
    },
    async PRINT (data, manifest) {
      this.dialogPrint.type = null
      this.dialogPrint.list = []
      if (manifest) {
        this.dialogPrint.type = 'manifest'
        await this.$store.dispatch('logistic/SHIPPING_GET', '?manifest=' + (data.id))
          .then((res) => {
            if (res.status) {
              this.dialogPrint.list = res.data.data.data.map((r) => {
                r.manifest_plan_notes = this.$statusPlan(r.manifest_plan).notes
                return r
              })
            }
          })
      }
      this.dialogPrint.data = Object.assign({}, data)
      this.dialogPrint.show = true
    },
    SHIPPING_PRODUCT_GET () {
      this.productData = []
      this.$store.dispatch('logistic/SHIPPING_PRODUCT_GET')
        .then((res) => {
          if (res) {
            if (res.status) {
              this.productData = res.data.data || []
            }
          }
        })
    },
    PackageAdd () {
      const data = this.$StrToArray(this.dialogShipping.data.shipping_package)
      data.push({
        quantity: 1,
        volume_length: 0,
        volume_width: 0,
        volume_height: 0,
        kg_metric: 0,
        kg_actual: 0,
        chargeable_weight: 0
      })
      this.dialogShipping.data.shipping_package = this.$ArrayToStr(this.ReCountPackage(data))
    },
    PackageUpdate (type, index, value) {
      const data = this.$StrToArray(this.dialogShipping.data.shipping_package)
      data[index][type] = parseFloat(value)
      this.dialogShipping.data.shipping_package = this.$ArrayToStr(this.ReCountPackage(data))
    },
    PackageDelete (iPkg) {
      const data = this.$StrToArray(this.dialogShipping.data.shipping_package)
      data.splice(iPkg, 1)
      this.dialogShipping.data.shipping_package = this.$ArrayToStr(this.ReCountPackage(data))
    },
    ReCountPackage (data) {
      const newData = []
      for (let d = 0; d < data.length; d++) {
        const newD = Object.assign({}, data[d])
        const productSelected = this.productSelected || {}
        newD.kg_metric = this.$VolumeMetric(newD, parseFloat(productSelected.div_amount) || 0) || 0
        newD.chargeable_weight = parseFloat(newD.kg_actual) > parseFloat(newD.kg_metric) ? newD.kg_actual : newD.kg_metric
        newData.push(newD)
      }
      return newData
    },
    async PlanAction (act, v1, v2, v3, v4, v5, isScan) {
      const planID = v1
      const manifestID = v2
      const masterID = v3
      const status = v4
      const statusPlan = v5
      if (act === 'bulk') {
        if (v5 >= 0 && v5 <= 3) {
          if (!confirm((
            v5 === 0
              ? 'Terima'
              : v5 === 1
                ? 'Terima [TERLAMBAT]'
                : v5 === 2
                  ? 'Terima [RUSAK]'
                  : 'Investigasi'
          ) + ' semua TTK ?')) {
            return false
          }
          const manifestListTTK = this.dialogManifestData.list || []
          let countIteration = 0
          this.loadingPlanAction = true
          for (let s = 0; s < manifestListTTK.length; s++) {
            const ttk = manifestListTTK[s]
            await this.$store.dispatch('logistic/SHIPPING_PLAN_UPDATE', {
              id: this.$statusPlan(ttk.manifest_plan).id,
              status: 1,
              status_plan: statusPlan,
              notes: (ttk.manifest_plan_notes || '')
            }).then(async (res) => {
              if (res.status) {
                await this.$store.dispatch('logistic/SHIPPING_GET', '?manifest=' + manifestID)
                  .then((res) => {
                    if (res.status) {
                      this.dialogManifestData.list = res.data.data.data.map((r) => {
                        r.manifest_plan_notes = this.$statusPlan(r.manifest_plan).notes
                        return r
                      })
                    }
                  })
              } else {
                this.$store.dispatch('TOAST', { show: true, message: 'Terjadi kesalahan!' })
              }
            })
            countIteration++
            if (countIteration === manifestListTTK.length) {
              this.$store.dispatch('TOAST', { show: true, message: 'Berhasil!' })
              this.loadingPlanAction = false
            }
          }
        }
      } else if (act === 'update') {
        const foundTtk = this.dialogManifestData.list.find(r => parseInt(r.id) === parseInt(v3))
        if (foundTtk) {
          if (!isScan) {
            // if (!foundTtk.manifest_plan_notes && parseInt(statusPlan)) {
            //   this.$store.dispatch('TOAST', { show: true, message: 'Mohon tambahkan catatan!' })
            //   return false
            // }
            if (!confirm('Update this TTK ?')) {
              return false
            }
          }
          const stPlan = this.$statusPlan(foundTtk.manifest_plan) || {}
          const payload = { status: status, status_plan: statusPlan, notes: (foundTtk.manifest_plan_notes || '') }
          if (!v1 && stPlan) {
            if (parseInt(stPlan.id)) {
              payload.id = parseInt(stPlan.id)
            }
          } else {
            payload.id = v1
          }
          if (foundTtk) {
            payload.vendor_awb = foundTtk.vendor_awb
          }
          await this.$store.dispatch('logistic/SHIPPING_PLAN_UPDATE', payload).then(async (res) => {
            if (res.status) {
              await this.$store.dispatch('logistic/SHIPPING_GET', '?manifest=' + manifestID)
                .then((res) => {
                  if (res.status) {
                    this.dialogManifestData.list = res.data.data.data.map((r) => {
                      r.manifest_plan_notes = this.$statusPlan(r.manifest_plan).notes
                      return r
                    })
                  }
                })
            } else {
              this.$store.dispatch('TOAST', { show: true, message: 'Terjadi kesalahan!' })
            }
          })
        }
      } else if (act === 'delete') {
        if (v2) {
          if (!confirm('Delete item ?')) {
            return false
          } else {
            await this.$store.dispatch('logistic/SHIPPING_PLAN_DELETE', planID).then(async (res) => {
              if (res.status) {
                await this.$store.dispatch('logistic/SHIPPING_GET', '?manifest=' + manifestID)
                  .then((res) => {
                    if (res.status) {
                      this.dialogManifestData.list = res.data.data.data
                    }
                  })
              } else {
                this.$store.dispatch('TOAST', { show: true, message: 'Terjadi kesalahan!' })
              }
            })
          }
        } else {
          const findIndex = this.dataSelected.findIndex(r => parseInt(r.id) === masterID)
          this.dataSelected.splice(findIndex, 1)
        }
      }
    },
    PaymentGetShow (item) {
      this.dialogPayment.new.payment_type = 'cash'
      this.dialogPayment.new.notes = ''
      this.$store.dispatch('logistic/PAYMENT_GET', '?trx=' + (parseInt(item.pickup_id) || parseInt(item.id)) + '&type=' + (parseInt(item.pickup_id) ? 'PICKUP' : 'TRX'))
        .then((res) => {
          if (res.status) {
            this.dialogPayment.selected = Object.assign({}, item)
            this.dialogPayment.data = res.data.data || []
            this.dialogPayment.show = true
          } else {
            this.$store.dispatch('TOAST', { show: true, message: 'Terjadi kesalahan!' })
          }
        })
    },
    PaymentProcess () {
      if (!confirm('Buat pembayaran baru ?')) {
        return false
      }
      const data = Object.assign({}, {
        payment_type: this.dialogPayment.new.payment_type,
        notes: this.dialogPayment.new.notes || '',
        trx_id: parseInt(this.dialogPayment.selected.pickup_id) || this.dialogPayment.selected.id,
        trx_type: parseInt(this.dialogPayment.selected.pickup_id) ? 'PICKUP' : 'TRX',
        user: this.dialogPayment.selected.customer
      })
      this.dialogPayment.loading = true
      this.$store.dispatch('logistic/PAYMENT_PROCESS', data)
        .then(() => {
          this.dialogPayment.loading = false
          this.dialogPayment.new.payment_type = ''
          this.PaymentGetShow(this.dialogPayment.selected)
          this.SHIPPING_GET(this.tableSearch)
        })
    },
    async AddNewMaster () {
      const newMaster = this.dialogManifestData.newMaster || ''
      if (newMaster) {
        const masterID = (newMaster + '').split('/')[(newMaster + '').split('/').length - 1]
        const findExist = this.dialogManifestData.list.find(r => parseInt(r.master) === parseInt(masterID))
        if (findExist) {
          this.$store.dispatch('TOAST', { show: true, message: 'Sudah berada dalam list!' })
          return false
        } else if (parseInt(masterID)) {
          await this.$store.dispatch('logistic/SHIPPING_PLAN_PROCESS', {
            master: parseInt(masterID),
            manifest: this.dialogManifestData.data.id
          }).then(async (res) => {
            if (res.status) {
              if (res.data.data.message) {
                this.$store.dispatch('TOAST', { show: true, message: res.data.data.message || 'Something went wrong!' })
              } else {
                this.dialogManifestData.newMaster = ''
                const manifestList = await this.MANIFEST_LIST_GET(this.dialogManifestData.data.id)
                if (manifestList) {
                  if (manifestList.status) {
                    this.dialogManifestData.list = manifestList.data.data || []
                  }
                }
              }
            } else {
              console.log(res)
            }
          })
        } else {
          this.$store.dispatch('TOAST', { show: true, message: 'Ops, terjadi kesalahan!' })
        }
      }
    },
    async MANIFEST_SHOW (data) {
      if (data) {
        this.dialogManifestData.data = Object.assign({}, data)
        this.dialogManifestData.list = []
        if (data.type === 'courier' && parseInt(data.courier)) {
          this.dataPickupQuery = data.courier_detail
        }
        await this.PRICING_GET()
        await this.$store.dispatch('logistic/SHIPPING_GET', '?manifest=' + (data.id))
          .then((res) => {
            if (res.status) {
              this.dialogManifestData.list = res.data.data.data.map((r) => {
                r.manifest_plan_notes = this.$statusPlan(r.manifest_plan).notes
                return r
              })
            }
          })
      } else {
        this.dialogManifestData.data = {
          manifest_ext_id: '',
          type: null,
          store_origin: (parseInt(this.$store.state.user.store) === 0 || parseInt(this.$store.state.user.store) > 0) ? parseInt(this.$store.state.user.store) : -1,
          store_destination: -1,
          vendor: 0,
          vendor_price_selected: 0,
          city_origin: 0,
          city_destination: 0,
          departure: '',
          arrival: '',
          price: 0,
          status: 0,
          notes: ''
        }
      }
      // const manifestList = await this.MANIFEST_LIST_GET(data ? parseInt(data.id) : 0)
      // if (manifestList) {
      //   if (manifestList.status) {
      //     this.dialogManifestData.list = manifestList.data.data || []
      //   }
      // }
      if (data) {
        setTimeout(() => {
          this.shippingManifestOriginQuery = data.city_origin_name
          this.shippingManifestDestinationQuery = data.city_destination_name
          this.dialogManifestData.show = true
        }, 300)
      } else {
        this.dialogManifestData.data.city_origin = 0
        this.dialogManifestData.data.city_destination = 0
        this.shippingManifestOriginQuery = ''
        this.shippingManifestDestinationQuery = ''
        this.shippingManifestOriginnData = []
        this.shippingManifestDestinationData = []
        this.dialogManifestData.show = true
      }
    },
    MANIFEST_DISPATCH (id, dispatch, name) {
      if (parseInt(dispatch)) {
        if (!confirm('Dispatch manifest to ' + name + ' ?')) {
          return false
        }
      } else {
        if (!confirm('Cancel dispatch ?')) {
          return false
        }
        dispatch = 0
      }
      this.dialogManifestData.loading = true
      this.$store.dispatch('logistic/MANIFEST_PROCESS', {
        id,
        dispatch
      })
        .then((res) => {
          this.dialogManifestData.loading = false
          if (res.status) {
            this.$store.dispatch('TOAST', { show: true, message: (parseInt(dispatch) ? 'Manifest dispatched!' : 'Dispatch canceled!') })
            this.MANIFEST_GET()
            this.DISPATCH_LOAD()
          } else {
            this.$store.dispatch('TOAST', { show: true, message: 'Ops, something went wrong!' })
          }
        })
    },
    MANIFEST_PROCESS (ACT) {
      let data = Object.assign({}, this.dialogManifestData.data)
      if (data) {
        if (parseInt(data.store_destination) < 0) {
          this.$store.dispatch('TOAST', { show: true, message: 'Tujuan cabang belum dipilih!' })
          return false
        }
        if (data.type === 'courier' && !parseInt(data.courier) && !parseInt(data.vendor)) {
          this.$store.dispatch('TOAST', { show: true, message: 'Kurir atau vendor belum dipilih!' })
          return false
        } else if (data.type !== 'courier') {
          data.courier = 0
          data.type = null
        }
        data.courier = parseInt(data.courier) || 0
        data.items = parseInt(data.id) ? this.dialogManifestData.list : this.dataSelected
        if (!data.items.length) {
          this.$store.dispatch('TOAST', { show: true, message: 'Belum ada list data manifest!' })
          return false
        }
        // if (parseInt(data.vendor) && !parseInt(data.vendor_price_selected)) {
        //   this.$store.dispatch('TOAST', { show: true, message: 'Harga vendor belum dipilih!' })
        //   return false
        // }
        if (!data.notes) {
          this.$store.dispatch('TOAST', { show: true, message: 'Catatan manifest tidak boleh kosong!' })
          return false
        }
        const statusMSG = ACT === 'OUT' ? 'Set Manifest OUT ?' : (ACT === 'IN' ? 'Set Manifest IN ?' : 'Proses Manifest ?')
        if (!confirm(statusMSG)) {
          return false
        }
        if (ACT === 'OUT') {
          data = {
            id: data.id,
            departure: new Date().toISOString(),
            arrival: null
          }
        } else if (ACT === 'IN') {
          data = {
            id: data.id,
            departure: data.departure,
            arrival: new Date().toISOString()
          }
        }
        this.dialogManifestData.loading = true
        data.unit_weight = this.ManifestWeight.unit_weight
        data.unit_quantity = this.ManifestWeight.unit
        data.unit_quantity_sum = this.ManifestWeight.unit_sum
        data.unitnon_weight = this.ManifestWeight.weight_chargeable
        data.unitnon_quantity = this.ManifestWeight.weight_sum
        data.unitnon_quantity_sum = this.ManifestWeight.weight
        this.$store.dispatch('logistic/MANIFEST_PROCESS', data)
          .then((res) => {
            this.dialogManifestData.loading = false
            if (res.status) {
              this.dialogManifestData.show = false
              this.$store.dispatch('TOAST', { show: true, message: parseInt(data.id) ? 'Manifest updated!' : 'Succesfully manifested!' })
              this.dataSelected = []
              this.MANIFEST_GET()
              this.DISPATCH_LOAD()
              this.SHIPPING_GET(this.tableSearch)
            } else {
              this.$store.dispatch('TOAST', { show: true, message: 'Ops, something went wrong!' })
            }
          })
      } else {
        this.$store.dispatch('TOAST', { show: true, message: 'Invalid form selected!' })
        return false
      }
    },
    MANIFEST_DELETE (id) {
      if (!confirm('Delete this manifest ?')) {
        return false
      }
      this.$store.dispatch('logistic/MANIFEST_DELETE', id)
        .then((res) => {
          if (res) {
            if (res.status) {
              this.MANIFEST_GET()
              this.dialogManifestData.show = false
              this.dialogManifestData.data = null
            } else {
              this.$store.dispatch('TOAST', { show: true, message: 'Failed!' })
            }
          } else {
            this.$store.dispatch('TOAST', { show: true, message: 'Something went wrong!' })
          }
        })
    },
    SetDataManifest () {
      // const priceSelected = this.dialogManifestData.data.vendor_price_selected
      // if (parseInt(priceSelected)) {
      //   const pricingSelected = this.pricingData.find(r => parseInt(r.id) === priceSelected)
      //   if (pricingSelected) {
      //     this.dialogManifestData.data.city_origin = parseInt(pricingSelected.city_origin) || 0
      //     this.dialogManifestData.data.city_destination = parseInt(pricingSelected.city_destination) || 0
      //     this.shippingManifestOriginQuery = pricingSelected.city_origin_name
      //     this.shippingManifestDestinationQuery = pricingSelected.city_destination_name
      //   }
      // }
    },
    PLAN_SHOW (item) {
      this.dialogPlan.selected = Object.assign({}, item)
      this.shippingPlanOriginQuery = ''
      this.shippingPlanDestinationQuery = ''
      this.PLAN_GET(item.id)
      this.MANIFEST_GET()
      this.dialogPlan.show = true
    },
    PLAN_GET (master) {
      this.dialogPlan.data = []
      this.$store.dispatch('logistic/SHIPPING_PLAN_GET', {
        master: master,
        q: ''
      }).then((res) => {
        if (res.status) {
          this.dialogPlan.data = res.data.data || []
        }
      })
    },
    PROJECT_GET () {
      this.dataProject = []
      this.$store.dispatch('logistic/PROJECT_GET', '?q=' + (this.dataProjectQuery || '')).then((res) => {
        if (res.status) {
          this.dataProject = res.data.data || []
        }
      })
    },
    PROJECT_SHOW (projectID) {
      if (projectID && parseInt(projectID)) {
        const projectFind = this.dataProject.find(r => parseInt(r.id) === parseInt(projectID))
        if (projectFind) {
          this.dialogProject.data = Object.assign({}, projectFind)
          if (!parseInt(projectFind.customer)) {
            this.dialogProject.data.customer = parseInt(this.dialogShipping.data.customer_billto) || 0
          } else {
            this.dialogShipping.data.customer_billto = parseInt(projectFind.customer) || 0
            this.dataBilltoQuery = projectFind.customer_detail
          }
        } else {
          this.$store.dispatch('TOAST', { show: true, message: 'Project tidak ditemukan!' })
        }
      } else {
        this.dialogProject.data = {
          name: '',
          customer: parseInt(this.dialogShipping.data.customer_billto) || 0,
          status: 1
        }
      }
      this.dialogProject.show = true
    },
    PROJECT_PROCESS () {
      const processedProject = Object.assign({}, this.dialogProject.data)
      if (!processedProject.name) {
        this.$store.dispatch('TOAST', { show: true, message: 'Nama project tidak boleh kosong!' })
        return false
      }
      if (!parseInt(this.dialogShipping.data.customer_billto)) {
        this.$store.dispatch('TOAST', { show: true, message: 'Customer tidak boleh kosong!' })
        return false
      }
      processedProject.customer = parseInt(this.dialogShipping.data.customer_billto)
      this.$store.dispatch('logistic/PROJECT_PROCESS', processedProject)
        .then((res) => {
          if (res.status) {
            if (parseInt(res.data.data.id)) {
              this.dialogProject.show = false
              this.dialogShipping.data.project = parseInt(res.data.data.id)
              // this.PROJECT_GET()
              this.dataProjectQuery = processedProject.name
              this.$store.dispatch('TOAST', { show: true, message: processedProject.id ? 'Berhasil diupdate' : 'Berhasil dibuat' })
            } else {
              this.$store.dispatch('TOAST', { show: true, message: 'Something went wrong!' })
            }
          } else {
            this.$store.dispatch('TOAST', { show: true, message: 'Terjadi kesalahan!' })
          }
        })
    },
    MANIFEST_GET () {
      let query = ''
      this.dialogManifest.table = []
      query += '?q=' + (this.dialogManifest.search || '')
      query += parseInt(this.dialogManifest.status) > -1 ? ('&status=' + parseInt(this.dialogManifest.status)) : ''
      query += parseInt(this.dialogManifest.cabang) > -1 ? ('&store=' + parseInt(this.dialogManifest.cabang)) : ''
      query += parseInt(this.dialogManifest.vendor) > -1 ? ('&vendor=' + parseInt(this.dialogManifest.vendor)) : ''
      query += '&type=' + (this.dialogManifest.type || '')
      query += this.GetDates(true)
      const { sortBy, sortDesc, page, itemsPerPage } = this.dialogManifest.options
      query += (parseInt(page) > 0 ? '&page=' + page : '') + (parseInt(itemsPerPage) > 0 ? '&limit=' + parseInt(itemsPerPage) : '') + (sortBy.length ? '&sortby=' + sortBy[0] + (sortDesc[0] ? '&sort=DESC' : '&sort=ASC') : '')
      this.$store.dispatch('logistic/MANIFEST_GET', query).then((res) => {
        if (res.status) {
          this.dialogManifest.table = res.data.data.data || []
          this.dialogManifest.tableTotal = parseInt(res.data.data.total) || 0
        }
      })
    },
    async MANIFEST_LIST_GET (manifestID) {
      if (manifestID) {
        return await this.$store.dispatch('logistic/MANIFEST_LIST_GET', manifestID).then(res => res)
      }
      return null
    },
    PLAN_PROCESS () {
      if (!parseInt(this.newShippingPlanOrigin) || !parseInt(this.newShippingPlanDestination)) {
        this.$store.dispatch('TOAST', { show: true, message: 'Invalid Asal / Tujuan!' })
        return false
      }
      const params = {
        city_origin: this.newShippingPlanOrigin,
        city_destination: this.newShippingPlanDestination,
        master: this.dialogPlan.selected.id,
        manifest: this.newShippingManifest
      }
      this.$store.dispatch('logistic/SHIPPING_PLAN_PROCESS', params).then((res) => {
        if (res.status) {
          this.newShippingPlanOrigin = 0
          this.newShippingPlanDestination = 0
          this.newShippingManifest = 0
          this.PLAN_GET(params.master)
        } else {
          this.$store.dispatch('TOAST', { show: true, message: 'Terjadi kesalahan!' })
        }
      })
    },
    PLAN_DELETE (id, master, fromDialogManifest) {
      if (!confirm('Hapus data ?')) {
        return false
      }
      this.$store.dispatch('logistic/SHIPPING_PLAN_DELETE', id).then(async (res) => {
        if (fromDialogManifest) {
          const manifestList = await this.MANIFEST_LIST_GET(id)
          if (manifestList) {
            if (manifestList.status) {
              this.dialogManifestData.list = manifestList.data.data || []
            }
          }
        } else {
          this.PLAN_GET(master)
        }
      })
    },
    async ReloadCustomer (customerCode) {
      // await this.SyncOriginDestination()
      await this.SetCustomer(customerCode)
    },
    async SyncOriginDestination () {
      return await new Promise((resolve, reject) => {
        setTimeout(() => {
          if (this.selectedCustomer.fullname && parseInt(this.selectedCustomer.kecamatan_id)) {
            this.dialogShipping.data.shipping_origin = parseInt(this.selectedCustomer.kecamatan_id)
            this.shippingOriginQuery = this.selectedCustomer.fullname || ''
          }
          if (this.selectedRecipient.fullname && parseInt(this.selectedRecipient.kecamatan_id)) {
            this.dialogShipping.data.shipping_destination = parseInt(this.selectedRecipient.kecamatan_id)
            this.shippingDestinationQuery = this.selectedRecipient.fullname
          }
          resolve(true)
        }, 300)
      })
    },
    async SetCustomer (customerCode) {
      if (this.dialogShipping.data) {
        if (customerCode === 1) {
          this.dialogShipping.data.shipping_name = ''
          this.dialogShipping.data.shipping_phone = ''
          this.dialogShipping.data.shipping_address = ''
          if (parseInt(this.dialogShipping.data.recipient) && this.dataRecipient.length) {
            const c = this.dataRecipient.find(r => parseInt(r.id) === parseInt(this.dialogShipping.data.recipient))
            if (c) {
              this.dialogShipping.data.shipping_name = c.name || ''
              this.dialogShipping.data.shipping_phone = c.phone || ''
              this.dialogShipping.data.shipping_address = c.address || ''
              if (this.selectedRecipient.fullname && parseInt(this.selectedRecipient.kecamatan_id)) {
                // this.shippingDestinationQuery = this.selectedRecipient.area_name
                this.shippingDestinationData = [{ kecamatan_id: this.selectedRecipient.kecamatan_id, fullname: this.selectedRecipient.fullname }]
                this.dialogShipping.data.shipping_destination = parseInt(this.selectedRecipient.kecamatan_id)
              }
            }
          }
        } else if (customerCode === 2) {
          if (parseInt(this.dialogShipping.data.customer_billto) && this.dataBillto.length) {
            // const c = this.dataBillto.find(r => parseInt(r.id) === parseInt(this.dialogShipping.data.customer_billto))
          }
        } else {
          this.dialogShipping.data.shipping_sender_name = ''
          this.dialogShipping.data.shipping_sender_phone = ''
          this.dialogShipping.data.shipping_sender_address = ''
          if (parseInt(this.dialogShipping.data.customer) && this.dataCustomer.length) {
            const c = this.dataCustomer.find(r => parseInt(r.id) === parseInt(this.dialogShipping.data.customer))
            if (c) {
              this.dialogShipping.data.shipping_sender_name = c.name || ''
              this.dialogShipping.data.shipping_sender_phone = c.phone || ''
              this.dialogShipping.data.shipping_sender_address = c.address || ''
              if (this.selectedCustomer.fullname && parseInt(this.selectedCustomer.kecamatan_id)) {
                this.shippingOriginData = [{ kecamatan_id: this.selectedCustomer.kecamatan_id, fullname: this.selectedCustomer.fullname }]
                this.dialogShipping.data.shipping_origin = parseInt(this.selectedCustomer.kecamatan_id)
              }
            }
          }
        }
      }
      await this.PRICING_GET()
    },
    SetPrice () {
      if (this.dialogDispatch.show) {
        this.dialogDispatch.data.price = 0
        const priceIDSelected = parseInt(this.dialogDispatch.data.vendor_price_id)
        if (priceIDSelected && this.pricingData.length) {
          const p = this.pricingData.find(r => parseInt(r.id) === priceIDSelected)
          if (p) {
            this.dialogDispatch.data.price = (parseInt(p.price) || 0)
          }
        }
      } else if (this.dialogShipping.data && !parseInt(this.dialogShipping.data.id)) {
        this.dialogShipping.data.est_to = 0
        this.dialogShipping.data.price = 0
        if (parseInt(this.dialogShipping.data.price_id) && this.pricingData.length) {
          const p = this.pricingData.find(r => parseInt(r.id) === parseInt(this.dialogShipping.data.price_id))
          if (p) {
            const price = (parseInt(p.price) || 0)
            this.dialogShipping.data.price = (parseInt(price) || 0) * (parseInt(this.productSelected.is_unit) ? this.PrintItemTotal.quantity : (parseInt(this.ChargeableWeightTotal) || 0))
            this.dialogShipping.data.est_to = parseInt(p.est_to) || 0
          }
        }
      }
    },
    CUSTOMER_GET (customerCode) {
      const q = '?q=' + (customerCode === 2 ? (this.dataBilltoQuery || '') : (customerCode === 1 ? (this.dataRecipientQuery || '') : (this.dataCustomerQuery || '')))
      this.$store.dispatch('customer/CUSTOMER_SEARCH', q).then((res) => {
        if (res.status) {
          if (customerCode === 2) {
            this.dataBillto = res.data.data.data || []
          } else if (customerCode === 1) {
            this.dataRecipient = res.data.data.data || []
          } else {
            this.dataCustomer = res.data.data.data || []
          }
        }
      })
    },
    CUSTOMER_SHOW (customer) {
      if (customer) {
        customer.password = ''
        if (customer.fullname) {
          this.areaquery = customer.fullname || ''
        }
        this.dialogCustomer.data = Object.assign({}, customer)
      } else {
        this.dialogCustomer.data = {
          type: 0,
          type_price: 0,
          name: '',
          phone: '',
          email: '',
          address: '',
          kecamatan_id: 0,
          city_id: 0,
          province_id: '',

          img: '',
          password: '',
          rauth: '',
          verified_email: 0,
          verified_phone: 0,
          verified_email_code: '',
          verified_phone_code: '',
          fcm_ids: '',
          status: 1,
          role: 'customer',
          notes: ''
        }
      }
      this.dialogCustomer.show = true
    },
    CUSTOMER_PROCESS () {
      if (this.processCustomerLoading) {
        this.$store.dispatch('TOAST', { show: true, message: 'Mohon tunggu!' })
        return false
      }
      const processedCustomer = Object.assign({}, this.dialogCustomer.data)
      if (!processedCustomer.name) {
        this.$store.dispatch('TOAST', { show: true, message: 'Nama tidak boleh kosong!' })
        return false
      } else if (processedCustomer.name.length < 3) {
        this.$store.dispatch('TOAST', { show: true, message: 'Masukkan nama yang valid!' })
        return false
      }

      if (!processedCustomer.address) {
        this.$store.dispatch('TOAST', { show: true, message: 'Alamat tidak valid!' })
        return false
      }
      if (!parseInt(processedCustomer.kecamatan_id)) {
        this.$store.dispatch('TOAST', { show: true, message: 'Area belum dipilih!' })
        return false
      } else {
        const area = this.areas.find(r => parseInt(r.kecamatan_id) === parseInt(processedCustomer.kecamatan_id))
        processedCustomer.city_id = area ? (parseInt(area.city_id) || 0) : 0
        processedCustomer.province_id = area ? (parseInt(area.province_id) || 0) : 0
      }

      processedCustomer.role = 'customer'
      if (!processedCustomer.password) {
        delete processedCustomer.password
      }
      this.processCustomerLoading = true
      this.$store.dispatch('customer/CUSTOMER_PROCESS_BY_ADMIN', processedCustomer)
        .then((res) => {
          this.processCustomerLoading = false
          if (res.status) {
            if (res.data.data.status) {
              this.dialogCustomer.show = false
              this.$store.dispatch('TOAST', { show: true, message: processedCustomer.id ? 'Berhasil diupdate' : 'Berhasil dibuat' })
            } else {
              this.$store.dispatch('TOAST', { show: true, message: res.data.data.message })
            }
          } else {
            this.$store.dispatch('TOAST', { show: true, message: 'Terjadi kesalahan!' })
          }
        })
    },
    areaGet (q, id) {
      this.$store.dispatch('KECAMATAN_GET', q).then((res) => {
      // this.$store.dispatch('AREA_GET', q + (parseInt(id) ? '&id=' + id : '') + '&nonKecamatan=1').then((res) => {
        if (res.status) {
          this.areas = res.data.data || []
        }
      })
    },
    SALES_GET (isPickup) {
      const q = '?q=' + (isPickup ? (this.dataPickupQuery || '') : (this.dataSalesQuery || ''))
      this.$store.dispatch('account/ACCOUNTS_GET', q).then((res) => {
        if (res.status) {
          if (isPickup) {
            this.dataPickup = (res.data.data.data || []).filter(r => r.role === 'courier')
          } else {
            this.dataSales = (res.data.data.data || []).filter(r => r.role === 'marketing')
          }
        }
      })
    },
    async PRICING_GET (isVendor) {
      const params = {}
      if (this.dialogDispatch.show) {
        const dataOrigin = this.$store.state.storeData.find(r => parseInt(r.id) === parseInt(this.dialogDispatch.data.store_origin))
        const dataDestination = this.$store.state.storeData.find(r => parseInt(r.id) === parseInt(this.dialogDispatch.data.store_destination))

        let pquery = this.pricingDataQuery
        if (!this.pricingDataQuery || this.pricingDataQuery === 'Custom Price') {
          pquery = ''
        }
        params.vendor = parseInt(this.dialogDispatch.data.vendor)
        params.q = '?q=' + pquery || ''
        params.q += dataOrigin ? '&city_origin=' + (dataOrigin.city_id || 0) : ''
        params.q += dataDestination ? '&city_destination=' + (dataDestination.city_id || 0) : ''
        if (!dataOrigin || !dataDestination || !params.vendor) {
          return false
        }
      } else if (this.dialogShipping.data) {
        params.vendor = isVendor ? this.dialogShipping.data.vendor : this.dialogShipping.data.cabang
        params.q = '?kecamatan_origin=' + (parseInt(this.dialogShipping.data.shipping_origin_kec) || 0) + '&kecamatan_destination=' + (parseInt(this.dialogShipping.data.shipping_destination_kec) || 0)
        if (isVendor) {
          this.vendorSelected.pricingSelected = null
        } else {
          this.dialogShipping.pricingSelected = null
        }
      }
      if (parseInt(params.vendor) > -1) {
        await this.$store.dispatch('logistic/SHIPPING_PRICING_GET', params)
          .then((res) => {
            if (isVendor) {
              this.vendorSelected.pricing = res.data.data || []
            } else {
              this.pricingData = res.data.data || []
            }
          })
      }
    },
    VENDOR_GET () {
      this.$store.dispatch('STORE', '?q=&status=1&limit=10000')
        .then((res) => {
          this.vendorSelected.data = res.data.data || []
        })
    },
    async AREA_REQUEST (isOrigin) {
      let q = '?q='
      if (isOrigin === 5) {
        q += this.shippingManifestDestinationQuery || ''
      } else if (isOrigin === 4) {
        q += this.shippingManifestOriginQuery || ''
      } else if (isOrigin === 3) {
        q += this.shippingPlanDestinationQuery || ''
      } else if (isOrigin === 2) {
        q += this.shippingPlanOriginQuery || ''
      } else if (isOrigin === 1) {
        q += this.shippingOriginQuery || ''
      } else {
        q += this.shippingDestinationQuery || ''
      }
      this.$store.dispatch('KECAMATAN_GET', q).then((res) => {
        if (res.status) {
          if (isOrigin === 5) {
            this.shippingManifestDestinationData = res.data.data || []
          } else if (isOrigin === 4) {
            this.shippingManifestOriginData = res.data.data || []
          } else if (isOrigin === 3) {
            this.shippingPlanDestinationData = res.data.data || []
          } else if (isOrigin === 2) {
            this.shippingPlanOriginData = res.data.data || []
          } else if (isOrigin === 1) {
            this.shippingOriginData = res.data.data || []
          } else {
            this.shippingDestinationData = res.data.data || []
          }
        }
      })
    },
    MANIFEST_DATA_SHOW () {
      this.dialogManifest.search = ''
      this.dialogManifest.data = []
      this.dialogManifest.show = true
      this.dialogManifest.vendor = -1
      this.dialogManifest.cabang = this.$store.state.user ? parseInt(this.$store.state.user.store) : -1
      this.MANIFEST_GET()
      this.DISPATCH_LOAD()
    },
    SHIPPING_SHOW (shipping) {
      this.isProjectBased.v = false
      this.isProjectBased.sheets = null
      this.isProjectBased.isError = []
      if (shipping) {
        this.shippingOriginQuery = (shipping.shipping_origin_fullname || '').trim() || null
        this.shippingDestinationQuery = (shipping.shipping_destination_fullname || '').trim() || null
        if (shipping.customer_detail) {
          this.dataCustomerQuery = shipping.customer_detail
        }
        if (shipping.recipient_detail) {
          this.dataRecipientQuery = shipping.recipient_detail
        }
        if (shipping.customer_billto_detail) {
          this.dataBilltoQuery = shipping.customer_billto_detail
        }
        if (shipping.sales_detail) {
          this.dataSalesQuery = shipping.sales_detail
        }
        if (shipping.pickup_detail) {
          this.dataPickupQuery = shipping.pickup_detail
        }
        this.dialogShipping.data = Object.assign({ shipping_package: '[]' }, shipping)
        this.dialogShipping.oldStatus = shipping.status
      } else {
        this.shippingOriginQuery = null
        this.shippingDestinationQuery = null
        this.dialogShipping.oldStatus = 0
        this.dialogShipping.data = {
          initialTTK: '',
          product: 0,
          project: 0,
          ttk: '',
          id_generated: '',
          id_refference: '',
          cabang: parseInt(this.$store.state.user.store) || 0,
          cabang_destination: -1,
          vendor: 0,
          vendor_price: 0,
          customer: 0,
          customer_billto: 0,
          recipient: 0,
          sales: 0,
          shipping_origin: 0,
          shipping_destination: 0,
          shipping_origin_kec: 0,
          shipping_destination_kec: 0,
          shipping_name: '',
          shipping_phone: '',
          shipping_address: '',
          shipping_postalcode: '',
          shipping_sender_name: '',
          shipping_sender_phone: '',
          shipping_sender_address: '',
          shipping_sender_postalcode: '',
          shipping_package: '[]',
          type: 'KG',
          shipping_package_quantity: 0,
          weight_kg_actual: 0,
          weight_volume_length: 0,
          weight_volume_width: 0,
          weight_volume_height: 0,
          weight_chargeable: 0,
          price_id: 0,
          price: 0,
          price_packaging: 0,
          price_other: 0,
          price_final: 0,
          price_caption: '',
          payment_option: 'CASH',
          notes: '',
          pickup_id: 0,
          pickup: 0,
          pickup_handling: 0,
          pickup_image: null,
          est_from: 0,
          est_to: 0,
          status: 0
        }
        // if (storeActive) {
        //   if (storeActive.area_name) {
        //     setTimeout(() => {
        //       this.shippingOriginQuery = storeActive.area_name
        //       this.PRICING_GET()
        //     }, 300)
        //   }
        // }
      }
      this.PRICING_GET()
      this.dialogShipping.show = true
    },
    SHIPPING_GET (q, downloadTTKS) {
      const storeFilterSelected = this.tableSearchSwitch ? (parseInt(this.tableSearchStore)) : (
        this.$role(['manager'], this.$store.state.user.role) ? parseInt(this.tableSearchStore) : parseInt(this.$store.state.user.store)
      )
      const warningTTKStatusPlan = this.tableSearchSwitch === 1 ? '&warn=1' : ''
      const warningTTKStatusLate = this.tableSearchSwitch === 99 ? '&late=1' : ''
      this.tableLoading = true
      // this.summaryPrice = 0
      const fromTo = this.GetDates()
      const { sortBy, sortDesc, page, itemsPerPage } = this.options
      const limit = (parseInt(itemsPerPage) > 0 ? '&limit=' + parseInt(itemsPerPage) : '')
      // const limit = this.tableSearchSwitch ? (parseInt(itemsPerPage) > 0 ? '&limit=' + parseInt(itemsPerPage) : '') : ('&limit=' + setLimit)
      const withStore = '&store=' + storeFilterSelected
      const withSortBy = sortBy ? (sortBy.length ? '&sortby=' + sortBy[0] + (sortDesc[0] ? '&sort=DESC' : '&sort=ASC') : '') : ''
      const query = '?c=' + (parseInt(page) > 0 ? '&page=' + page : '') + limit + withSortBy
      let fullQuery = query + (q ? ('&q=' + q) : '') + fromTo + withStore + warningTTKStatusPlan + warningTTKStatusLate
      if (downloadTTKS) {
        const qTTKS = JSON.stringify(downloadTTKS)
        fullQuery += '&ttks=' + qTTKS
        this.loadingDownload = true
      }
      this.$store.dispatch('logistic/SHIPPING_GET', fullQuery)
        .then((res) => {
          if (downloadTTKS) {
            if (res && res.status && res.data.data && res.data.data.filename) {
              const a = document.createElement('a')
              a.setAttribute('href', res.data.data.filename)
              a.setAttribute('target', '_blank')
              a.click()
            } else {
              console.log('FAILED DOWNLOAD')
            }
          } else {
            if (res.status) {
              this.table = res.data.data.data
              this.tableTotal = parseInt(res.data.data.total) || 0
              // this.summaryPrice = parseInt(res.data.data.sum) || 0
            } else {
              this.table = []
              this.tableTotal = 0
            }
          }
          this.tableLoading = false
          this.loadingDownload = false
        })
    },
    SHIPPING_GET_TEMP () {
      if (!confirm('RUNNNG AUTO DOWNLOAD ?')) {
        return false
      }
      this.tableTempCounter = 0
      const q = this.tableSearch || ''
      const storeFilterSelected = this.tableSearchSwitch ? (parseInt(this.tableSearchStore)) : parseInt(this.$store.state.user.store)
      const warningTTKStatusPlan = this.tableSearchSwitch === 1 ? '&warn=1' : ''
      const warningTTKStatusLate = this.tableSearchSwitch === 99 ? '&late=1' : ''
      // this.summaryPrice = 0
      const fromTo = this.GetDates()
      const { sortBy, sortDesc } = this.options
      const limit = '&limit=100000000'
      // const limit = this.tableSearchSwitch ? (parseInt(itemsPerPage) > 0 ? '&limit=' + parseInt(itemsPerPage) : '') : ('&limit=' + setLimit)
      const withStore = '&store=' + storeFilterSelected
      const withSortBy = sortBy ? (sortBy.length ? '&sortby=' + sortBy[0] + (sortDesc[0] ? '&sort=DESC' : '&sort=ASC') : '') : ''
      const query = '?c=&page=1' + limit + withSortBy
      const fullQuery = query + (q ? ('&q=' + q) : '') + fromTo + withStore + warningTTKStatusPlan + warningTTKStatusLate
      this.$store.dispatch('logistic/SHIPPING_GET', fullQuery)
        .then((res) => {
          if (res.status) {
            this.tableTemp = res.data.data.data || []
            this.DOWNLOAD_RUNNER_START()
          }
        })
    },
    SHIPPING_PROCESS () {
      const processedData = Object.assign({}, this.dialogShipping.data)
      if (!parseInt(processedData.product)) {
        this.$store.dispatch('TOAST', { show: true, message: 'Produk belum dipilih!' })
        return false
      }
      if (!this.isProjectBased.v) {
        if (!parseInt(processedData.shipping_origin_kec) || !parseInt(processedData.shipping_destination_kec)) {
          this.$store.dispatch('TOAST', { show: true, message: 'Asal / Tujuan belum ditentukan!' })
          return false
        }
      }
      const sOrigin = this.shippingOriginData.find(r => parseInt(r.kecamatan_id) === (processedData.shipping_origin || 0))
      const sDestination = this.shippingDestinationData.find(r => parseInt(r.kecamatan_id) === (processedData.shipping_destination || 0))
      processedData.shipping_origin_kec = sOrigin ? sOrigin.kecamatan_id : 0
      processedData.shipping_destination_kec = sDestination ? sDestination.kecamatan_id : 0
      processedData.shipping_origin = sOrigin ? sOrigin.city_id : 0
      processedData.shipping_destination = sDestination ? sDestination.city_id : 0
      if (!parseInt(processedData.customer_billto)) {
        this.$store.dispatch('TOAST', { show: true, message: 'Customer Bill To belum ditentukan!' })
        return false
      }
      if (!processedData.shipping_sender_name || !processedData.shipping_sender_phone) {
        this.$store.dispatch('TOAST', { show: true, message: 'Data Pengirim, belum lengkap!' })
        return false
      }
      if (!this.isProjectBased.v) {
        processedData.project = 0
        if (!processedData.shipping_name || !processedData.shipping_phone || !processedData.shipping_address) {
          this.$store.dispatch('TOAST', { show: true, message: 'Data Penerima, belum lengkap!' })
          return false
        }
      } else {
        if (!this.dialogShipping.data.initialTTK) {
          this.$store.dispatch('TOAST', { show: true, message: 'Format awal TTK belum ditentukan!' })
          return false
        } else if (!parseInt(this.dialogShipping.data.project)) {
          this.$store.dispatch('TOAST', { show: true, message: 'Project belum dipilih!' })
          return false
        } else if (!Object.keys(this.isProjectBased.sheets).length) {
          this.$store.dispatch('TOAST', { show: true, message: 'Sheet excel belum diimport!' })
          return false
        }
      }
      if (!this.$StrToArray(this.dialogShipping.data.shipping_package).length) {
        this.$store.dispatch('TOAST', { show: true, message: 'Data paket belum ditambahkan!' })
        return false
      }
      if (!parseInt(this.productSelected.is_unit) && !parseFloat(this.ChargeableWeightTotal)) {
        this.$store.dispatch('TOAST', { show: true, message: 'Berat/volume kiriman belum ditentukan!' })
        return false
      } else {
        processedData.weight_chargeable = parseFloat(this.ChargeableWeightTotal)
        processedData.shipping_package_quantity = (this.$StrToArray(this.dialogShipping.data.shipping_package) || []).length
        processedData.shipping_package_quantity_sum = parseInt(this.PrintItemTotal.quantity)
      }
      if (parseInt(this.productSelected.is_unit) && !parseInt(this.PrintItemTotal.quantity)) {
        this.$store.dispatch('TOAST', { show: true, message: 'Jumlah / Quantity Item belum ditentukan!' })
        return false
      }
      if (parseInt(processedData.vendor) && !parseInt(processedData.vendor_price)) {
        this.$store.dispatch('TOAST', { show: true, message: 'Harga vendor belum ditentukan!' })
        return false
      }
      if (!this.IsWeightMatch && !parseInt(this.dialogShipping.data.price_id)) {
        const p = confirm('Gunakan custom pricing ?')
        if (!p) {
          return false
        }
      } else if (!this.IsWeightMatch) {
        this.$store.dispatch('TOAST', { show: true, message: 'Harga untuk minimum tidak valid!' })
        return false
      }
      if (!parseInt(processedData.est_to)) {
        this.$store.dispatch('TOAST', { show: true, message: 'Estimasi waktu pengiriman belum diisi!' })
        return false
      }
      if (!confirm((parseInt(processedData.id) ? 'Update' : 'Simpan') + ' Data ?')) {
        return false
      }
      if (!parseInt(this.dialogShipping.data.price_id)) {
        const p = prompt('Menggunakan Custom Pricing, SVP Password :')
        if (!p) {
          return false
        } else {
          processedData.svp_pwd = p || 'x'
        }
      }

      if (this.isProjectBased.v) {
        if (parseInt(processedData.customer_billto) !== parseInt(this.dialogProject.data.customer)) {
          this.$store.dispatch('TOAST', { show: true, message: 'Customer bill dan pemilik project tidak sama!' })
          return false
        }
        processedData.sheets = this.isProjectBased.sheets
        const date = (processedData.initialTTK).replace(/^.*\D+/g, '')
        if (date && date.length === 6) {
          const newDate = new Date()
          newDate.setFullYear(parseInt('20' + date.substring(0, 2)))
          newDate.setMonth(parseInt(date.substring(2, 4)) - 1)
          newDate.setDate(parseInt(date.substring(4, 6)))
          processedData.created = newDate.toISOString()
        } else {
          this.$store.dispatch('TOAST', { show: true, message: 'Initial TTK tidak valid (KODE|00TAHUN|00BULAN|00TANGGAL)!' })
          return false
        }
      } else {
        this.isProjectBased.sheets = null
        this.isProjectBased.isError = []
        this.dialogShipping.data.project = 0
        this.dialogShipping.data.initialTTK = null
        delete processedData.initialTTK
      }

      const pricingFind = this.pricingData.find(r => parseInt(r.id) === parseInt(processedData.price_id))
      processedData.price_caption = !parseInt(processedData.price_id) ? 'Custom Price' : (pricingFind ? (pricingFind.notes || '-') : '')
      processedData.price_final = this.totalPrice
      this.dialogShipping.loading = true
      this.$store.dispatch(this.isProjectBased.v ? 'logistic/SHIPPING_PROCESS_BULK' : 'logistic/SHIPPING_PROCESS', processedData)
        .then((res) => {
          if (res.status) {
            if (res.data && res.data.data) {
              if (parseInt(res.data.data.id)) {
                this.SHIPPING_GET(this.tableSearch)
                this.dialogShipping.show = false
                this.$store.dispatch('TOAST', { show: true, message: processedData.id ? 'Berhasil diupdate!' : 'Berhasil disimpan!' })
              } else if (this.isProjectBased.v) {
                this.SHIPPING_GET(this.tableSearch)
                this.dialogShipping.show = false
                this.$store.dispatch('TOAST', { show: true, message: 'Berhasil diimport!' })
              }
            } else if (res.data && res.data.data && res.data.data.response && res.data.data.message) {
              this.$store.dispatch('TOAST', { show: true, message: res.data.data.message })
            } else {
              this.$store.dispatch('TOAST', { show: true, message: res.data.data.message })
            }
          } else {
            this.$store.dispatch('TOAST', { show: true, message: 'Terjadi kesalahan!' })
          }
          this.dialogShipping.loading = false
        })
    },
    GetDates (isManifest) {
      const fromTo = isManifest ? this.dialogManifest.dates : this.dates
      if (fromTo) {
        if (fromTo.length === 2) {
          if ((new Date(fromTo[0])).getTime() < (new Date(fromTo[1])).getTime()) {
            return '&from=' + fromTo[0] + '&to=' + fromTo[1]
          } else {
            return '&from=' + fromTo[1] + '&to=' + fromTo[0]
          }
        }
      }
      return ''
    }
  }
}
</script>

<style lang="scss">
.product-selected {
  &.v-card {
    &.v-sheet {
      &.v-sheet--outlined {
        background: rgba(193, 248, 193, 0.562);
      }
    }
  }
}
</style>
